/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';
export const HOST = "https://dev-financial-bff.solfacil.com.br/graphql"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type ScalarsSelector<T> = {
  [X in Required<{
    [P in keyof T]: T[P] extends number | string | undefined | boolean ? P : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([, value]) => {
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType || (typeof isReturnType === 'string' && isReturnType.startsWith('scalar.'))) {
          return true;
        }
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T]>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['ID']: unknown;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = GraphQLTypes["GenericFinancingStep"]
export type ScalarCoders = {
	Upload?: ScalarResolver;
	JSON?: ScalarResolver;
}
type ZEUS_UNIONS = never

export type ValueTypes = {
    ["Order"]:Order;
	/** The `Upload` scalar type represents a file upload. */
["Upload"]:unknown;
	["Combos"]: AliasType<{
	data?:ValueTypes["ComboData"],
		__typename?: boolean | `@${string}`
}>;
	["Cities"]: AliasType<{
	data?:ValueTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["AddressInstallation"]: AliasType<{
	data?:ValueTypes["AddressInstallationData"],
		__typename?: boolean | `@${string}`
}>;
	["ComboData"]: AliasType<{
	nationality?:ValueTypes["CityStateData"],
	gender?:ValueTypes["CityStateData"],
	occupation?:ValueTypes["CityStateData"],
	state?:ValueTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["CepAddress"]: AliasType<{
	neighborhood?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	state?:ValueTypes["CityStateData"],
	city?:ValueTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["AddressInstallationData"]: AliasType<{
	postal_code?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	additional_info?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	rural_area?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CityStateData"]: AliasType<{
	name?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
address_combos?: [{	nationality?: boolean | undefined | null | Variable<any, string>,	gender?: boolean | undefined | null | Variable<any, string>,	occupation?: boolean | undefined | null | Variable<any, string>,	state?: boolean | undefined | null | Variable<any, string>},ValueTypes["Combos"]],
address_cities?: [{	state_id: number | Variable<any, string>},ValueTypes["Cities"]],
address_from_cep?: [{	cep: string | Variable<any, string>},ValueTypes["CepAddress"]],
address_installation?: [{	project_id: string | Variable<any, string>},ValueTypes["AddressInstallation"]],
customer_form?: [{	project_id: string | Variable<any, string>},ValueTypes["CustomerFormResponse"]],
access_user_credentials?: [{	brand: string | Variable<any, string>},ValueTypes["AccessUserCredentialsResponse"]],
credentials_check?: [{	brand: string | Variable<any, string>},ValueTypes["CredentialsCheckResponse"]],
documents?: [{	project_id: string | Variable<any, string>},ValueTypes["DocumentResponse"]],
financing?: [{	id: string | Variable<any, string>},ValueTypes["Financing"]],
financingV2?: [{	id: string | Variable<any, string>},ValueTypes["FinancingV2"]],
financings?: [{	input: ValueTypes["FinancingsInput"] | Variable<any, string>},ValueTypes["FinancingsList"]],
financing_type?: [{	person_type: string | Variable<any, string>},ValueTypes["FinancingType"]],
formalization?: [{	projectId: string | Variable<any, string>},ValueTypes["FormalizationInfo"]],
formalization_biometry_confirm?: [{	projectId: string | Variable<any, string>},ValueTypes["ConfirmBiometryResponse"]],
formalization_v2?: [{	projectId: string | Variable<any, string>},ValueTypes["FormalizedFinancing"]],
formalization_metrics?: [{	window_days?: number | undefined | null | Variable<any, string>,	partner_id?: Array<string> | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	page_size?: number | undefined | null | Variable<any, string>},ValueTypes["FormalizationMetricsResponse"]],
targetIncentivesSummary?: [{	target_id: string | Variable<any, string>,	campaign_type: string | Variable<any, string>,	target_type: string | Variable<any, string>},ValueTypes["TargetIncentiveSummary"]],
getCommissioningStatus?: [{	installation_id: string | Variable<any, string>},ValueTypes["CommissioningStatusResponse"]],
installation?: [{	projectId: string | Variable<any, string>},ValueTypes["Installation"]],
mirrorStatus?: [{	projectId: string | Variable<any, string>},ValueTypes["MirrorStatus"]],
	inverter_brands?:ValueTypes["InverterBrands"],
available_orders?: [{	projectId: string | Variable<any, string>,	with_summary?: boolean | undefined | null | Variable<any, string>,	order_id?: number | undefined | null | Variable<any, string>,	page?: number | undefined | null | Variable<any, string>,	page_size?: number | undefined | null | Variable<any, string>},ValueTypes["AvailableOrders"]],
legacyFinancing?: [{	projectId: string | Variable<any, string>},ValueTypes["LegacyFinancing"]],
notifications?: [{	userId: number | Variable<any, string>,	cursor?: string | undefined | null | Variable<any, string>},ValueTypes["NotificationsList"]],
partner?: [{	partnerId: string | Variable<any, string>},ValueTypes["OnlyPartner"]],
partners?: [{	input?: ValueTypes["CoreGetPartnersInput"] | undefined | null | Variable<any, string>},ValueTypes["CorePartner"]],
payment_current_issuance_model?: [{	partnerId: string | Variable<any, string>},ValueTypes["PaymentCurrentIssuanceModel"]],
projects_partner_overview?: [{	partner_id: string | Variable<any, string>},ValueTypes["PartnerOverview"]],
project?: [{	projectId: string | Variable<any, string>},ValueTypes["Project"]],
project_proposal_changes?: [{	project_id: string | Variable<any, string>},ValueTypes["ProjectProposal"]],
project_is_combo?: [{	project_id: string | Variable<any, string>},ValueTypes["IsComboResponse"]],
	project_system_types?:boolean | `@${string}`,
registration?: [{	project_id: string | Variable<any, string>},ValueTypes["RegistrationDetailsResponse"]],
registration_grid_access_approval?: [{	project_id: string | Variable<any, string>,	city: string | Variable<any, string>,	state: string | Variable<any, string>},ValueTypes["RegistrationGridAccessApproval"]],
	risk_financing_revalidation_summary?:ValueTypes["RevalidationSummary"],
risk_financing_revalidations?: [{	input?: ValueTypes["RevalidationsInput"] | undefined | null | Variable<any, string>},ValueTypes["RevalidationsListResponse"]],
getOpportunities?: [{	params: ValueTypes["GetOpportunitiesInput"] | Variable<any, string>},ValueTypes["GetOpportunitiesResponse"]],
simulation_project_shopping_cart_id_get?: [{	projectId: string | Variable<any, string>},boolean | `@${string}`],
	user?:ValueTypes["User"],
wallet_payment_model?: [{	partner_id?: string | undefined | null | Variable<any, string>},ValueTypes["WalletPaymentModel"]],
		__typename?: boolean | `@${string}`
}>;
	["PersonTypes"]:PersonTypes;
	["DocumentTypes"]:DocumentTypes;
	["LegalRepresentantTypes"]:LegalRepresentantTypes;
	["CustomerStatus"]:CustomerStatus;
	["RegistrationContactChangeResponse"]: AliasType<{
	message?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerFormResponse"]: AliasType<{
	project_id?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	customer?:ValueTypes["CustomerData"],
	guarantor?:ValueTypes["CustomerData"],
	project?:ValueTypes["CustomerProject"],
	remaining_changes_after_confirmation?:boolean | `@${string}`,
	company?:ValueTypes["CompanyData"],
	errors?:ValueTypes["CustomerErrors"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerErrors"]: AliasType<{
	field?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocument"]: AliasType<{
	type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	url_download?:boolean | `@${string}`,
	url_preview?:boolean | `@${string}`,
	mime_type?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerAddress"]: AliasType<{
	zipcode?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city_id?:boolean | `@${string}`,
	state_id?:boolean | `@${string}`,
	city?:ValueTypes["CustomerIdName"],
	state?:ValueTypes["CustomerIdName"],
	is_rural?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerData"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["CustomerContact"],
	documents?:ValueTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ValueTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerEletricityBill"]: AliasType<{
	is_under_customer_name?:boolean | `@${string}`,
	holder_cpf?:boolean | `@${string}`,
	distributor_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerProject"]: AliasType<{
	address?:ValueTypes["CustomerAddress"],
	documents?:ValueTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	electricity_bill?:ValueTypes["CustomerEletricityBill"],
	residencial_is_the_same_of_plant?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyMajorityPartner"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["CustomerContact"],
	documents?:ValueTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ValueTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CompanyLegalRepresentant"]: AliasType<{
	kind?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["CustomerContact"],
	documents?:ValueTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ValueTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CompanyData"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	contact?:ValueTypes["CustomerContact"],
	documents?:ValueTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	majority_partner?:ValueTypes["CompanyMajorityPartner"],
	majority_partner_is_legal_representative?:boolean | `@${string}`,
	is_only_one_legal_representative?:boolean | `@${string}`,
	legal_representatives?:ValueTypes["CompanyLegalRepresentant"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationV2PersonType"]:RegistrationV2PersonType;
	["CustomerIdName"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationAddress"]: {
	zipcode: string | Variable<any, string>,
	street: string | Variable<any, string>,
	street_number: string | Variable<any, string>,
	complement?: string | undefined | null | Variable<any, string>,
	neighborhood: string | Variable<any, string>,
	city_id: number | Variable<any, string>,
	state_id: number | Variable<any, string>,
	is_rural?: boolean | undefined | null | Variable<any, string>
};
	["CustomerRegistrationContact"]: {
	email: string | Variable<any, string>,
	phone: string | Variable<any, string>
};
	["CustomerRegistrationDocument"]: {
	type: string | Variable<any, string>,
	docstorage_id: string | Variable<any, string>
};
	["CustomerRegistrationCustomer"]: {
	full_name: string | Variable<any, string>,
	birthdate: string | Variable<any, string>,
	contact: ValueTypes["CustomerRegistrationContact"] | Variable<any, string>,
	documents: Array<ValueTypes["CustomerRegistrationDocument"]> | Variable<any, string>,
	address: ValueTypes["CustomerRegistrationAddress"] | Variable<any, string>
};
	["CustomerRegistrationGuarantor"]: {
	full_name: string | Variable<any, string>,
	birthdate: string | Variable<any, string>,
	contact: ValueTypes["CustomerRegistrationContact"] | Variable<any, string>,
	documents: Array<ValueTypes["CustomerRegistrationDocument"]> | Variable<any, string>,
	address: ValueTypes["CustomerRegistrationAddress"] | Variable<any, string>
};
	["CustomerRegistrationElectricityBill"]: {
	is_under_customer_name: boolean | Variable<any, string>,
	holder_cpf?: string | undefined | null | Variable<any, string>,
	distributor_id?: number | undefined | null | Variable<any, string>
};
	["CustomerRegistrationElectricityBillWithDocuments"]: {
	electricity_bill_docstorage_id: string | Variable<any, string>,
	employment_proof_docstorage_id?: string | undefined | null | Variable<any, string>,
	additional_document_docstorage_id?: string | undefined | null | Variable<any, string>,
	holder_cpf?: string | undefined | null | Variable<any, string>,
	is_under_customer_name: boolean | Variable<any, string>
};
	["CustomerRegistrationProject"]: {
	address: ValueTypes["CustomerRegistrationAddress"] | Variable<any, string>,
	documents: Array<ValueTypes["CustomerRegistrationDocument"]> | Variable<any, string>,
	comment?: string | undefined | null | Variable<any, string>,
	electricity_bill: ValueTypes["CustomerRegistrationElectricityBill"] | Variable<any, string>,
	electricity_bills?: Array<ValueTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined | null | Variable<any, string>
};
	["CustomerRegistrationCompany"]: {
	company_name: string | Variable<any, string>,
	contact: ValueTypes["CustomerRegistrationContact"] | Variable<any, string>,
	documents: Array<ValueTypes["CustomerRegistrationDocument"]> | Variable<any, string>,
	majority_partner: ValueTypes["CustomerRegistrationCustomer"] | Variable<any, string>,
	legal_representatives: Array<ValueTypes["CustomerRegistrationLegalRepresentative"]> | Variable<any, string>
};
	["CustomerRegistrationLegalRepresentative"]: {
	kind: string | Variable<any, string>,
	cpf: string | Variable<any, string>,
	full_name: string | Variable<any, string>,
	birthdate: string | Variable<any, string>,
	contact: ValueTypes["CustomerRegistrationContact"] | Variable<any, string>,
	documents: Array<ValueTypes["CustomerRegistrationDocument"]> | Variable<any, string>,
	address: ValueTypes["CustomerRegistrationAddress"] | Variable<any, string>
};
	["CustomerRegistrationInput"]: {
	project_id: string | Variable<any, string>,
	person_type: ValueTypes["RegistrationV2PersonType"] | Variable<any, string>,
	customer?: ValueTypes["CustomerRegistrationCustomer"] | undefined | null | Variable<any, string>,
	guarantor?: ValueTypes["CustomerRegistrationGuarantor"] | undefined | null | Variable<any, string>,
	project?: ValueTypes["CustomerRegistrationProject"] | undefined | null | Variable<any, string>,
	company?: ValueTypes["CustomerRegistrationCompany"] | undefined | null | Variable<any, string>,
	electricity_bills?: Array<ValueTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined | null | Variable<any, string>
};
	["Person"]: {
	email?: string | undefined | null | Variable<any, string>,
	partner_id: string | Variable<any, string>,
	phone?: string | undefined | null | Variable<any, string>
};
	["CustomerDocumentUpload"]: AliasType<{
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	url_inline?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	mimetype?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationError"]: AliasType<{
	field?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationV2Response"]: AliasType<{
	errors?:ValueTypes["CustomerRegistrationError"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocumentFormAnalysis"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	installation_document_matches_bill?:boolean | `@${string}`,
	installation_address_matches_bill?:boolean | `@${string}`,
	identity_matches_document?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	comments?:boolean | `@${string}`,
	documents?:ValueTypes["CustomerDocumentUpload"],
		__typename?: boolean | `@${string}`
}>;
	["PersonInput"]: {
	email: string | Variable<any, string>,
	phone: string | Variable<any, string>
};
	["RegistrationContactChangeInput"]: {
	project_id: string | Variable<any, string>,
	customer?: ValueTypes["PersonInput"] | undefined | null | Variable<any, string>,
	guarantor?: ValueTypes["PersonInput"] | undefined | null | Variable<any, string>,
	majority_partner?: ValueTypes["PersonInput"] | undefined | null | Variable<any, string>,
	legal_representative_1?: ValueTypes["PersonInput"] | undefined | null | Variable<any, string>,
	legal_representative_2?: ValueTypes["PersonInput"] | undefined | null | Variable<any, string>
};
	["Mutation"]: AliasType<{
registration_contact_change?: [{	input: ValueTypes["RegistrationContactChangeInput"] | Variable<any, string>},ValueTypes["RegistrationContactChangeResponse"]],
customer_document_upload?: [{	documents: Array<ValueTypes["Upload"]> | Variable<any, string>},ValueTypes["CustomerDocumentUpload"]],
customer_document_form_analysis_cancel?: [{	project_id: string | Variable<any, string>,	step: string | Variable<any, string>},ValueTypes["CustomerDocumentFormAnalysis"]],
customer_registration?: [{	params: ValueTypes["CustomerRegistrationInput"] | Variable<any, string>},ValueTypes["CustomerRegistrationV2Response"]],
register_device_orchestrator_gateway_credential?: [{	input: ValueTypes["RegisterDeviceOrchestratorGatewayCredentialInput"] | Variable<any, string>},ValueTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"]],
device_orchestrator_credentials_change?: [{	brand: string | Variable<any, string>,	password: string | Variable<any, string>},ValueTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"]],
formalization_term_combo_connect_resend?: [{	projectId: string | Variable<any, string>},ValueTypes["TermComboConnectResponse"]],
validateHardwareForm?: [{	hardwareFormInput: ValueTypes["HardwareFormInput"] | Variable<any, string>},ValueTypes["HardwareFormValidation"]],
hardware_form_showcase?: [{	hardwareFormShowcaseInput: ValueTypes["HardwareFormShowcaseInput"] | Variable<any, string>},ValueTypes["HardwareFormShowcaseResponse"]],
hardware_form_draft?: [{	hardwareFormDraftInput: ValueTypes["HardwareDraft"] | Variable<any, string>},boolean | `@${string}`],
installation_mirror_upload?: [{	projectId: string | Variable<any, string>,	mirror: ValueTypes["Upload"] | Variable<any, string>},ValueTypes["MirrorUploadResponse"]],
installation_inverter_labels_upload?: [{	installationId: string | Variable<any, string>,	inverterLabel: ValueTypes["Upload"] | Variable<any, string>,	dataloggerLabel?: ValueTypes["Upload"] | undefined | null | Variable<any, string>},ValueTypes["UploadInstallationLabelsResponse"]],
installation_power_inverters_validate?: [{	input: ValueTypes["ValidateTotalInvertersPowerInput"] | Variable<any, string>},ValueTypes["ValidateTotalInvertersPowerResponse"]],
installation_section_delete?: [{	installation_id: string | Variable<any, string>},boolean | `@${string}`],
installation_section_document_delete?: [{	installation_id: string | Variable<any, string>,	section_id: string | Variable<any, string>,	document_id: string | Variable<any, string>},boolean | `@${string}`],
installation_customer_reproval?: [{	input: ValueTypes["CustomerReprovalInput"] | Variable<any, string>},boolean | `@${string}`],
installation_installed_inverter_create?: [{	project_id: string | Variable<any, string>,	installation_id: string | Variable<any, string>,	input: ValueTypes["CreateInstalledInverterInput"] | Variable<any, string>},ValueTypes["CreatedInstalledInverter"]],
installation_installed_inverter_create_with_brand?: [{	installation_id: string | Variable<any, string>,	input: ValueTypes["CreateInstalledInverterWithBrandInput"] | Variable<any, string>},ValueTypes["CreatedInstalledInverter"]],
installation_commissioning_check?: [{	formalization_date?: string | undefined | null | Variable<any, string>,	installation_id: string | Variable<any, string>,	plant_name?: string | undefined | null | Variable<any, string>,	platforms: Array<string> | Variable<any, string>},ValueTypes["CommissioningCheckResponse"]],
installation_commissioning_request?: [{	input: ValueTypes["CommissioningRequestInput"] | Variable<any, string>},ValueTypes["CommissioningRequestResponse"]],
installation_commissioning_reset_customer_rejection?: [{	project_id: string | Variable<any, string>},ValueTypes["CommissioningResetResponse"]],
installation_biometric_validation?: [{	input: ValueTypes["BiometricValidationInput"] | Variable<any, string>},ValueTypes["BiometricValidationResponse"]],
markNotificationsRead?: [{	userId: number | Variable<any, string>},boolean | `@${string}`],
markNotificationClicked?: [{	notificationId: number | Variable<any, string>},boolean | `@${string}`],
project_update_shopping_cart?: [{	project_id: string | Variable<any, string>,	shopping_cart_id: string | Variable<any, string>},boolean | `@${string}`],
project_proposal_update?: [{	project_id: string | Variable<any, string>,	payload: ValueTypes["ProjectProposalUpdatePayloadInput"] | Variable<any, string>},boolean | `@${string}`],
project_create?: [{	input: ValueTypes["ProjectCreateInput"] | Variable<any, string>},ValueTypes["ProjectCreateResponse"]],
registration?: [{	params: ValueTypes["RegistrationUpdateInput"] | Variable<any, string>},boolean | `@${string}`],
risk_financing_register_credential?: [{	input: ValueTypes["RegisterRevalidationCredentialInput"] | Variable<any, string>},ValueTypes["RegisterRevalidationCredentialResponse"]],
risk_financing_submit_revalidations?: [{	input: ValueTypes["SubmitRevalidationsInput"] | Variable<any, string>},ValueTypes["SubmitRevalidationsResponse"]],
processEnergyAccountAnalysis?: [{	params: ValueTypes["AnalyzeEnergyBillInput"] | Variable<any, string>},ValueTypes["EnergyBillAnalysisDecision"]],
		__typename?: boolean | `@${string}`
}>;
	/** Arbitrary JSON value */
["JSON"]:unknown;
	["DeviceOrchestratorGatewayCredentialErrorCode"]:DeviceOrchestratorGatewayCredentialErrorCode;
	["RegisterDeviceOrchestratorGatewayCredentialResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegisterDeviceOrchestratorGatewayCredentialInput"]: {
	brand: string | Variable<any, string>,
	username: string | Variable<any, string>,
	password: string | Variable<any, string>
};
	["AccessUserCredentialsData"]: AliasType<{
	access_user?:boolean | `@${string}`,
	platform?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccessUserCredentialsResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ValueTypes["AccessUserCredentialsData"],
		__typename?: boolean | `@${string}`
}>;
	["CredentialsCheckResponse"]: AliasType<{
	has_credentials?:boolean | `@${string}`,
	is_valid?:boolean | `@${string}`,
	access_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentResponse"]: AliasType<{
	data?:ValueTypes["DocumentData"],
		__typename?: boolean | `@${string}`
}>;
	["DocumentData"]: AliasType<{
	project?:ValueTypes["Documents"],
	customer?:ValueTypes["Documents"],
	guarantor?:ValueTypes["DocumentFile"],
	company?:ValueTypes["DocumentFile"],
		__typename?: boolean | `@${string}`
}>;
	["Documents"]: AliasType<{
	id?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	validated_at?:boolean | `@${string}`,
	validation_mode?:boolean | `@${string}`,
	deleted_at?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	canceled_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	reason?:ValueTypes["DocumentReason"],
	file?:ValueTypes["DocumentFile"],
		__typename?: boolean | `@${string}`
}>;
	["DocumentFile"]: AliasType<{
	public_id?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	mimetype?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	url_inline?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentReason"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PersonType"]:PersonType;
	["FinancingStatus"]:FinancingStatus;
	["FinancingSteps"]:FinancingSteps;
	["StatusList"]:StatusList;
	["FinancingV2"]: AliasType<{
	id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	financed_value?:boolean | `@${string}`,
	customer_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
	payments?:ValueTypes["Payment"],
	flow_provider?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	all_payments_sent?:boolean | `@${string}`,
	section_statuses?:ValueTypes["FinancingSectionStatusesV2"],
	updated_at?:boolean | `@${string}`,
	is_expired?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	system_type?:boolean | `@${string}`,
	inverters_power_kw?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	openable_steps?:ValueTypes["FormalizationStatuses"],
	is_aproved?:boolean | `@${string}`,
	is_final?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingSectionStatusesV2"]: AliasType<{
	simulation?:ValueTypes["FinancingStep"],
	installation?:ValueTypes["FinancingStep"],
	customer_data?:ValueTypes["FinancingStep"],
	equipment?:ValueTypes["FinancingStep"],
	biometry_and_contract?:ValueTypes["BiometryAndContractStep"],
	payment_model?:ValueTypes["FinancingStep"],
		__typename?: boolean | `@${string}`
}>;
	["GenericFinancingStep"]:AliasType<{
		completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`;
		['...on FinancingStep']?: Omit<ValueTypes["FinancingStep"],keyof ValueTypes["GenericFinancingStep"]>;
		['...on BiometryAndContractStep']?: Omit<ValueTypes["BiometryAndContractStep"],keyof ValueTypes["GenericFinancingStep"]>;
		__typename?: boolean | `@${string}`
}>;
	["FinancingStep"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MetadataItem"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	first_submitted_at?:boolean | `@${string}`,
	last_submitted_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BiometryAndContractMetadata"]: AliasType<{
	biometry?:ValueTypes["MetadataItem"],
	contract?:ValueTypes["MetadataItem"],
	term?:ValueTypes["MetadataItem"],
		__typename?: boolean | `@${string}`
}>;
	["BiometryAndContractStep"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	metadata?:ValueTypes["BiometryAndContractMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["Payment"]: AliasType<{
	id?:boolean | `@${string}`,
	financing_id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	total_value?:boolean | `@${string}`,
	payment_percentage?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Financing"]: AliasType<{
	id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	financed_value?:boolean | `@${string}`,
	project_value?:boolean | `@${string}`,
	customer_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
	payments?:ValueTypes["Payment"],
	flow_provider?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	all_payments_sent?:boolean | `@${string}`,
	section_statuses?:ValueTypes["FinancingSectionStatus"],
	updated_at?:boolean | `@${string}`,
	is_expired?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	openable_steps?:ValueTypes["FormalizationStatuses"],
	is_aproved?:boolean | `@${string}`,
	is_final?:boolean | `@${string}`,
	loan_value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationStatuses"]: AliasType<{
	hardware?:boolean | `@${string}`,
	registration?:boolean | `@${string}`,
	documentation?:boolean | `@${string}`,
	contract?:boolean | `@${string}`,
	receiptModel?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingProposal"]: AliasType<{
	customer_data?:boolean | `@${string}`,
	equipment?:boolean | `@${string}`,
	biometry_and_contract?:boolean | `@${string}`,
	payment_model?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingFormalization"]: AliasType<{
	contract?:boolean | `@${string}`,
	hardware?:boolean | `@${string}`,
	registration?:boolean | `@${string}`,
	documentation?:boolean | `@${string}`,
	receipt_model?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingSectionStatus"]: AliasType<{
	concluded?:boolean | `@${string}`,
	simulation?:boolean | `@${string}`,
	installation?:boolean | `@${string}`,
	proposal?:ValueTypes["FinancingProposal"],
	formalization?:ValueTypes["FinancingFormalization"],
		__typename?: boolean | `@${string}`
}>;
	["FinancingsList"]: AliasType<{
	data?:ValueTypes["Financing"],
	has_next?:boolean | `@${string}`,
	statuses?:boolean | `@${string}`,
	all_steps?:ValueTypes["Item"],
		__typename?: boolean | `@${string}`
}>;
	["Item"]: AliasType<{
	name?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingsInput"]: {
	formalized_gte?: number | undefined | null | Variable<any, string>,
	formalized_lte?: number | undefined | null | Variable<any, string>,
	is_canceled?: boolean | undefined | null | Variable<any, string>,
	is_combo?: string | undefined | null | Variable<any, string>,
	is_combo_connect?: boolean | undefined | null | Variable<any, string>,
	is_expired?: boolean | undefined | null | Variable<any, string>,
	is_installed?: boolean | undefined | null | Variable<any, string>,
	order_by?: string | undefined | null | Variable<any, string>,
	page?: number | undefined | null | Variable<any, string>,
	page_size?: number | undefined | null | Variable<any, string>,
	partner_id?: string | undefined | null | Variable<any, string>,
	provider?: string | undefined | null | Variable<any, string>,
	query?: string | undefined | null | Variable<any, string>,
	status?: Array<ValueTypes["FinancingStatus"]> | undefined | null | Variable<any, string>,
	steps?: Array<ValueTypes["FinancingSteps"]> | undefined | null | Variable<any, string>
};
	["FinancingType"]: AliasType<{
	max_financing_value?:boolean | `@${string}`,
	min_financing_value?:boolean | `@${string}`,
	max_financing_installments?:boolean | `@${string}`,
	grace_period_financing?:ValueTypes["GracePeriod"],
	max_bnpl_value?:boolean | `@${string}`,
	max_bnpl_installments?:boolean | `@${string}`,
	grace_period_bnpl?:ValueTypes["GracePeriod"],
		__typename?: boolean | `@${string}`
}>;
	["GracePeriod"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationInfo"]: AliasType<{
	approval?:boolean | `@${string}`,
	biometry?:ValueTypes["Biometry"],
	cancel?:boolean | `@${string}`,
	contract?:ValueTypes["Contract"],
	cancellation_type?:boolean | `@${string}`,
	contracts?:ValueTypes["FormalizationContracts"],
	term?:ValueTypes["Term"],
	download?:ValueTypes["Download"],
	order_id?:boolean | `@${string}`,
	pendencies?:ValueTypes["Pendencies"],
	remaining_contract_days_until_expiration?:boolean | `@${string}`,
	resend?:boolean | `@${string}`,
	send_biometry_contract?:ValueTypes["SendBiometryContract"],
	status?:boolean | `@${string}`,
	status_reason?:ValueTypes["FormalizationStatusReason"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationStatusReason"]: AliasType<{
	code?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Biometry"]: AliasType<{
	pending?:boolean | `@${string}`,
	signers?:ValueTypes["Signer"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Contract"]: AliasType<{
	has_biometric?:boolean | `@${string}`,
	signers?:ValueTypes["ContractSigner"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationContractSection"]: AliasType<{
	status?:boolean | `@${string}`,
	document_signed?:boolean | `@${string}`,
	signers?:ValueTypes["ContractSigner"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationContracts"]: AliasType<{
	financing_amendment_term?:ValueTypes["FormalizationContractSection"],
	loan?:ValueTypes["FormalizationContractSection"],
	lender_insurance?:ValueTypes["FormalizationContractSection"],
	diverse_risks_insurance?:ValueTypes["FormalizationContractSection"],
	combo_connect_term?:ValueTypes["FormalizationContractSection"],
		__typename?: boolean | `@${string}`
}>;
	["Term"]: AliasType<{
	signers?:ValueTypes["ContractSigner"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Signer"]: AliasType<{
	name?:boolean | `@${string}`,
	checked?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ContractSigner"]: AliasType<{
	name?:boolean | `@${string}`,
	checked?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Download"]: AliasType<{
	contract?:boolean | `@${string}`,
	insurance?:boolean | `@${string}`,
	term?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Pendencies"]: AliasType<{
	expired_at?:boolean | `@${string}`,
	items?:ValueTypes["PendencyItem"],
		__typename?: boolean | `@${string}`
}>;
	["PendencyItem"]: AliasType<{
	category?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SendBiometryContract"]: AliasType<{
	message?:ValueTypes["BiometryMessage"],
	method_receipt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BiometryMessage"]: AliasType<{
	days?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConfirmBiometryResponse"]: AliasType<{
	is_done?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TermComboConnectResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancing"]: AliasType<{
	id?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	partner_commission_percent?:boolean | `@${string}`,
	financing_line?:boolean | `@${string}`,
	company?:ValueTypes["FormalizedFinancingCompany"],
	customer?:ValueTypes["FormalizedFinancingCustomer"],
	guarantor?:ValueTypes["FormalizedFinancingGuarantor"],
	legal_representatives?:ValueTypes["FormalizedFinancingLegalRepresentative"],
	majority_partner?:ValueTypes["FormalizedFinancingMajorityPartner"],
	proposal?:ValueTypes["FormalizedFinancingProposal"],
	contract?:ValueTypes["FormalizedFinancingContract"],
	partner?:ValueTypes["FormalizedFinancingPartner"],
	securitization?:ValueTypes["FormalizedFinancingSecuritization"],
	funding?:boolean | `@${string}`,
	project?:ValueTypes["FormalizedFinancingProject"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomer"]: AliasType<{
	address?:ValueTypes["FormalizedFinancingCustomerAddress"],
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["FormalizedFinancingCustomerContact"],
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomerAddress"]: AliasType<{
	city?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	zipcode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomerContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingContract"]: AliasType<{
	banking?:boolean | `@${string}`,
	ccb_number?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	generate_date?:boolean | `@${string}`,
	signed_date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingPartner"]: AliasType<{
	id?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	company_name?:boolean | `@${string}`,
	payment_institution?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingProposal"]: AliasType<{
	installments_number?:boolean | `@${string}`,
	rate_type?:boolean | `@${string}`,
	installment_amount?:boolean | `@${string}`,
	gross_amount?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	registration_fee?:boolean | `@${string}`,
	interest_fee?:boolean | `@${string}`,
	iof?:boolean | `@${string}`,
	ipca_type?:boolean | `@${string}`,
	cet?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingSecuritization"]: AliasType<{
	cnpj?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingProject"]: AliasType<{
	electrical_phase?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	inverter_type?:boolean | `@${string}`,
	inverters?:ValueTypes["FormalizedFinancingInverter"],
	modules?:ValueTypes["FormalizedFinancingModule"],
	total_powers?:ValueTypes["FormalizedFinancingTotalPowers"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingInverter"]: AliasType<{
	brand?:boolean | `@${string}`,
	contactor_switch?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	phase?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	voltage?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingModule"]: AliasType<{
	brand?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	phase?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	voltage?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingTotalPowers"]: AliasType<{
	system?:boolean | `@${string}`,
	modules?:boolean | `@${string}`,
	inverters?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCompany"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingGuarantor"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingMajorityPartner"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	percentage?:boolean | `@${string}`,
	contact?:ValueTypes["FormalizedFinancingCustomerContact"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingLegalRepresentative"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationBucket"]: AliasType<{
	amount?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
	pct?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationBuckets"]: AliasType<{
	lte_45?:ValueTypes["FormalizationBucket"],
	d46_60?:ValueTypes["FormalizationBucket"],
	d61_90?:ValueTypes["FormalizationBucket"],
	gt_90?:ValueTypes["FormalizationBucket"],
	lte_60?:ValueTypes["FormalizationBucket"],
	lte_90?:ValueTypes["FormalizationBucket"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationIntegratorMetrics"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	partner_name?:boolean | `@${string}`,
	total_formalized?:boolean | `@${string}`,
	total_formalized_in_window?:boolean | `@${string}`,
	total_installed?:boolean | `@${string}`,
	total_installed_in_window?:boolean | `@${string}`,
	buckets?:ValueTypes["FormalizationBuckets"],
	buckets_pending?:ValueTypes["FormalizationBuckets"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationMetricsResponse"]: AliasType<{
	window_days?:boolean | `@${string}`,
	items?:ValueTypes["FormalizationIntegratorMetrics"],
	has_next?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Incentive"]: AliasType<{
	title_ptbr?:boolean | `@${string}`,
	description_ptbr?:boolean | `@${string}`,
	banner_url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TargetIncentiveSummary"]: AliasType<{
	campaign_id?:boolean | `@${string}`,
	incentive?:ValueTypes["Incentive"],
		__typename?: boolean | `@${string}`
}>;
	["FileStatusType"]:FileStatusType;
	["DocumentStatusType"]:DocumentStatusType;
	["TypeSection"]:TypeSection;
	["MirrorStatuses"]:MirrorStatuses;
	["Status"]: AliasType<{
	description?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Document"]: AliasType<{
	filename?:boolean | `@${string}`,
	filetype?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:ValueTypes["Status"],
	type?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Section"]: AliasType<{
	documents?:ValueTypes["Document"],
	id?:boolean | `@${string}`,
	status?:ValueTypes["Status"],
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstallationStatus"]: AliasType<{
	description?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Installation"]: AliasType<{
	comment?:boolean | `@${string}`,
	concluded_at?:boolean | `@${string}`,
	grade?:boolean | `@${string}`,
	has_ampera?:boolean | `@${string}`,
	has_ampera_activated?:boolean | `@${string}`,
	has_minimal_projects?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	plant_id?:boolean | `@${string}`,
	plant_url?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	sections?:ValueTypes["Section"],
	status?:ValueTypes["InstallationStatus"],
	installed_inverters?:ValueTypes["InstalledInverters"],
	stage?:boolean | `@${string}`,
	stage_updated_at?:boolean | `@${string}`,
	stage_error?:boolean | `@${string}`,
	stage_customer_phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormInverter"]: {
	id: number | Variable<any, string>,
	quantity: number | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>
};
	["HardwareFormModule"]: {
	id: number | Variable<any, string>,
	quantity: number | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>
};
	["HardwareFormComboEquipment"]: {
	sku: string | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>,
	quantity: number | Variable<any, string>
};
	["HardwareFormBatteries"]: {
	id: number | Variable<any, string>,
	quantity: number | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>
};
	["HardwareFormComboMetadata"]: {
	project_id: string | Variable<any, string>,
	sku?: string | undefined | null | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>,
	price?: number | undefined | null | Variable<any, string>,
	inverters: Array<ValueTypes["HardwareFormComboEquipment"]> | Variable<any, string>,
	modules: Array<ValueTypes["HardwareFormComboEquipment"]> | Variable<any, string>
};
	["HardwareFormInput"]: {
	is_combo: boolean | Variable<any, string>,
	id?: string | undefined | null | Variable<any, string>,
	combo_price?: number | undefined | null | Variable<any, string>,
	inverter_type?: string | undefined | null | Variable<any, string>,
	project_id: string | Variable<any, string>,
	distributor_id: number | Variable<any, string>,
	phase_id: number | Variable<any, string>,
	inverters: Array<ValueTypes["HardwareFormInverter"]> | Variable<any, string>,
	modules: Array<ValueTypes["HardwareFormModule"]> | Variable<any, string>,
	batteries?: Array<ValueTypes["HardwareFormBatteries"]> | undefined | null | Variable<any, string>,
	combo_metadata?: ValueTypes["HardwareFormComboMetadata"] | undefined | null | Variable<any, string>,
	is_showcase?: boolean | undefined | null | Variable<any, string>,
	shopping_cart_id?: string | undefined | null | Variable<any, string>
};
	["HardwareFormShowcaseInput"]: {
	price?: number | undefined | null | Variable<any, string>,
	project_id: string | Variable<any, string>,
	inverters: Array<ValueTypes["HardwareFormInverter"]> | Variable<any, string>,
	modules: Array<ValueTypes["HardwareFormModule"]> | Variable<any, string>,
	shopping_cart_id?: string | undefined | null | Variable<any, string>
};
	["ValidateTotalInvertersPowerInput"]: {
	project_id: string | Variable<any, string>,
	total_inverters_power_kw: number | Variable<any, string>
};
	["CustomerReprovalInput"]: {
	validation_message_id: string | Variable<any, string>
};
	["BiometricValidationInput"]: {
	project_id: string | Variable<any, string>
};
	["BiometricValidationStatus"]:BiometricValidationStatus;
	["BiometricValidationReason"]:BiometricValidationReason;
	["BiometricValidationResponse"]: AliasType<{
	reason?:boolean | `@${string}`,
	retry_after_seconds?:boolean | `@${string}`,
	retry_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateTotalInvertersPowerResponse"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	error?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormPricePerWatt"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormSystemPower"]: AliasType<{
	is_valid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormModules"]: AliasType<{
	price_per_watt?:ValueTypes["ValidateHardwareFormPricePerWatt"],
	system_power?:ValueTypes["ValidateHardwareFormSystemPower"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormOverload"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormInverters"]: AliasType<{
	overload?:ValueTypes["ValidateHardwareFormOverload"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormCapacity"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormBatteries"]: AliasType<{
	capacity?:ValueTypes["ValidateHardwareFormCapacity"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormHardware"]: AliasType<{
	modules?:ValueTypes["ValidateHardwareFormModules"],
	inverters?:ValueTypes["ValidateHardwareFormInverters"],
	batteries?:ValueTypes["ValidateHardwareFormBatteries"],
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormValidation"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	hardware?:ValueTypes["ValidateHardwareFormHardware"],
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormShowcaseResponse"]: AliasType<{
	overload_is_valid?:boolean | `@${string}`,
	price_per_watt_is_valid?:boolean | `@${string}`,
	percentage_of_service_with_combo_is_valid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MirrorStatus"]: AliasType<{
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MirrorUploadResponse"]: AliasType<{
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardwareDraftEquipment"]: {
	sku: string | Variable<any, string>,
	quantity: number | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>,
	model: string | Variable<any, string>,
	brand: string | Variable<any, string>
};
	["HardwareDraft"]: {
	project_id: string | Variable<any, string>,
	sku?: string | undefined | null | Variable<any, string>,
	power?: number | undefined | null | Variable<any, string>,
	price?: number | undefined | null | Variable<any, string>,
	inverters: Array<ValueTypes["HardwareDraftEquipment"]> | Variable<any, string>,
	modules: Array<ValueTypes["HardwareDraftEquipment"]> | Variable<any, string>
};
	["CreateInstalledInverterInput"]: {
	model?: string | undefined | null | Variable<any, string>,
	power_kw: number | Variable<any, string>,
	serial_number: string | Variable<any, string>
};
	["CreateInstalledInverterWithBrandInput"]: {
	brand: string | Variable<any, string>,
	model?: string | undefined | null | Variable<any, string>,
	power_kw: number | Variable<any, string>,
	serial_number: string | Variable<any, string>
};
	["CreatedInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	installation_id?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	entry_mode?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadInstallationLabelsResponse"]: AliasType<{
	inverter_label_file?:boolean | `@${string}`,
	inverter_label_file_url?:boolean | `@${string}`,
	datalogger_label_file?:boolean | `@${string}`,
	datalogger_label_file_url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstalledInverterGlobalStatus"]:InstalledInverterGlobalStatus;
	["InstalledInverterStatus"]:InstalledInverterStatus;
	["InstalledInverters"]: AliasType<{
	status?:boolean | `@${string}`,
	inverters?:ValueTypes["InstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["InstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	datalogger_serial_number?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	entry_mode?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	updated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningCheckStatus"]:CommissioningCheckStatus;
	["CommissioningMonitoringStatus"]:CommissioningMonitoringStatus;
	["CommissioningFailureReason"]:CommissioningFailureReason;
	["CommissioningCheckResponse"]: AliasType<{
	checked_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	access_user?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InverterBrands"]: AliasType<{
	brands?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitItemCategory"]: AliasType<{
	id?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitItem"]: AliasType<{
	item_id?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	category?:ValueTypes["AvailableOrderKitItemCategory"],
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitChannel"]: AliasType<{
	channel?:boolean | `@${string}`,
	source?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitCustomer"]: AliasType<{
	type?:boolean | `@${string}`,
	document_number?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	billing_type?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	ibge_code?:boolean | `@${string}`,
	zip_code?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitShipping"]: AliasType<{
	freight_type?:boolean | `@${string}`,
	freight_value?:boolean | `@${string}`,
	recipient_name?:boolean | `@${string}`,
	recipient_phone?:boolean | `@${string}`,
	recipient_email?:boolean | `@${string}`,
	rural_zone?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	ibge_code?:boolean | `@${string}`,
	zip_code?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitUser"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	partner_cnpj?:boolean | `@${string}`,
	user_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitPayment"]: AliasType<{
	origin?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKit"]: AliasType<{
	error?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	order_number?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	cart_id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	region?:boolean | `@${string}`,
	dc_id?:boolean | `@${string}`,
	reservation_id?:boolean | `@${string}`,
	raw_value?:boolean | `@${string}`,
	total_value?:boolean | `@${string}`,
	items?:ValueTypes["AvailableOrderKitItem"],
	channel?:ValueTypes["AvailableOrderKitChannel"],
	customer?:ValueTypes["AvailableOrderKitCustomer"],
	shipping?:ValueTypes["AvailableOrderKitShipping"],
	user?:ValueTypes["AvailableOrderKitUser"],
	payment?:ValueTypes["AvailableOrderKitPayment"],
	status?:boolean | `@${string}`,
	erp_code?:boolean | `@${string}`,
	erp_branch?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrder"]: AliasType<{
	order_id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	expire_at?:boolean | `@${string}`,
	kit?:ValueTypes["AvailableOrderKit"],
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrdersPagination"]: AliasType<{
	page?:boolean | `@${string}`,
	page_size?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
	has_next?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrders"]: AliasType<{
	data?:ValueTypes["AvailableOrder"],
	pagination?:ValueTypes["AvailableOrdersPagination"],
		__typename?: boolean | `@${string}`
}>;
	["MonitoringInput"]: {
	brand: string | Variable<any, string>,
	expected_plant_name?: string | undefined | null | Variable<any, string>,
	inverters: Array<string> | Variable<any, string>
};
	["CommissioningRequestInput"]: {
	installation_id: string | Variable<any, string>,
	total_power_kw: number | Variable<any, string>,
	monitorings: Array<ValueTypes["MonitoringInput"]> | Variable<any, string>
};
	["CommissioningInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningMonitoring"]: AliasType<{
	id?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	installed_inverters?:ValueTypes["CommissioningInstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningRequestData"]: AliasType<{
	installation_id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	monitorings?:ValueTypes["CommissioningMonitoring"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningRequestResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ValueTypes["CommissioningRequestData"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningResetData"]: AliasType<{
	project_id?:boolean | `@${string}`,
	installation_id?:boolean | `@${string}`,
	removed_monitorings?:boolean | `@${string}`,
	removed_inverters?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningResetResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ValueTypes["CommissioningResetData"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusMonitoring"]: AliasType<{
	brand?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	plant_name?:boolean | `@${string}`,
	commissioning_failure_reason?:boolean | `@${string}`,
	installed_inverters?:ValueTypes["CommissioningStatusInstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningInstallationStatus"]:CommissioningInstallationStatus;
	["CommissioningStatusCustomerValidationRequest"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	attempt_number?:boolean | `@${string}`,
	initiated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusData"]: AliasType<{
	installation_id?:boolean | `@${string}`,
	installation_status?:boolean | `@${string}`,
	access_user?:boolean | `@${string}`,
	monitorings?:ValueTypes["CommissioningStatusMonitoring"],
	customer_validation_requests?:ValueTypes["CommissioningStatusCustomerValidationRequest"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ValueTypes["CommissioningStatusData"],
		__typename?: boolean | `@${string}`
}>;
	["LegacyFinancing"]: AliasType<{
	projectId?:boolean | `@${string}`,
	financingId?:boolean | `@${string}`,
	formalizedAt?:boolean | `@${string}`,
	stage?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationData"]: AliasType<{
	id?:boolean | `@${string}`,
	clickedAt?:boolean | `@${string}`,
	readAt?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	notification?:ValueTypes["Notification"],
		__typename?: boolean | `@${string}`
}>;
	["Notification"]: AliasType<{
	actionUrl?:boolean | `@${string}`,
	templateName?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Metrics"]: AliasType<{
	totalCount?:boolean | `@${string}`,
	totalUnreadCount?:boolean | `@${string}`,
	totalUnclickedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationsList"]: AliasType<{
	count?:boolean | `@${string}`,
	totalCount?:boolean | `@${string}`,
	nextCursor?:boolean | `@${string}`,
	nextPage?:boolean | `@${string}`,
	previousCursor?:boolean | `@${string}`,
	previousPage?:boolean | `@${string}`,
	data?:ValueTypes["NotificationData"],
	metrics?:ValueTypes["Metrics"],
		__typename?: boolean | `@${string}`
}>;
	["ContactPartner"]: AliasType<{
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Address"]: AliasType<{
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	reference?:boolean | `@${string}`,
	district?:boolean | `@${string}`,
	zipcode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ResponsiblePartner"]: AliasType<{
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	contact?:ValueTypes["ContactPartner"],
		__typename?: boolean | `@${string}`
}>;
	["Permission"]: AliasType<{
	store?:boolean | `@${string}`,
	financing?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Sfplus"]: AliasType<{
	level?:boolean | `@${string}`,
	is_level_black?:boolean | `@${string}`,
	next_transition_date?:boolean | `@${string}`,
	score?:ValueTypes["Score"],
	black_status?:ValueTypes["LevelBlackStatus"],
	downgrade?:ValueTypes["Downgrade"],
		__typename?: boolean | `@${string}`
}>;
	["OnlyPartner"]: AliasType<{
	id?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	trade_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	state_registration?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	operation_term_accepted?:boolean | `@${string}`,
	address?:ValueTypes["Address"],
	responsible?:ValueTypes["ResponsiblePartner"],
	permission?:ValueTypes["Permission"],
	sfplus?:ValueTypes["Sfplus"],
	blocklist?:ValueTypes["PartnerBlocklist"],
	registration_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerBlocklist"]: AliasType<{
	is_blocked?:boolean | `@${string}`,
	nature?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	action?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CorePartner"]: AliasType<{
	id?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	responsible?:ValueTypes["CoreParterResponsible"],
	company_name?:boolean | `@${string}`,
	fantasy_name?:boolean | `@${string}`,
	status?:ValueTypes["CoreParterStatus"],
		__typename?: boolean | `@${string}`
}>;
	["CoreParterResponsible"]: AliasType<{
	id?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoreParterStatus"]: AliasType<{
	active?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoreGetPartnersInput"]: {
	page?: number | undefined | null | Variable<any, string>,
	search_term?: string | undefined | null | Variable<any, string>
};
	["PaymentCurrentIssuanceModel"]: AliasType<{
	payout_options?:boolean | `@${string}`,
	best_payout_option?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectProposal"]: AliasType<{
	value_changed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectPersonType"]:ProjectPersonType;
	["ProjectSystemType"]:ProjectSystemType;
	["AppliedModifierOption"]: AliasType<{
	type?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AppliedModifier"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	options?:ValueTypes["AppliedModifierOption"],
		__typename?: boolean | `@${string}`
}>;
	["AddonProduct"]: AliasType<{
	id?:boolean | `@${string}`,
	product_name?:boolean | `@${string}`,
	product_external_id?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	product_slug?:boolean | `@${string}`,
	applied?:boolean | `@${string}`,
	partner_commission?:boolean | `@${string}`,
	installment_price?:boolean | `@${string}`,
	total_price?:boolean | `@${string}`,
	monthly_interest_rate?:boolean | `@${string}`,
	engine_simulation_id?:boolean | `@${string}`,
	previous_engine_simulation_id?:boolean | `@${string}`,
	cet?:boolean | `@${string}`,
	applied_modifiers?:ValueTypes["AppliedModifier"],
	addon_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SelectedInstallments"]: AliasType<{
	cet?:boolean | `@${string}`,
	iof?:boolean | `@${string}`,
	ipca?:boolean | `@${string}`,
	addons?:ValueTypes["AddonProduct"],
	aggregated_addons?:ValueTypes["AddonProduct"],
	user_id?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
	aliquot_iof?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	due_day?:boolean | `@${string}`,
	first_due_date?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	interest_rate?:boolean | `@${string}`,
	cet_percentage?:boolean | `@${string}`,
	commission_raw?:boolean | `@${string}`,
	financing_value?:boolean | `@${string}`,
	taxa_de_cadastro?:boolean | `@${string}`,
	taxa_de_juros?:boolean | `@${string}`,
	installment_value?:boolean | `@${string}`,
	is_from_suggested?:boolean | `@${string}`,
	registration_fee_gross?:boolean | `@${string}`,
	registration_fee_raw_dry?:boolean | `@${string}`,
	registration_fee_raw_final?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RiskInfo"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	todo?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	decision?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BNPL"]: AliasType<{
	decision_pre_analysis?:boolean | `@${string}`,
	min_entry_value?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Guarantor"]: AliasType<{
	id?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birth_date?:boolean | `@${string}`,
	border_line?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	customer_second_financing_policy?:boolean | `@${string}`,
	decision_pre_analysis?:boolean | `@${string}`,
	max_approved_project_value?:boolean | `@${string}`,
	max_financing_value?:boolean | `@${string}`,
	max_grace_period?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	min_approved_project_value?:boolean | `@${string}`,
	min_installment_value?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	project_state?:boolean | `@${string}`,
	risk_class?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstallmentsConditions"]: AliasType<{
	suggested_installments?:boolean | `@${string}`,
	suggested_installments_value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Project"]: AliasType<{
	id?:boolean | `@${string}`,
	user_id?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	representative_document?:boolean | `@${string}`,
	project_value?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	system_type?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_status?:boolean | `@${string}`,
	min_installments?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	max_grace_period?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	project_state?:boolean | `@${string}`,
	partner_profile?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	products_applieds?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
	risk_info?:ValueTypes["RiskInfo"],
	state_registration?:boolean | `@${string}`,
	complete?:boolean | `@${string}`,
	selected_installments?:ValueTypes["SelectedInstallments"],
	guarantor?:ValueTypes["Guarantor"],
	birth_date?:boolean | `@${string}`,
	decision_pre_analysis?:boolean | `@${string}`,
	score_sol_facil?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	addons?:ValueTypes["AddonProduct"],
	max_approved_project_value?:boolean | `@${string}`,
	min_approved_project_value?:boolean | `@${string}`,
	max_financing_value?:boolean | `@${string}`,
	border_line?:boolean | `@${string}`,
	is_formalized?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	shopping_cart_id?:boolean | `@${string}`,
	bnpl?:ValueTypes["BNPL"],
	bnpl_simulation_id?:boolean | `@${string}`,
	bnpl_status?:boolean | `@${string}`,
	is_onflex_partner?:boolean | `@${string}`,
	is_turbo_prime?:boolean | `@${string}`,
	can_select_ampera?:boolean | `@${string}`,
	has_energy_bill_analysis?:boolean | `@${string}`,
	insurance_commission?:boolean | `@${string}`,
	gained_points?:boolean | `@${string}`,
	original_installment_value?:boolean | `@${string}`,
	is_contract_signed?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	risk_class?:boolean | `@${string}`,
	selected_installment?:boolean | `@${string}`,
	credit_analysis_status?:boolean | `@${string}`,
	bill_value?:boolean | `@${string}`,
	installments_conditions?:ValueTypes["InstallmentsConditions"],
		__typename?: boolean | `@${string}`
}>;
	["ProjectProposalUpdatePayloadInput"]: {
	engine_simulation_id: string | Variable<any, string>,
	simulation_id: string | Variable<any, string>,
	is_combo: boolean | Variable<any, string>,
	is_ampera: boolean | Variable<any, string>,
	commission: number | Variable<any, string>,
	applied_addons: Array<string> | Variable<any, string>
};
	["ProjectProposalUpdateResponse"]: AliasType<{
	engine_simulation_id?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_ampera?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	applied_addons?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["IsComboResponse"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectCreateInput"]: {
	person_type: ValueTypes["ProjectPersonType"] | Variable<any, string>,
	project_name?: string | undefined | null | Variable<any, string>,
	document: string | Variable<any, string>,
	project_value: number | Variable<any, string>,
	down_payment: number | Variable<any, string>,
	partner_id: number | Variable<any, string>,
	user_id: number | Variable<any, string>,
	representative_document?: string | undefined | null | Variable<any, string>,
	system_power: number | Variable<any, string>,
	new_journey: boolean | Variable<any, string>,
	shopping_cart_id?: string | undefined | null | Variable<any, string>,
	provider: string | Variable<any, string>,
	bill_value: number | Variable<any, string>,
	system_type: ValueTypes["ProjectSystemType"] | Variable<any, string>,
	engine_pricing?: string | undefined | null | Variable<any, string>
};
	["ProjectCreateStatus"]:ProjectCreateStatus;
	["ProjectCreateResponse"]: AliasType<{
	status?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewAll"]: AliasType<{
	total?:boolean | `@${string}`,
	in_progress?:boolean | `@${string}`,
	in_reassassement?:boolean | `@${string}`,
	finish?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewSimulation"]: AliasType<{
	total?:boolean | `@${string}`,
	approved?:boolean | `@${string}`,
	reassassement?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewProposal"]: AliasType<{
	total?:boolean | `@${string}`,
	in_equipments?:boolean | `@${string}`,
	in_customer_data?:boolean | `@${string}`,
	in_biometry_and_contract?:boolean | `@${string}`,
	in_payment_model?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewInstallation"]: AliasType<{
	total?:boolean | `@${string}`,
	in_progress?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverview"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	all?:ValueTypes["PartnerOverviewAll"],
	simulation?:ValueTypes["PartnerOverviewSimulation"],
	proposal?:ValueTypes["PartnerOverviewProposal"],
	installation?:ValueTypes["PartnerOverviewInstallation"],
	status?:boolean | `@${string}`,
	last_updated_at?:boolean | `@${string}`,
	next_update_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationPersonType"]:RegistrationPersonType;
	["RegistrationDocumentTypes"]:RegistrationDocumentTypes;
	["RegistrationRepresentantTypes"]:RegistrationRepresentantTypes;
	["RegistrationContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddressCity"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddressState"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationDocumentModel"]:RegistrationDocumentModel;
	["RegistrationElectricityBill"]: AliasType<{
	holder_cpf?:boolean | `@${string}`,
	is_under_customer_name?:boolean | `@${string}`,
	distributor_id?:boolean | `@${string}`,
	inverters_power_above_limit?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationElectricityBillWithDocuments"]: AliasType<{
	id?:boolean | `@${string}`,
	holder_cpf?:boolean | `@${string}`,
	is_under_customer_name?:boolean | `@${string}`,
	documents?:ValueTypes["RegistrationDocument"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationDocument"]: AliasType<{
	type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	url_download?:boolean | `@${string}`,
	url_preview?:boolean | `@${string}`,
	mime_type?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddress"]: AliasType<{
	zipcode?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city_id?:boolean | `@${string}`,
	state_id?:boolean | `@${string}`,
	city?:ValueTypes["RegistrationAddressCity"],
	state?:ValueTypes["RegistrationAddressState"],
	is_rural?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationProject"]: AliasType<{
	address?:ValueTypes["RegistrationAddress"],
	documents?:ValueTypes["RegistrationDocument"],
	electricity_bill?:ValueTypes["RegistrationElectricityBill"],
	residencial_is_the_same_of_plant?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCustomer"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["RegistrationContact"],
	documents?:ValueTypes["RegistrationDocument"],
	document_type?:boolean | `@${string}`,
	address?:ValueTypes["RegistrationAddress"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCompany"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	contact?:ValueTypes["RegistrationContact"],
	documents?:ValueTypes["RegistrationDocument"],
	majority_partner?:ValueTypes["RegistrationCompanyMajorityPartner"],
	legal_representatives?:ValueTypes["RegistrationLegalRepresentative"],
	majority_partner_is_legal_representative?:boolean | `@${string}`,
	is_only_one_legal_representative?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationLegalRepresentative"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["RegistrationContact"],
	documents?:ValueTypes["RegistrationDocument"],
	address?:ValueTypes["RegistrationAddress"],
	kind?:boolean | `@${string}`,
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCompanyMajorityPartner"]: AliasType<{
	cpf?:boolean | `@${string}`,
	is_legal_representative?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["RegistrationContact"],
	documents?:ValueTypes["RegistrationDocument"],
	address?:ValueTypes["RegistrationAddress"],
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationGuarantor"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ValueTypes["RegistrationContact"],
	documents?:ValueTypes["RegistrationDocument"],
	address?:ValueTypes["RegistrationAddress"],
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationError"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	field?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationUpdateInput"]: {
	project_id: string | Variable<any, string>
};
	["RegistrationDetailsResponse"]: AliasType<{
	project_id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	remaining_changes_after_confirmation?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	customer?:ValueTypes["RegistrationCustomer"],
	company?:ValueTypes["RegistrationCompany"],
	guarantor?:ValueTypes["RegistrationGuarantor"],
	project?:ValueTypes["RegistrationProject"],
	errors?:ValueTypes["RegistrationError"],
	electricity_bills?:ValueTypes["RegistrationElectricityBillWithDocuments"],
	has_other_beneficiary_units?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Display mode of the grid access approval (parecer de acesso) field for the installation site.
HIDDEN: the field is not shown. SHOW: the field is optional. SHOW_REQUIRED: the field is required. */
["GridAccessApprovalDisplayMode"]:GridAccessApprovalDisplayMode;
	["RegistrationGridAccessApproval"]: AliasType<{
	display_mode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationStatus"]:RevalidationStatus;
	["AttemptStatus"]:AttemptStatus;
	["RevalidationStatusCount"]: AliasType<{
	status?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationBrandSummary"]: AliasType<{
	brand?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
	statuses?:ValueTypes["RevalidationStatusCount"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSummary"]: AliasType<{
	total?:boolean | `@${string}`,
	statuses?:ValueTypes["RevalidationStatusCount"],
	brands?:ValueTypes["RevalidationBrandSummary"],
		__typename?: boolean | `@${string}`
}>;
	["LatestSubmission"]: AliasType<{
	serial_number?:boolean | `@${string}`,
	attempt_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LatestAttempt"]: AliasType<{
	serial_number?:boolean | `@${string}`,
	attempt_status?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	processed_at?:boolean | `@${string}`,
	reason_code?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationItem"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	plant_name?:boolean | `@${string}`,
	reference_inverter_brand?:boolean | `@${string}`,
	expected_total_inverters?:boolean | `@${string}`,
	latest_submission?:ValueTypes["LatestSubmission"],
	latest_attempts?:ValueTypes["LatestAttempt"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationPagination"]: AliasType<{
	page?:boolean | `@${string}`,
	page_size?:boolean | `@${string}`,
	total_items?:boolean | `@${string}`,
	total_pages?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationsListResponse"]: AliasType<{
	items?:ValueTypes["RevalidationItem"],
	pagination?:ValueTypes["RevalidationPagination"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationsInput"]: {
	status?: Array<ValueTypes["RevalidationStatus"]> | undefined | null | Variable<any, string>,
	brand?: string | undefined | null | Variable<any, string>,
	sort?: string | undefined | null | Variable<any, string>,
	page?: number | undefined | null | Variable<any, string>,
	page_size?: number | undefined | null | Variable<any, string>
};
	["RegisterRevalidationCredentialInput"]: {
	brand: string | Variable<any, string>,
	username: string | Variable<any, string>,
	password: string | Variable<any, string>
};
	["RegisterRevalidationCredentialErrorCode"]:RegisterRevalidationCredentialErrorCode;
	["RegisterRevalidationCredentialResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionDeviceInput"]: {
	brand: string | Variable<any, string>,
	serial_number: string | Variable<any, string>
};
	["RevalidationSubmissionInput"]: {
	revalidation_id: string | Variable<any, string>,
	monitoring_plant_name: string | Variable<any, string>,
	devices: Array<ValueTypes["RevalidationSubmissionDeviceInput"]> | Variable<any, string>
};
	["SubmitRevalidationsInput"]: {
	platform_access_token: string | Variable<any, string>,
	submissions: Array<ValueTypes["RevalidationSubmissionInput"]> | Variable<any, string>
};
	["RevalidationSubmissionAccepted"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	submission_number?:boolean | `@${string}`,
	total_devices?:boolean | `@${string}`,
	revalidation_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionError"]: AliasType<{
	code?:boolean | `@${string}`,
	detail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionDevice"]: AliasType<{
	brand?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionRejected"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	errors?:ValueTypes["RevalidationSubmissionError"],
	devices?:ValueTypes["RevalidationSubmissionDevice"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionReferenceBrandUpdated"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	reference_inverter_brand?:boolean | `@${string}`,
	revalidation_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionsData"]: AliasType<{
	accepted?:ValueTypes["RevalidationSubmissionAccepted"],
	rejected?:ValueTypes["RevalidationSubmissionRejected"],
	reference_brand_updated?:ValueTypes["RevalidationSubmissionReferenceBrandUpdated"],
		__typename?: boolean | `@${string}`
}>;
	["SubmitRevalidationsResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ValueTypes["RevalidationSubmissionsData"],
		__typename?: boolean | `@${string}`
}>;
	["AnalyzeEnergyBillInput"]: {
	person_type: string | Variable<any, string>,
	project_id: string | Variable<any, string>,
	document_customer: string | Variable<any, string>,
	financing_id: number | Variable<any, string>,
	document_owner_energy_bill: string | Variable<any, string>,
	auto_cancel_flow_on_rejection: boolean | Variable<any, string>
};
	["GetOpportunitiesInput"]: {
	financing_value: number | Variable<any, string>,
	partner_id: number | Variable<any, string>,
	project_type: string | Variable<any, string>
};
	["EnergyBillAnalysisDecision"]: AliasType<{
	decision?:boolean | `@${string}`,
	details?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GetOpportunitiesResponse"]: AliasType<{
	addons_opportunities?:ValueTypes["AddonsOpportunities"],
	financing_gained_points?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AddonsOpportunities"]: AliasType<{
	addon_type?:boolean | `@${string}`,
	gained_points?:boolean | `@${string}`,
	product_slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LevelBlackStatus"]: AliasType<{
	kwGoalMonth?:boolean | `@${string}`,
	kwReachedMonth?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Contact"]: AliasType<{
	landline?:boolean | `@${string}`,
	mobile?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Responsible"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	contact?:ValueTypes["Contact"],
	partner?:ValueTypes["Partner"],
		__typename?: boolean | `@${string}`
}>;
	["Score"]: AliasType<{
	current?:boolean | `@${string}`,
	goal?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Downgrade"]: AliasType<{
	has_risk?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Partner"]: AliasType<{
	id?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	operation_term_accepted?:boolean | `@${string}`,
	trade_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	state_registration?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	address?:ValueTypes["Address"],
	responsible?:ValueTypes["Responsible"],
	permission?:ValueTypes["Permission"],
	users?:ValueTypes["User"],
	sfplus?:ValueTypes["Sfplus"],
		__typename?: boolean | `@${string}`
}>;
	["Post"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	comments?:ValueTypes["Comment"],
		__typename?: boolean | `@${string}`
}>;
	["Comment"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OperatingAgreement"]: AliasType<{
	is_current_term_accepted?:boolean | `@${string}`,
	can_accept?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserTerms"]: AliasType<{
	operating_agreement?:ValueTypes["OperatingAgreement"],
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	contact?:ValueTypes["Contact"],
	partner?:ValueTypes["Partner"],
	posts?:ValueTypes["Post"],
	terms?:ValueTypes["UserTerms"],
		__typename?: boolean | `@${string}`
}>;
	/** Estados que o portal NAO tem como deduzir — o backend manda, o portal traduz.

WalletPaymentModelSummary.state   ENABLED | MODEL_DISABLED | NOVICE | ESSENTIAL_PROFILE
                                  | COMMERCIAL_EXCEPTION | BLOCKED
WalletPaymentModelCard.state      ENABLED | DEFAULT | LOCKED | DISABLED | BLOCKED | WAIVED */
["WalletPaymentModelSummary"]: AliasType<{
	/** Qual das 7 variantes do card do Resumo renderizar (Figma: MR overview card). */
	state?:boolean | `@${string}`,
	/** null quando state = BLOCKED — o corpo do card vira empty state. */
	current_model?:boolean | `@${string}`,
	upfront_percentage?:boolean | `@${string}`,
	after_completion_percentage?:boolean | `@${string}`,
	/** Vem calculado do backend (que repassa o lambda). O portal NAO divide
on_time_completed/total_completed em lugar nenhum.
null quando state = NOVICE ou ESSENTIAL_PROFILE: o Figma tira o bloco de desempenho. */
	performance_percentage?:boolean | `@${string}`,
	/** Qual modelo foi desabilitado apesar do desempenho. So com state = MODEL_DISABLED. */
	disabled_model?:boolean | `@${string}`,
	/** Motivo, para 'O Modelo A foi desabilitado · Motivo: inadimplência da carteira em alerta'. */
	disabled_reason?:boolean | `@${string}`,
	/** O '3' de '3 de 5 realizadas'. So com state = NOVICE. */
	novice_completed?:boolean | `@${string}`,
	total_completed?:boolean | `@${string}`,
	on_time_completed?:boolean | `@${string}`,
	next_model?:boolean | `@${string}`,
	projects_needed_for_next_model?:boolean | `@${string}`,
	is_blocked?:boolean | `@${string}`,
	block_reason?:boolean | `@${string}`,
	updated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentModelCard"]: AliasType<{
	key?:boolean | `@${string}`,
	upfront_percentage?:boolean | `@${string}`,
	after_completion_percentage?:boolean | `@${string}`,
	min_on_time_percentage?:boolean | `@${string}`,
	is_current?:boolean | `@${string}`,
	/** Substitui is_default e is_unlocked:
  LOCKED   — elegivel, ainda nao alcancou
  DISABLED — alcancou, mas um requisito entrou em alerta/critico
  BLOCKED  — conta bloqueada por fraude, atraso critico ou saude do CNPJ
Mais ENABLED, DEFAULT (so o C) e WAIVED (flexibilizacao comercial). */
	state?:boolean | `@${string}`,
	requirements?:ValueTypes["WalletModelRequirement"],
		__typename?: boolean | `@${string}`
}>;
	["WalletModelRequirement"]: AliasType<{
	code?:boolean | `@${string}`,
	/** O que varia por parceiro. O portal nunca deduz isto comparando percentuais. */
	is_met?:boolean | `@${string}`,
	/** true = o portal RISCA o texto da linha (flexibilizacao comercial ativa). */
	is_waived?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletDefaultModelCondition"]: AliasType<{
	code?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentPerformance"]: AliasType<{
	total_completed?:boolean | `@${string}`,
	on_time_completed?:boolean | `@${string}`,
	late_completed?:boolean | `@${string}`,
	/** Vem calculado do backend. O portal nao divide os contadores. */
	on_time_percentage?:boolean | `@${string}`,
	thresholds?:ValueTypes["WalletPerformanceThresholds"],
	challenge?:ValueTypes["WalletPerformanceChallenge"],
	by_kit_type?:ValueTypes["WalletPerformanceByKitType"],
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceThresholds"]: AliasType<{
	model_b?:boolean | `@${string}`,
	model_a?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceChallenge"]: AliasType<{
	target_model?:boolean | `@${string}`,
	projects_needed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceByKitType"]: AliasType<{
	kit_type?:boolean | `@${string}`,
	on_time_count?:boolean | `@${string}`,
	late_count?:boolean | `@${string}`,
	projects_filter?:ValueTypes["WalletProjectsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["WalletProjectsFilter"]: AliasType<{
	kit_type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletCommercialException"]: AliasType<{
	is_active?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletEligibilityContext"]: AliasType<{
	partner_profile?:boolean | `@${string}`,
	is_novice?:boolean | `@${string}`,
	novice_completed?:boolean | `@${string}`,
	novice_required?:boolean | `@${string}`,
	performance_model?:boolean | `@${string}`,
	delinquency_status?:boolean | `@${string}`,
	commercial_exception?:ValueTypes["WalletCommercialException"],
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentModel"]: AliasType<{
	summary?:ValueTypes["WalletPaymentModelSummary"],
	models?:ValueTypes["WalletPaymentModelCard"],
	default_model_conditions?:ValueTypes["WalletDefaultModelCondition"],
	performance?:ValueTypes["WalletPaymentPerformance"],
	eligibility_context?:ValueTypes["WalletEligibilityContext"],
		__typename?: boolean | `@${string}`
}>
  }

export type ResolverInputTypes = {
    ["Order"]:Order;
	/** The `Upload` scalar type represents a file upload. */
["Upload"]:unknown;
	["Combos"]: AliasType<{
	data?:ResolverInputTypes["ComboData"],
		__typename?: boolean | `@${string}`
}>;
	["Cities"]: AliasType<{
	data?:ResolverInputTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["AddressInstallation"]: AliasType<{
	data?:ResolverInputTypes["AddressInstallationData"],
		__typename?: boolean | `@${string}`
}>;
	["ComboData"]: AliasType<{
	nationality?:ResolverInputTypes["CityStateData"],
	gender?:ResolverInputTypes["CityStateData"],
	occupation?:ResolverInputTypes["CityStateData"],
	state?:ResolverInputTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["CepAddress"]: AliasType<{
	neighborhood?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	state?:ResolverInputTypes["CityStateData"],
	city?:ResolverInputTypes["CityStateData"],
		__typename?: boolean | `@${string}`
}>;
	["AddressInstallationData"]: AliasType<{
	postal_code?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	additional_info?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	rural_area?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CityStateData"]: AliasType<{
	name?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Query"]: AliasType<{
address_combos?: [{	nationality?: boolean | undefined | null,	gender?: boolean | undefined | null,	occupation?: boolean | undefined | null,	state?: boolean | undefined | null},ResolverInputTypes["Combos"]],
address_cities?: [{	state_id: number},ResolverInputTypes["Cities"]],
address_from_cep?: [{	cep: string},ResolverInputTypes["CepAddress"]],
address_installation?: [{	project_id: string},ResolverInputTypes["AddressInstallation"]],
customer_form?: [{	project_id: string},ResolverInputTypes["CustomerFormResponse"]],
access_user_credentials?: [{	brand: string},ResolverInputTypes["AccessUserCredentialsResponse"]],
credentials_check?: [{	brand: string},ResolverInputTypes["CredentialsCheckResponse"]],
documents?: [{	project_id: string},ResolverInputTypes["DocumentResponse"]],
financing?: [{	id: string},ResolverInputTypes["Financing"]],
financingV2?: [{	id: string},ResolverInputTypes["FinancingV2"]],
financings?: [{	input: ResolverInputTypes["FinancingsInput"]},ResolverInputTypes["FinancingsList"]],
financing_type?: [{	person_type: string},ResolverInputTypes["FinancingType"]],
formalization?: [{	projectId: string},ResolverInputTypes["FormalizationInfo"]],
formalization_biometry_confirm?: [{	projectId: string},ResolverInputTypes["ConfirmBiometryResponse"]],
formalization_v2?: [{	projectId: string},ResolverInputTypes["FormalizedFinancing"]],
formalization_metrics?: [{	window_days?: number | undefined | null,	partner_id?: Array<string> | undefined | null,	page?: number | undefined | null,	page_size?: number | undefined | null},ResolverInputTypes["FormalizationMetricsResponse"]],
targetIncentivesSummary?: [{	target_id: string,	campaign_type: string,	target_type: string},ResolverInputTypes["TargetIncentiveSummary"]],
getCommissioningStatus?: [{	installation_id: string},ResolverInputTypes["CommissioningStatusResponse"]],
installation?: [{	projectId: string},ResolverInputTypes["Installation"]],
mirrorStatus?: [{	projectId: string},ResolverInputTypes["MirrorStatus"]],
	inverter_brands?:ResolverInputTypes["InverterBrands"],
available_orders?: [{	projectId: string,	with_summary?: boolean | undefined | null,	order_id?: number | undefined | null,	page?: number | undefined | null,	page_size?: number | undefined | null},ResolverInputTypes["AvailableOrders"]],
legacyFinancing?: [{	projectId: string},ResolverInputTypes["LegacyFinancing"]],
notifications?: [{	userId: number,	cursor?: string | undefined | null},ResolverInputTypes["NotificationsList"]],
partner?: [{	partnerId: string},ResolverInputTypes["OnlyPartner"]],
partners?: [{	input?: ResolverInputTypes["CoreGetPartnersInput"] | undefined | null},ResolverInputTypes["CorePartner"]],
payment_current_issuance_model?: [{	partnerId: string},ResolverInputTypes["PaymentCurrentIssuanceModel"]],
projects_partner_overview?: [{	partner_id: string},ResolverInputTypes["PartnerOverview"]],
project?: [{	projectId: string},ResolverInputTypes["Project"]],
project_proposal_changes?: [{	project_id: string},ResolverInputTypes["ProjectProposal"]],
project_is_combo?: [{	project_id: string},ResolverInputTypes["IsComboResponse"]],
	project_system_types?:boolean | `@${string}`,
registration?: [{	project_id: string},ResolverInputTypes["RegistrationDetailsResponse"]],
registration_grid_access_approval?: [{	project_id: string,	city: string,	state: string},ResolverInputTypes["RegistrationGridAccessApproval"]],
	risk_financing_revalidation_summary?:ResolverInputTypes["RevalidationSummary"],
risk_financing_revalidations?: [{	input?: ResolverInputTypes["RevalidationsInput"] | undefined | null},ResolverInputTypes["RevalidationsListResponse"]],
getOpportunities?: [{	params: ResolverInputTypes["GetOpportunitiesInput"]},ResolverInputTypes["GetOpportunitiesResponse"]],
simulation_project_shopping_cart_id_get?: [{	projectId: string},boolean | `@${string}`],
	user?:ResolverInputTypes["User"],
wallet_payment_model?: [{	partner_id?: string | undefined | null},ResolverInputTypes["WalletPaymentModel"]],
		__typename?: boolean | `@${string}`
}>;
	["PersonTypes"]:PersonTypes;
	["DocumentTypes"]:DocumentTypes;
	["LegalRepresentantTypes"]:LegalRepresentantTypes;
	["CustomerStatus"]:CustomerStatus;
	["RegistrationContactChangeResponse"]: AliasType<{
	message?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerFormResponse"]: AliasType<{
	project_id?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	customer?:ResolverInputTypes["CustomerData"],
	guarantor?:ResolverInputTypes["CustomerData"],
	project?:ResolverInputTypes["CustomerProject"],
	remaining_changes_after_confirmation?:boolean | `@${string}`,
	company?:ResolverInputTypes["CompanyData"],
	errors?:ResolverInputTypes["CustomerErrors"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerErrors"]: AliasType<{
	field?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocument"]: AliasType<{
	type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	url_download?:boolean | `@${string}`,
	url_preview?:boolean | `@${string}`,
	mime_type?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerAddress"]: AliasType<{
	zipcode?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city_id?:boolean | `@${string}`,
	state_id?:boolean | `@${string}`,
	city?:ResolverInputTypes["CustomerIdName"],
	state?:ResolverInputTypes["CustomerIdName"],
	is_rural?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerData"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["CustomerContact"],
	documents?:ResolverInputTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ResolverInputTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerEletricityBill"]: AliasType<{
	is_under_customer_name?:boolean | `@${string}`,
	holder_cpf?:boolean | `@${string}`,
	distributor_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerProject"]: AliasType<{
	address?:ResolverInputTypes["CustomerAddress"],
	documents?:ResolverInputTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	electricity_bill?:ResolverInputTypes["CustomerEletricityBill"],
	residencial_is_the_same_of_plant?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompanyMajorityPartner"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["CustomerContact"],
	documents?:ResolverInputTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ResolverInputTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CompanyLegalRepresentant"]: AliasType<{
	kind?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["CustomerContact"],
	documents?:ResolverInputTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	address?:ResolverInputTypes["CustomerAddress"],
		__typename?: boolean | `@${string}`
}>;
	["CompanyData"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	contact?:ResolverInputTypes["CustomerContact"],
	documents?:ResolverInputTypes["CustomerDocument"],
	document_type?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
	majority_partner?:ResolverInputTypes["CompanyMajorityPartner"],
	majority_partner_is_legal_representative?:boolean | `@${string}`,
	is_only_one_legal_representative?:boolean | `@${string}`,
	legal_representatives?:ResolverInputTypes["CompanyLegalRepresentant"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationV2PersonType"]:RegistrationV2PersonType;
	["CustomerIdName"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationAddress"]: {
	zipcode: string,
	street: string,
	street_number: string,
	complement?: string | undefined | null,
	neighborhood: string,
	city_id: number,
	state_id: number,
	is_rural?: boolean | undefined | null
};
	["CustomerRegistrationContact"]: {
	email: string,
	phone: string
};
	["CustomerRegistrationDocument"]: {
	type: string,
	docstorage_id: string
};
	["CustomerRegistrationCustomer"]: {
	full_name: string,
	birthdate: string,
	contact: ResolverInputTypes["CustomerRegistrationContact"],
	documents: Array<ResolverInputTypes["CustomerRegistrationDocument"]>,
	address: ResolverInputTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationGuarantor"]: {
	full_name: string,
	birthdate: string,
	contact: ResolverInputTypes["CustomerRegistrationContact"],
	documents: Array<ResolverInputTypes["CustomerRegistrationDocument"]>,
	address: ResolverInputTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationElectricityBill"]: {
	is_under_customer_name: boolean,
	holder_cpf?: string | undefined | null,
	distributor_id?: number | undefined | null
};
	["CustomerRegistrationElectricityBillWithDocuments"]: {
	electricity_bill_docstorage_id: string,
	employment_proof_docstorage_id?: string | undefined | null,
	additional_document_docstorage_id?: string | undefined | null,
	holder_cpf?: string | undefined | null,
	is_under_customer_name: boolean
};
	["CustomerRegistrationProject"]: {
	address: ResolverInputTypes["CustomerRegistrationAddress"],
	documents: Array<ResolverInputTypes["CustomerRegistrationDocument"]>,
	comment?: string | undefined | null,
	electricity_bill: ResolverInputTypes["CustomerRegistrationElectricityBill"],
	electricity_bills?: Array<ResolverInputTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined | null
};
	["CustomerRegistrationCompany"]: {
	company_name: string,
	contact: ResolverInputTypes["CustomerRegistrationContact"],
	documents: Array<ResolverInputTypes["CustomerRegistrationDocument"]>,
	majority_partner: ResolverInputTypes["CustomerRegistrationCustomer"],
	legal_representatives: Array<ResolverInputTypes["CustomerRegistrationLegalRepresentative"]>
};
	["CustomerRegistrationLegalRepresentative"]: {
	kind: string,
	cpf: string,
	full_name: string,
	birthdate: string,
	contact: ResolverInputTypes["CustomerRegistrationContact"],
	documents: Array<ResolverInputTypes["CustomerRegistrationDocument"]>,
	address: ResolverInputTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationInput"]: {
	project_id: string,
	person_type: ResolverInputTypes["RegistrationV2PersonType"],
	customer?: ResolverInputTypes["CustomerRegistrationCustomer"] | undefined | null,
	guarantor?: ResolverInputTypes["CustomerRegistrationGuarantor"] | undefined | null,
	project?: ResolverInputTypes["CustomerRegistrationProject"] | undefined | null,
	company?: ResolverInputTypes["CustomerRegistrationCompany"] | undefined | null,
	electricity_bills?: Array<ResolverInputTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined | null
};
	["Person"]: {
	email?: string | undefined | null,
	partner_id: string,
	phone?: string | undefined | null
};
	["CustomerDocumentUpload"]: AliasType<{
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	url_inline?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	mimetype?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationError"]: AliasType<{
	field?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CustomerRegistrationV2Response"]: AliasType<{
	errors?:ResolverInputTypes["CustomerRegistrationError"],
		__typename?: boolean | `@${string}`
}>;
	["CustomerDocumentFormAnalysis"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	installation_document_matches_bill?:boolean | `@${string}`,
	installation_address_matches_bill?:boolean | `@${string}`,
	identity_matches_document?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	comments?:boolean | `@${string}`,
	documents?:ResolverInputTypes["CustomerDocumentUpload"],
		__typename?: boolean | `@${string}`
}>;
	["PersonInput"]: {
	email: string,
	phone: string
};
	["RegistrationContactChangeInput"]: {
	project_id: string,
	customer?: ResolverInputTypes["PersonInput"] | undefined | null,
	guarantor?: ResolverInputTypes["PersonInput"] | undefined | null,
	majority_partner?: ResolverInputTypes["PersonInput"] | undefined | null,
	legal_representative_1?: ResolverInputTypes["PersonInput"] | undefined | null,
	legal_representative_2?: ResolverInputTypes["PersonInput"] | undefined | null
};
	["Mutation"]: AliasType<{
registration_contact_change?: [{	input: ResolverInputTypes["RegistrationContactChangeInput"]},ResolverInputTypes["RegistrationContactChangeResponse"]],
customer_document_upload?: [{	documents: Array<ResolverInputTypes["Upload"]>},ResolverInputTypes["CustomerDocumentUpload"]],
customer_document_form_analysis_cancel?: [{	project_id: string,	step: string},ResolverInputTypes["CustomerDocumentFormAnalysis"]],
customer_registration?: [{	params: ResolverInputTypes["CustomerRegistrationInput"]},ResolverInputTypes["CustomerRegistrationV2Response"]],
register_device_orchestrator_gateway_credential?: [{	input: ResolverInputTypes["RegisterDeviceOrchestratorGatewayCredentialInput"]},ResolverInputTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"]],
device_orchestrator_credentials_change?: [{	brand: string,	password: string},ResolverInputTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"]],
formalization_term_combo_connect_resend?: [{	projectId: string},ResolverInputTypes["TermComboConnectResponse"]],
validateHardwareForm?: [{	hardwareFormInput: ResolverInputTypes["HardwareFormInput"]},ResolverInputTypes["HardwareFormValidation"]],
hardware_form_showcase?: [{	hardwareFormShowcaseInput: ResolverInputTypes["HardwareFormShowcaseInput"]},ResolverInputTypes["HardwareFormShowcaseResponse"]],
hardware_form_draft?: [{	hardwareFormDraftInput: ResolverInputTypes["HardwareDraft"]},boolean | `@${string}`],
installation_mirror_upload?: [{	projectId: string,	mirror: ResolverInputTypes["Upload"]},ResolverInputTypes["MirrorUploadResponse"]],
installation_inverter_labels_upload?: [{	installationId: string,	inverterLabel: ResolverInputTypes["Upload"],	dataloggerLabel?: ResolverInputTypes["Upload"] | undefined | null},ResolverInputTypes["UploadInstallationLabelsResponse"]],
installation_power_inverters_validate?: [{	input: ResolverInputTypes["ValidateTotalInvertersPowerInput"]},ResolverInputTypes["ValidateTotalInvertersPowerResponse"]],
installation_section_delete?: [{	installation_id: string},boolean | `@${string}`],
installation_section_document_delete?: [{	installation_id: string,	section_id: string,	document_id: string},boolean | `@${string}`],
installation_customer_reproval?: [{	input: ResolverInputTypes["CustomerReprovalInput"]},boolean | `@${string}`],
installation_installed_inverter_create?: [{	project_id: string,	installation_id: string,	input: ResolverInputTypes["CreateInstalledInverterInput"]},ResolverInputTypes["CreatedInstalledInverter"]],
installation_installed_inverter_create_with_brand?: [{	installation_id: string,	input: ResolverInputTypes["CreateInstalledInverterWithBrandInput"]},ResolverInputTypes["CreatedInstalledInverter"]],
installation_commissioning_check?: [{	formalization_date?: string | undefined | null,	installation_id: string,	plant_name?: string | undefined | null,	platforms: Array<string>},ResolverInputTypes["CommissioningCheckResponse"]],
installation_commissioning_request?: [{	input: ResolverInputTypes["CommissioningRequestInput"]},ResolverInputTypes["CommissioningRequestResponse"]],
installation_commissioning_reset_customer_rejection?: [{	project_id: string},ResolverInputTypes["CommissioningResetResponse"]],
installation_biometric_validation?: [{	input: ResolverInputTypes["BiometricValidationInput"]},ResolverInputTypes["BiometricValidationResponse"]],
markNotificationsRead?: [{	userId: number},boolean | `@${string}`],
markNotificationClicked?: [{	notificationId: number},boolean | `@${string}`],
project_update_shopping_cart?: [{	project_id: string,	shopping_cart_id: string},boolean | `@${string}`],
project_proposal_update?: [{	project_id: string,	payload: ResolverInputTypes["ProjectProposalUpdatePayloadInput"]},boolean | `@${string}`],
project_create?: [{	input: ResolverInputTypes["ProjectCreateInput"]},ResolverInputTypes["ProjectCreateResponse"]],
registration?: [{	params: ResolverInputTypes["RegistrationUpdateInput"]},boolean | `@${string}`],
risk_financing_register_credential?: [{	input: ResolverInputTypes["RegisterRevalidationCredentialInput"]},ResolverInputTypes["RegisterRevalidationCredentialResponse"]],
risk_financing_submit_revalidations?: [{	input: ResolverInputTypes["SubmitRevalidationsInput"]},ResolverInputTypes["SubmitRevalidationsResponse"]],
processEnergyAccountAnalysis?: [{	params: ResolverInputTypes["AnalyzeEnergyBillInput"]},ResolverInputTypes["EnergyBillAnalysisDecision"]],
		__typename?: boolean | `@${string}`
}>;
	/** Arbitrary JSON value */
["JSON"]:unknown;
	["DeviceOrchestratorGatewayCredentialErrorCode"]:DeviceOrchestratorGatewayCredentialErrorCode;
	["RegisterDeviceOrchestratorGatewayCredentialResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegisterDeviceOrchestratorGatewayCredentialInput"]: {
	brand: string,
	username: string,
	password: string
};
	["AccessUserCredentialsData"]: AliasType<{
	access_user?:boolean | `@${string}`,
	platform?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AccessUserCredentialsResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ResolverInputTypes["AccessUserCredentialsData"],
		__typename?: boolean | `@${string}`
}>;
	["CredentialsCheckResponse"]: AliasType<{
	has_credentials?:boolean | `@${string}`,
	is_valid?:boolean | `@${string}`,
	access_token?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentResponse"]: AliasType<{
	data?:ResolverInputTypes["DocumentData"],
		__typename?: boolean | `@${string}`
}>;
	["DocumentData"]: AliasType<{
	project?:ResolverInputTypes["Documents"],
	customer?:ResolverInputTypes["Documents"],
	guarantor?:ResolverInputTypes["DocumentFile"],
	company?:ResolverInputTypes["DocumentFile"],
		__typename?: boolean | `@${string}`
}>;
	["Documents"]: AliasType<{
	id?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	kind?:boolean | `@${string}`,
	validated_at?:boolean | `@${string}`,
	validation_mode?:boolean | `@${string}`,
	deleted_at?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	canceled_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	reason?:ResolverInputTypes["DocumentReason"],
	file?:ResolverInputTypes["DocumentFile"],
		__typename?: boolean | `@${string}`
}>;
	["DocumentFile"]: AliasType<{
	public_id?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	mimetype?:boolean | `@${string}`,
	size?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
	url_inline?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["DocumentReason"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PersonType"]:PersonType;
	["FinancingStatus"]:FinancingStatus;
	["FinancingSteps"]:FinancingSteps;
	["StatusList"]:StatusList;
	["FinancingV2"]: AliasType<{
	id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	financed_value?:boolean | `@${string}`,
	customer_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
	payments?:ResolverInputTypes["Payment"],
	flow_provider?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	all_payments_sent?:boolean | `@${string}`,
	section_statuses?:ResolverInputTypes["FinancingSectionStatusesV2"],
	updated_at?:boolean | `@${string}`,
	is_expired?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	system_type?:boolean | `@${string}`,
	inverters_power_kw?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	openable_steps?:ResolverInputTypes["FormalizationStatuses"],
	is_aproved?:boolean | `@${string}`,
	is_final?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingSectionStatusesV2"]: AliasType<{
	simulation?:ResolverInputTypes["FinancingStep"],
	installation?:ResolverInputTypes["FinancingStep"],
	customer_data?:ResolverInputTypes["FinancingStep"],
	equipment?:ResolverInputTypes["FinancingStep"],
	biometry_and_contract?:ResolverInputTypes["BiometryAndContractStep"],
	payment_model?:ResolverInputTypes["FinancingStep"],
		__typename?: boolean | `@${string}`
}>;
	["GenericFinancingStep"]:AliasType<{
		completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`;
		['...on FinancingStep']?: Omit<ResolverInputTypes["FinancingStep"],keyof ResolverInputTypes["GenericFinancingStep"]>;
		['...on BiometryAndContractStep']?: Omit<ResolverInputTypes["BiometryAndContractStep"],keyof ResolverInputTypes["GenericFinancingStep"]>;
		__typename?: boolean | `@${string}`
}>;
	["FinancingStep"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MetadataItem"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	first_submitted_at?:boolean | `@${string}`,
	last_submitted_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BiometryAndContractMetadata"]: AliasType<{
	biometry?:ResolverInputTypes["MetadataItem"],
	contract?:ResolverInputTypes["MetadataItem"],
	term?:ResolverInputTypes["MetadataItem"],
		__typename?: boolean | `@${string}`
}>;
	["BiometryAndContractStep"]: AliasType<{
	completed_at?:boolean | `@${string}`,
	reproved_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	metadata?:ResolverInputTypes["BiometryAndContractMetadata"],
		__typename?: boolean | `@${string}`
}>;
	["Payment"]: AliasType<{
	id?:boolean | `@${string}`,
	financing_id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	total_value?:boolean | `@${string}`,
	payment_percentage?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Financing"]: AliasType<{
	id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	financed_value?:boolean | `@${string}`,
	project_value?:boolean | `@${string}`,
	customer_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
	payments?:ResolverInputTypes["Payment"],
	flow_provider?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	all_payments_sent?:boolean | `@${string}`,
	section_statuses?:ResolverInputTypes["FinancingSectionStatus"],
	updated_at?:boolean | `@${string}`,
	is_expired?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	openable_steps?:ResolverInputTypes["FormalizationStatuses"],
	is_aproved?:boolean | `@${string}`,
	is_final?:boolean | `@${string}`,
	loan_value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationStatuses"]: AliasType<{
	hardware?:boolean | `@${string}`,
	registration?:boolean | `@${string}`,
	documentation?:boolean | `@${string}`,
	contract?:boolean | `@${string}`,
	receiptModel?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingProposal"]: AliasType<{
	customer_data?:boolean | `@${string}`,
	equipment?:boolean | `@${string}`,
	biometry_and_contract?:boolean | `@${string}`,
	payment_model?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingFormalization"]: AliasType<{
	contract?:boolean | `@${string}`,
	hardware?:boolean | `@${string}`,
	registration?:boolean | `@${string}`,
	documentation?:boolean | `@${string}`,
	receipt_model?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingSectionStatus"]: AliasType<{
	concluded?:boolean | `@${string}`,
	simulation?:boolean | `@${string}`,
	installation?:boolean | `@${string}`,
	proposal?:ResolverInputTypes["FinancingProposal"],
	formalization?:ResolverInputTypes["FinancingFormalization"],
		__typename?: boolean | `@${string}`
}>;
	["FinancingsList"]: AliasType<{
	data?:ResolverInputTypes["Financing"],
	has_next?:boolean | `@${string}`,
	statuses?:boolean | `@${string}`,
	all_steps?:ResolverInputTypes["Item"],
		__typename?: boolean | `@${string}`
}>;
	["Item"]: AliasType<{
	name?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FinancingsInput"]: {
	formalized_gte?: number | undefined | null,
	formalized_lte?: number | undefined | null,
	is_canceled?: boolean | undefined | null,
	is_combo?: string | undefined | null,
	is_combo_connect?: boolean | undefined | null,
	is_expired?: boolean | undefined | null,
	is_installed?: boolean | undefined | null,
	order_by?: string | undefined | null,
	page?: number | undefined | null,
	page_size?: number | undefined | null,
	partner_id?: string | undefined | null,
	provider?: string | undefined | null,
	query?: string | undefined | null,
	status?: Array<ResolverInputTypes["FinancingStatus"]> | undefined | null,
	steps?: Array<ResolverInputTypes["FinancingSteps"]> | undefined | null
};
	["FinancingType"]: AliasType<{
	max_financing_value?:boolean | `@${string}`,
	min_financing_value?:boolean | `@${string}`,
	max_financing_installments?:boolean | `@${string}`,
	grace_period_financing?:ResolverInputTypes["GracePeriod"],
	max_bnpl_value?:boolean | `@${string}`,
	max_bnpl_installments?:boolean | `@${string}`,
	grace_period_bnpl?:ResolverInputTypes["GracePeriod"],
		__typename?: boolean | `@${string}`
}>;
	["GracePeriod"]: AliasType<{
	label?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationInfo"]: AliasType<{
	approval?:boolean | `@${string}`,
	biometry?:ResolverInputTypes["Biometry"],
	cancel?:boolean | `@${string}`,
	contract?:ResolverInputTypes["Contract"],
	cancellation_type?:boolean | `@${string}`,
	contracts?:ResolverInputTypes["FormalizationContracts"],
	term?:ResolverInputTypes["Term"],
	download?:ResolverInputTypes["Download"],
	order_id?:boolean | `@${string}`,
	pendencies?:ResolverInputTypes["Pendencies"],
	remaining_contract_days_until_expiration?:boolean | `@${string}`,
	resend?:boolean | `@${string}`,
	send_biometry_contract?:ResolverInputTypes["SendBiometryContract"],
	status?:boolean | `@${string}`,
	status_reason?:ResolverInputTypes["FormalizationStatusReason"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationStatusReason"]: AliasType<{
	code?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Biometry"]: AliasType<{
	pending?:boolean | `@${string}`,
	signers?:ResolverInputTypes["Signer"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Contract"]: AliasType<{
	has_biometric?:boolean | `@${string}`,
	signers?:ResolverInputTypes["ContractSigner"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationContractSection"]: AliasType<{
	status?:boolean | `@${string}`,
	document_signed?:boolean | `@${string}`,
	signers?:ResolverInputTypes["ContractSigner"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationContracts"]: AliasType<{
	financing_amendment_term?:ResolverInputTypes["FormalizationContractSection"],
	loan?:ResolverInputTypes["FormalizationContractSection"],
	lender_insurance?:ResolverInputTypes["FormalizationContractSection"],
	diverse_risks_insurance?:ResolverInputTypes["FormalizationContractSection"],
	combo_connect_term?:ResolverInputTypes["FormalizationContractSection"],
		__typename?: boolean | `@${string}`
}>;
	["Term"]: AliasType<{
	signers?:ResolverInputTypes["ContractSigner"],
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Signer"]: AliasType<{
	name?:boolean | `@${string}`,
	checked?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ContractSigner"]: AliasType<{
	name?:boolean | `@${string}`,
	checked?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Download"]: AliasType<{
	contract?:boolean | `@${string}`,
	insurance?:boolean | `@${string}`,
	term?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Pendencies"]: AliasType<{
	expired_at?:boolean | `@${string}`,
	items?:ResolverInputTypes["PendencyItem"],
		__typename?: boolean | `@${string}`
}>;
	["PendencyItem"]: AliasType<{
	category?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SendBiometryContract"]: AliasType<{
	message?:ResolverInputTypes["BiometryMessage"],
	method_receipt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BiometryMessage"]: AliasType<{
	days?:boolean | `@${string}`,
	time?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ConfirmBiometryResponse"]: AliasType<{
	is_done?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TermComboConnectResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancing"]: AliasType<{
	id?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	partner_commission_percent?:boolean | `@${string}`,
	financing_line?:boolean | `@${string}`,
	company?:ResolverInputTypes["FormalizedFinancingCompany"],
	customer?:ResolverInputTypes["FormalizedFinancingCustomer"],
	guarantor?:ResolverInputTypes["FormalizedFinancingGuarantor"],
	legal_representatives?:ResolverInputTypes["FormalizedFinancingLegalRepresentative"],
	majority_partner?:ResolverInputTypes["FormalizedFinancingMajorityPartner"],
	proposal?:ResolverInputTypes["FormalizedFinancingProposal"],
	contract?:ResolverInputTypes["FormalizedFinancingContract"],
	partner?:ResolverInputTypes["FormalizedFinancingPartner"],
	securitization?:ResolverInputTypes["FormalizedFinancingSecuritization"],
	funding?:boolean | `@${string}`,
	project?:ResolverInputTypes["FormalizedFinancingProject"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomer"]: AliasType<{
	address?:ResolverInputTypes["FormalizedFinancingCustomerAddress"],
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["FormalizedFinancingCustomerContact"],
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomerAddress"]: AliasType<{
	city?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	zipcode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCustomerContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingContract"]: AliasType<{
	banking?:boolean | `@${string}`,
	ccb_number?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	generate_date?:boolean | `@${string}`,
	signed_date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingPartner"]: AliasType<{
	id?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	company_name?:boolean | `@${string}`,
	payment_institution?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingProposal"]: AliasType<{
	installments_number?:boolean | `@${string}`,
	rate_type?:boolean | `@${string}`,
	installment_amount?:boolean | `@${string}`,
	gross_amount?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	registration_fee?:boolean | `@${string}`,
	interest_fee?:boolean | `@${string}`,
	iof?:boolean | `@${string}`,
	ipca_type?:boolean | `@${string}`,
	cet?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingSecuritization"]: AliasType<{
	cnpj?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingProject"]: AliasType<{
	electrical_phase?:boolean | `@${string}`,
	installed_at?:boolean | `@${string}`,
	inverter_type?:boolean | `@${string}`,
	inverters?:ResolverInputTypes["FormalizedFinancingInverter"],
	modules?:ResolverInputTypes["FormalizedFinancingModule"],
	total_powers?:ResolverInputTypes["FormalizedFinancingTotalPowers"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingInverter"]: AliasType<{
	brand?:boolean | `@${string}`,
	contactor_switch?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	phase?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	voltage?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingModule"]: AliasType<{
	brand?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	phase?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	voltage?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingTotalPowers"]: AliasType<{
	system?:boolean | `@${string}`,
	modules?:boolean | `@${string}`,
	inverters?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingCompany"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingGuarantor"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingMajorityPartner"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	percentage?:boolean | `@${string}`,
	contact?:ResolverInputTypes["FormalizedFinancingCustomerContact"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizedFinancingLegalRepresentative"]: AliasType<{
	full_name?:boolean | `@${string}`,
	cpf?:boolean | `@${string}`,
	role?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationBucket"]: AliasType<{
	amount?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
	pct?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["FormalizationBuckets"]: AliasType<{
	lte_45?:ResolverInputTypes["FormalizationBucket"],
	d46_60?:ResolverInputTypes["FormalizationBucket"],
	d61_90?:ResolverInputTypes["FormalizationBucket"],
	gt_90?:ResolverInputTypes["FormalizationBucket"],
	lte_60?:ResolverInputTypes["FormalizationBucket"],
	lte_90?:ResolverInputTypes["FormalizationBucket"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationIntegratorMetrics"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	partner_name?:boolean | `@${string}`,
	total_formalized?:boolean | `@${string}`,
	total_formalized_in_window?:boolean | `@${string}`,
	total_installed?:boolean | `@${string}`,
	total_installed_in_window?:boolean | `@${string}`,
	buckets?:ResolverInputTypes["FormalizationBuckets"],
	buckets_pending?:ResolverInputTypes["FormalizationBuckets"],
		__typename?: boolean | `@${string}`
}>;
	["FormalizationMetricsResponse"]: AliasType<{
	window_days?:boolean | `@${string}`,
	items?:ResolverInputTypes["FormalizationIntegratorMetrics"],
	has_next?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Incentive"]: AliasType<{
	title_ptbr?:boolean | `@${string}`,
	description_ptbr?:boolean | `@${string}`,
	banner_url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TargetIncentiveSummary"]: AliasType<{
	campaign_id?:boolean | `@${string}`,
	incentive?:ResolverInputTypes["Incentive"],
		__typename?: boolean | `@${string}`
}>;
	["FileStatusType"]:FileStatusType;
	["DocumentStatusType"]:DocumentStatusType;
	["TypeSection"]:TypeSection;
	["MirrorStatuses"]:MirrorStatuses;
	["Status"]: AliasType<{
	description?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Document"]: AliasType<{
	filename?:boolean | `@${string}`,
	filetype?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	status?:ResolverInputTypes["Status"],
	type?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Section"]: AliasType<{
	documents?:ResolverInputTypes["Document"],
	id?:boolean | `@${string}`,
	status?:ResolverInputTypes["Status"],
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstallationStatus"]: AliasType<{
	description?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Installation"]: AliasType<{
	comment?:boolean | `@${string}`,
	concluded_at?:boolean | `@${string}`,
	grade?:boolean | `@${string}`,
	has_ampera?:boolean | `@${string}`,
	has_ampera_activated?:boolean | `@${string}`,
	has_minimal_projects?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	plant_id?:boolean | `@${string}`,
	plant_url?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	sections?:ResolverInputTypes["Section"],
	status?:ResolverInputTypes["InstallationStatus"],
	installed_inverters?:ResolverInputTypes["InstalledInverters"],
	stage?:boolean | `@${string}`,
	stage_updated_at?:boolean | `@${string}`,
	stage_error?:boolean | `@${string}`,
	stage_customer_phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormInverter"]: {
	id: number,
	quantity: number,
	power?: number | undefined | null
};
	["HardwareFormModule"]: {
	id: number,
	quantity: number,
	power?: number | undefined | null
};
	["HardwareFormComboEquipment"]: {
	sku: string,
	power?: number | undefined | null,
	quantity: number
};
	["HardwareFormBatteries"]: {
	id: number,
	quantity: number,
	power?: number | undefined | null
};
	["HardwareFormComboMetadata"]: {
	project_id: string,
	sku?: string | undefined | null,
	power?: number | undefined | null,
	price?: number | undefined | null,
	inverters: Array<ResolverInputTypes["HardwareFormComboEquipment"]>,
	modules: Array<ResolverInputTypes["HardwareFormComboEquipment"]>
};
	["HardwareFormInput"]: {
	is_combo: boolean,
	id?: string | undefined | null,
	combo_price?: number | undefined | null,
	inverter_type?: string | undefined | null,
	project_id: string,
	distributor_id: number,
	phase_id: number,
	inverters: Array<ResolverInputTypes["HardwareFormInverter"]>,
	modules: Array<ResolverInputTypes["HardwareFormModule"]>,
	batteries?: Array<ResolverInputTypes["HardwareFormBatteries"]> | undefined | null,
	combo_metadata?: ResolverInputTypes["HardwareFormComboMetadata"] | undefined | null,
	is_showcase?: boolean | undefined | null,
	shopping_cart_id?: string | undefined | null
};
	["HardwareFormShowcaseInput"]: {
	price?: number | undefined | null,
	project_id: string,
	inverters: Array<ResolverInputTypes["HardwareFormInverter"]>,
	modules: Array<ResolverInputTypes["HardwareFormModule"]>,
	shopping_cart_id?: string | undefined | null
};
	["ValidateTotalInvertersPowerInput"]: {
	project_id: string,
	total_inverters_power_kw: number
};
	["CustomerReprovalInput"]: {
	validation_message_id: string
};
	["BiometricValidationInput"]: {
	project_id: string
};
	["BiometricValidationStatus"]:BiometricValidationStatus;
	["BiometricValidationReason"]:BiometricValidationReason;
	["BiometricValidationResponse"]: AliasType<{
	reason?:boolean | `@${string}`,
	retry_after_seconds?:boolean | `@${string}`,
	retry_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateTotalInvertersPowerResponse"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	error?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormPricePerWatt"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormSystemPower"]: AliasType<{
	is_valid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormModules"]: AliasType<{
	price_per_watt?:ResolverInputTypes["ValidateHardwareFormPricePerWatt"],
	system_power?:ResolverInputTypes["ValidateHardwareFormSystemPower"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormOverload"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormInverters"]: AliasType<{
	overload?:ResolverInputTypes["ValidateHardwareFormOverload"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormCapacity"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	is_under_expected?:boolean | `@${string}`,
	is_over_expected?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormBatteries"]: AliasType<{
	capacity?:ResolverInputTypes["ValidateHardwareFormCapacity"],
		__typename?: boolean | `@${string}`
}>;
	["ValidateHardwareFormHardware"]: AliasType<{
	modules?:ResolverInputTypes["ValidateHardwareFormModules"],
	inverters?:ResolverInputTypes["ValidateHardwareFormInverters"],
	batteries?:ResolverInputTypes["ValidateHardwareFormBatteries"],
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormValidation"]: AliasType<{
	is_valid?:boolean | `@${string}`,
	hardware?:ResolverInputTypes["ValidateHardwareFormHardware"],
		__typename?: boolean | `@${string}`
}>;
	["HardwareFormShowcaseResponse"]: AliasType<{
	overload_is_valid?:boolean | `@${string}`,
	price_per_watt_is_valid?:boolean | `@${string}`,
	percentage_of_service_with_combo_is_valid?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MirrorStatus"]: AliasType<{
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["MirrorUploadResponse"]: AliasType<{
	id?:boolean | `@${string}`,
	url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["HardwareDraftEquipment"]: {
	sku: string,
	quantity: number,
	power?: number | undefined | null,
	model: string,
	brand: string
};
	["HardwareDraft"]: {
	project_id: string,
	sku?: string | undefined | null,
	power?: number | undefined | null,
	price?: number | undefined | null,
	inverters: Array<ResolverInputTypes["HardwareDraftEquipment"]>,
	modules: Array<ResolverInputTypes["HardwareDraftEquipment"]>
};
	["CreateInstalledInverterInput"]: {
	model?: string | undefined | null,
	power_kw: number,
	serial_number: string
};
	["CreateInstalledInverterWithBrandInput"]: {
	brand: string,
	model?: string | undefined | null,
	power_kw: number,
	serial_number: string
};
	["CreatedInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	installation_id?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	entry_mode?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UploadInstallationLabelsResponse"]: AliasType<{
	inverter_label_file?:boolean | `@${string}`,
	inverter_label_file_url?:boolean | `@${string}`,
	datalogger_label_file?:boolean | `@${string}`,
	datalogger_label_file_url?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstalledInverterGlobalStatus"]:InstalledInverterGlobalStatus;
	["InstalledInverterStatus"]:InstalledInverterStatus;
	["InstalledInverters"]: AliasType<{
	status?:boolean | `@${string}`,
	inverters?:ResolverInputTypes["InstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["InstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	datalogger_serial_number?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	entry_mode?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	updated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningCheckStatus"]:CommissioningCheckStatus;
	["CommissioningMonitoringStatus"]:CommissioningMonitoringStatus;
	["CommissioningFailureReason"]:CommissioningFailureReason;
	["CommissioningCheckResponse"]: AliasType<{
	checked_at?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	access_user?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InverterBrands"]: AliasType<{
	brands?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitItemCategory"]: AliasType<{
	id?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitItem"]: AliasType<{
	item_id?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	quantity?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	power?:boolean | `@${string}`,
	category?:ResolverInputTypes["AvailableOrderKitItemCategory"],
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitChannel"]: AliasType<{
	channel?:boolean | `@${string}`,
	source?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitCustomer"]: AliasType<{
	type?:boolean | `@${string}`,
	document_number?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	billing_type?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	ibge_code?:boolean | `@${string}`,
	zip_code?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitShipping"]: AliasType<{
	freight_type?:boolean | `@${string}`,
	freight_value?:boolean | `@${string}`,
	recipient_name?:boolean | `@${string}`,
	recipient_phone?:boolean | `@${string}`,
	recipient_email?:boolean | `@${string}`,
	rural_zone?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
	ibge_code?:boolean | `@${string}`,
	zip_code?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitUser"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	partner_cnpj?:boolean | `@${string}`,
	user_id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKitPayment"]: AliasType<{
	origin?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrderKit"]: AliasType<{
	error?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
	order_number?:boolean | `@${string}`,
	legacy_id?:boolean | `@${string}`,
	cart_id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	region?:boolean | `@${string}`,
	dc_id?:boolean | `@${string}`,
	reservation_id?:boolean | `@${string}`,
	raw_value?:boolean | `@${string}`,
	total_value?:boolean | `@${string}`,
	items?:ResolverInputTypes["AvailableOrderKitItem"],
	channel?:ResolverInputTypes["AvailableOrderKitChannel"],
	customer?:ResolverInputTypes["AvailableOrderKitCustomer"],
	shipping?:ResolverInputTypes["AvailableOrderKitShipping"],
	user?:ResolverInputTypes["AvailableOrderKitUser"],
	payment?:ResolverInputTypes["AvailableOrderKitPayment"],
	status?:boolean | `@${string}`,
	erp_code?:boolean | `@${string}`,
	erp_branch?:boolean | `@${string}`,
	summary?:boolean | `@${string}`,
	expires_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrder"]: AliasType<{
	order_id?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	expire_at?:boolean | `@${string}`,
	kit?:ResolverInputTypes["AvailableOrderKit"],
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrdersPagination"]: AliasType<{
	page?:boolean | `@${string}`,
	page_size?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
	has_next?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AvailableOrders"]: AliasType<{
	data?:ResolverInputTypes["AvailableOrder"],
	pagination?:ResolverInputTypes["AvailableOrdersPagination"],
		__typename?: boolean | `@${string}`
}>;
	["MonitoringInput"]: {
	brand: string,
	expected_plant_name?: string | undefined | null,
	inverters: Array<string>
};
	["CommissioningRequestInput"]: {
	installation_id: string,
	total_power_kw: number,
	monitorings: Array<ResolverInputTypes["MonitoringInput"]>
};
	["CommissioningInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningMonitoring"]: AliasType<{
	id?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	installed_inverters?:ResolverInputTypes["CommissioningInstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningRequestData"]: AliasType<{
	installation_id?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
	monitorings?:ResolverInputTypes["CommissioningMonitoring"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningRequestResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ResolverInputTypes["CommissioningRequestData"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningResetData"]: AliasType<{
	project_id?:boolean | `@${string}`,
	installation_id?:boolean | `@${string}`,
	removed_monitorings?:boolean | `@${string}`,
	removed_inverters?:boolean | `@${string}`,
	code?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningResetResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ResolverInputTypes["CommissioningResetData"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusInstalledInverter"]: AliasType<{
	id?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
	model?:boolean | `@${string}`,
	power_kw?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusMonitoring"]: AliasType<{
	brand?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	plant_name?:boolean | `@${string}`,
	commissioning_failure_reason?:boolean | `@${string}`,
	installed_inverters?:ResolverInputTypes["CommissioningStatusInstalledInverter"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningInstallationStatus"]:CommissioningInstallationStatus;
	["CommissioningStatusCustomerValidationRequest"]: AliasType<{
	id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	attempt_number?:boolean | `@${string}`,
	initiated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusData"]: AliasType<{
	installation_id?:boolean | `@${string}`,
	installation_status?:boolean | `@${string}`,
	access_user?:boolean | `@${string}`,
	monitorings?:ResolverInputTypes["CommissioningStatusMonitoring"],
	customer_validation_requests?:ResolverInputTypes["CommissioningStatusCustomerValidationRequest"],
		__typename?: boolean | `@${string}`
}>;
	["CommissioningStatusResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ResolverInputTypes["CommissioningStatusData"],
		__typename?: boolean | `@${string}`
}>;
	["LegacyFinancing"]: AliasType<{
	projectId?:boolean | `@${string}`,
	financingId?:boolean | `@${string}`,
	formalizedAt?:boolean | `@${string}`,
	stage?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationData"]: AliasType<{
	id?:boolean | `@${string}`,
	clickedAt?:boolean | `@${string}`,
	readAt?:boolean | `@${string}`,
	createdAt?:boolean | `@${string}`,
	notification?:ResolverInputTypes["Notification"],
		__typename?: boolean | `@${string}`
}>;
	["Notification"]: AliasType<{
	actionUrl?:boolean | `@${string}`,
	templateName?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Metrics"]: AliasType<{
	totalCount?:boolean | `@${string}`,
	totalUnreadCount?:boolean | `@${string}`,
	totalUnclickedCount?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["NotificationsList"]: AliasType<{
	count?:boolean | `@${string}`,
	totalCount?:boolean | `@${string}`,
	nextCursor?:boolean | `@${string}`,
	nextPage?:boolean | `@${string}`,
	previousCursor?:boolean | `@${string}`,
	previousPage?:boolean | `@${string}`,
	data?:ResolverInputTypes["NotificationData"],
	metrics?:ResolverInputTypes["Metrics"],
		__typename?: boolean | `@${string}`
}>;
	["ContactPartner"]: AliasType<{
	phone?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Address"]: AliasType<{
	street?:boolean | `@${string}`,
	number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	reference?:boolean | `@${string}`,
	district?:boolean | `@${string}`,
	zipcode?:boolean | `@${string}`,
	city?:boolean | `@${string}`,
	state?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ResponsiblePartner"]: AliasType<{
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	contact?:ResolverInputTypes["ContactPartner"],
		__typename?: boolean | `@${string}`
}>;
	["Permission"]: AliasType<{
	store?:boolean | `@${string}`,
	financing?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Sfplus"]: AliasType<{
	level?:boolean | `@${string}`,
	is_level_black?:boolean | `@${string}`,
	next_transition_date?:boolean | `@${string}`,
	score?:ResolverInputTypes["Score"],
	black_status?:ResolverInputTypes["LevelBlackStatus"],
	downgrade?:ResolverInputTypes["Downgrade"],
		__typename?: boolean | `@${string}`
}>;
	["OnlyPartner"]: AliasType<{
	id?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	trade_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	state_registration?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	operation_term_accepted?:boolean | `@${string}`,
	address?:ResolverInputTypes["Address"],
	responsible?:ResolverInputTypes["ResponsiblePartner"],
	permission?:ResolverInputTypes["Permission"],
	sfplus?:ResolverInputTypes["Sfplus"],
	blocklist?:ResolverInputTypes["PartnerBlocklist"],
	registration_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerBlocklist"]: AliasType<{
	is_blocked?:boolean | `@${string}`,
	nature?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	action?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CorePartner"]: AliasType<{
	id?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	responsible?:ResolverInputTypes["CoreParterResponsible"],
	company_name?:boolean | `@${string}`,
	fantasy_name?:boolean | `@${string}`,
	status?:ResolverInputTypes["CoreParterStatus"],
		__typename?: boolean | `@${string}`
}>;
	["CoreParterResponsible"]: AliasType<{
	id?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoreParterStatus"]: AliasType<{
	active?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	date?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CoreGetPartnersInput"]: {
	page?: number | undefined | null,
	search_term?: string | undefined | null
};
	["PaymentCurrentIssuanceModel"]: AliasType<{
	payout_options?:boolean | `@${string}`,
	best_payout_option?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectProposal"]: AliasType<{
	value_changed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectPersonType"]:ProjectPersonType;
	["ProjectSystemType"]:ProjectSystemType;
	["AppliedModifierOption"]: AliasType<{
	type?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AppliedModifier"]: AliasType<{
	name?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	options?:ResolverInputTypes["AppliedModifierOption"],
		__typename?: boolean | `@${string}`
}>;
	["AddonProduct"]: AliasType<{
	id?:boolean | `@${string}`,
	product_name?:boolean | `@${string}`,
	product_external_id?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
	product_slug?:boolean | `@${string}`,
	applied?:boolean | `@${string}`,
	partner_commission?:boolean | `@${string}`,
	installment_price?:boolean | `@${string}`,
	total_price?:boolean | `@${string}`,
	monthly_interest_rate?:boolean | `@${string}`,
	engine_simulation_id?:boolean | `@${string}`,
	previous_engine_simulation_id?:boolean | `@${string}`,
	cet?:boolean | `@${string}`,
	applied_modifiers?:ResolverInputTypes["AppliedModifier"],
	addon_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["SelectedInstallments"]: AliasType<{
	cet?:boolean | `@${string}`,
	iof?:boolean | `@${string}`,
	ipca?:boolean | `@${string}`,
	addons?:ResolverInputTypes["AddonProduct"],
	aggregated_addons?:ResolverInputTypes["AddonProduct"],
	user_id?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
	aliquot_iof?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	due_day?:boolean | `@${string}`,
	first_due_date?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	interest_rate?:boolean | `@${string}`,
	cet_percentage?:boolean | `@${string}`,
	commission_raw?:boolean | `@${string}`,
	financing_value?:boolean | `@${string}`,
	taxa_de_cadastro?:boolean | `@${string}`,
	taxa_de_juros?:boolean | `@${string}`,
	installment_value?:boolean | `@${string}`,
	is_from_suggested?:boolean | `@${string}`,
	registration_fee_gross?:boolean | `@${string}`,
	registration_fee_raw_dry?:boolean | `@${string}`,
	registration_fee_raw_final?:boolean | `@${string}`,
	is_combo_connect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RiskInfo"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	todo?:boolean | `@${string}`,
	reason?:boolean | `@${string}`,
	decision?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["BNPL"]: AliasType<{
	decision_pre_analysis?:boolean | `@${string}`,
	min_entry_value?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Guarantor"]: AliasType<{
	id?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birth_date?:boolean | `@${string}`,
	border_line?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	customer_second_financing_policy?:boolean | `@${string}`,
	decision_pre_analysis?:boolean | `@${string}`,
	max_approved_project_value?:boolean | `@${string}`,
	max_financing_value?:boolean | `@${string}`,
	max_grace_period?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	min_approved_project_value?:boolean | `@${string}`,
	min_installment_value?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	project_state?:boolean | `@${string}`,
	risk_class?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["InstallmentsConditions"]: AliasType<{
	suggested_installments?:boolean | `@${string}`,
	suggested_installments_value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Project"]: AliasType<{
	id?:boolean | `@${string}`,
	user_id?:boolean | `@${string}`,
	partner_id?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	representative_document?:boolean | `@${string}`,
	project_value?:boolean | `@${string}`,
	system_power?:boolean | `@${string}`,
	system_type?:boolean | `@${string}`,
	grace_period?:boolean | `@${string}`,
	down_payment?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_status?:boolean | `@${string}`,
	min_installments?:boolean | `@${string}`,
	max_installments?:boolean | `@${string}`,
	max_grace_period?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	project_state?:boolean | `@${string}`,
	partner_profile?:boolean | `@${string}`,
	pre_approved_value?:boolean | `@${string}`,
	products_applieds?:boolean | `@${string}`,
	installments?:boolean | `@${string}`,
	risk_info?:ResolverInputTypes["RiskInfo"],
	state_registration?:boolean | `@${string}`,
	complete?:boolean | `@${string}`,
	selected_installments?:ResolverInputTypes["SelectedInstallments"],
	guarantor?:ResolverInputTypes["Guarantor"],
	birth_date?:boolean | `@${string}`,
	decision_pre_analysis?:boolean | `@${string}`,
	score_sol_facil?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	addons?:ResolverInputTypes["AddonProduct"],
	max_approved_project_value?:boolean | `@${string}`,
	min_approved_project_value?:boolean | `@${string}`,
	max_financing_value?:boolean | `@${string}`,
	border_line?:boolean | `@${string}`,
	is_formalized?:boolean | `@${string}`,
	new_journey?:boolean | `@${string}`,
	formalized_at?:boolean | `@${string}`,
	shopping_cart_id?:boolean | `@${string}`,
	bnpl?:ResolverInputTypes["BNPL"],
	bnpl_simulation_id?:boolean | `@${string}`,
	bnpl_status?:boolean | `@${string}`,
	is_onflex_partner?:boolean | `@${string}`,
	is_turbo_prime?:boolean | `@${string}`,
	can_select_ampera?:boolean | `@${string}`,
	has_energy_bill_analysis?:boolean | `@${string}`,
	insurance_commission?:boolean | `@${string}`,
	gained_points?:boolean | `@${string}`,
	original_installment_value?:boolean | `@${string}`,
	is_contract_signed?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	risk_class?:boolean | `@${string}`,
	selected_installment?:boolean | `@${string}`,
	credit_analysis_status?:boolean | `@${string}`,
	bill_value?:boolean | `@${string}`,
	installments_conditions?:ResolverInputTypes["InstallmentsConditions"],
		__typename?: boolean | `@${string}`
}>;
	["ProjectProposalUpdatePayloadInput"]: {
	engine_simulation_id: string,
	simulation_id: string,
	is_combo: boolean,
	is_ampera: boolean,
	commission: number,
	applied_addons: Array<string>
};
	["ProjectProposalUpdateResponse"]: AliasType<{
	engine_simulation_id?:boolean | `@${string}`,
	simulation_id?:boolean | `@${string}`,
	project_id?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	is_ampera?:boolean | `@${string}`,
	commission?:boolean | `@${string}`,
	applied_addons?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["IsComboResponse"]: AliasType<{
	data?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ProjectCreateInput"]: {
	person_type: ResolverInputTypes["ProjectPersonType"],
	project_name?: string | undefined | null,
	document: string,
	project_value: number,
	down_payment: number,
	partner_id: number,
	user_id: number,
	representative_document?: string | undefined | null,
	system_power: number,
	new_journey: boolean,
	shopping_cart_id?: string | undefined | null,
	provider: string,
	bill_value: number,
	system_type: ResolverInputTypes["ProjectSystemType"],
	engine_pricing?: string | undefined | null
};
	["ProjectCreateStatus"]:ProjectCreateStatus;
	["ProjectCreateResponse"]: AliasType<{
	status?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewAll"]: AliasType<{
	total?:boolean | `@${string}`,
	in_progress?:boolean | `@${string}`,
	in_reassassement?:boolean | `@${string}`,
	finish?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewSimulation"]: AliasType<{
	total?:boolean | `@${string}`,
	approved?:boolean | `@${string}`,
	reassassement?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewProposal"]: AliasType<{
	total?:boolean | `@${string}`,
	in_equipments?:boolean | `@${string}`,
	in_customer_data?:boolean | `@${string}`,
	in_biometry_and_contract?:boolean | `@${string}`,
	in_payment_model?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverviewInstallation"]: AliasType<{
	total?:boolean | `@${string}`,
	in_progress?:boolean | `@${string}`,
	canceled?:boolean | `@${string}`,
	expired?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["PartnerOverview"]: AliasType<{
	partner_id?:boolean | `@${string}`,
	all?:ResolverInputTypes["PartnerOverviewAll"],
	simulation?:ResolverInputTypes["PartnerOverviewSimulation"],
	proposal?:ResolverInputTypes["PartnerOverviewProposal"],
	installation?:ResolverInputTypes["PartnerOverviewInstallation"],
	status?:boolean | `@${string}`,
	last_updated_at?:boolean | `@${string}`,
	next_update_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationPersonType"]:RegistrationPersonType;
	["RegistrationDocumentTypes"]:RegistrationDocumentTypes;
	["RegistrationRepresentantTypes"]:RegistrationRepresentantTypes;
	["RegistrationContact"]: AliasType<{
	email?:boolean | `@${string}`,
	phone?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddressCity"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddressState"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationDocumentModel"]:RegistrationDocumentModel;
	["RegistrationElectricityBill"]: AliasType<{
	holder_cpf?:boolean | `@${string}`,
	is_under_customer_name?:boolean | `@${string}`,
	distributor_id?:boolean | `@${string}`,
	inverters_power_above_limit?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationElectricityBillWithDocuments"]: AliasType<{
	id?:boolean | `@${string}`,
	holder_cpf?:boolean | `@${string}`,
	is_under_customer_name?:boolean | `@${string}`,
	documents?:ResolverInputTypes["RegistrationDocument"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationDocument"]: AliasType<{
	type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	filename?:boolean | `@${string}`,
	url_download?:boolean | `@${string}`,
	url_preview?:boolean | `@${string}`,
	mime_type?:boolean | `@${string}`,
	docstorage_id?:boolean | `@${string}`,
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationAddress"]: AliasType<{
	zipcode?:boolean | `@${string}`,
	street?:boolean | `@${string}`,
	street_number?:boolean | `@${string}`,
	complement?:boolean | `@${string}`,
	neighborhood?:boolean | `@${string}`,
	city_id?:boolean | `@${string}`,
	state_id?:boolean | `@${string}`,
	city?:ResolverInputTypes["RegistrationAddressCity"],
	state?:ResolverInputTypes["RegistrationAddressState"],
	is_rural?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationProject"]: AliasType<{
	address?:ResolverInputTypes["RegistrationAddress"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	electricity_bill?:ResolverInputTypes["RegistrationElectricityBill"],
	residencial_is_the_same_of_plant?:boolean | `@${string}`,
	comment?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCustomer"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["RegistrationContact"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	document_type?:boolean | `@${string}`,
	address?:ResolverInputTypes["RegistrationAddress"],
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCompany"]: AliasType<{
	company_name?:boolean | `@${string}`,
	cnpj?:boolean | `@${string}`,
	contact?:ResolverInputTypes["RegistrationContact"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	majority_partner?:ResolverInputTypes["RegistrationCompanyMajorityPartner"],
	legal_representatives?:ResolverInputTypes["RegistrationLegalRepresentative"],
	majority_partner_is_legal_representative?:boolean | `@${string}`,
	is_only_one_legal_representative?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationLegalRepresentative"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["RegistrationContact"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	address?:ResolverInputTypes["RegistrationAddress"],
	kind?:boolean | `@${string}`,
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationCompanyMajorityPartner"]: AliasType<{
	cpf?:boolean | `@${string}`,
	is_legal_representative?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["RegistrationContact"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	address?:ResolverInputTypes["RegistrationAddress"],
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationGuarantor"]: AliasType<{
	cpf?:boolean | `@${string}`,
	full_name?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	contact?:ResolverInputTypes["RegistrationContact"],
	documents?:ResolverInputTypes["RegistrationDocument"],
	address?:ResolverInputTypes["RegistrationAddress"],
	document_type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationError"]: AliasType<{
	title?:boolean | `@${string}`,
	description?:boolean | `@${string}`,
	field?:boolean | `@${string}`,
	type?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegistrationUpdateInput"]: {
	project_id: string
};
	["RegistrationDetailsResponse"]: AliasType<{
	project_id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	is_combo?:boolean | `@${string}`,
	remaining_changes_after_confirmation?:boolean | `@${string}`,
	person_type?:boolean | `@${string}`,
	customer?:ResolverInputTypes["RegistrationCustomer"],
	company?:ResolverInputTypes["RegistrationCompany"],
	guarantor?:ResolverInputTypes["RegistrationGuarantor"],
	project?:ResolverInputTypes["RegistrationProject"],
	errors?:ResolverInputTypes["RegistrationError"],
	electricity_bills?:ResolverInputTypes["RegistrationElectricityBillWithDocuments"],
	has_other_beneficiary_units?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	/** Display mode of the grid access approval (parecer de acesso) field for the installation site.
HIDDEN: the field is not shown. SHOW: the field is optional. SHOW_REQUIRED: the field is required. */
["GridAccessApprovalDisplayMode"]:GridAccessApprovalDisplayMode;
	["RegistrationGridAccessApproval"]: AliasType<{
	display_mode?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationStatus"]:RevalidationStatus;
	["AttemptStatus"]:AttemptStatus;
	["RevalidationStatusCount"]: AliasType<{
	status?:boolean | `@${string}`,
	count?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationBrandSummary"]: AliasType<{
	brand?:boolean | `@${string}`,
	total?:boolean | `@${string}`,
	statuses?:ResolverInputTypes["RevalidationStatusCount"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSummary"]: AliasType<{
	total?:boolean | `@${string}`,
	statuses?:ResolverInputTypes["RevalidationStatusCount"],
	brands?:ResolverInputTypes["RevalidationBrandSummary"],
		__typename?: boolean | `@${string}`
}>;
	["LatestSubmission"]: AliasType<{
	serial_number?:boolean | `@${string}`,
	attempt_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LatestAttempt"]: AliasType<{
	serial_number?:boolean | `@${string}`,
	attempt_status?:boolean | `@${string}`,
	brand?:boolean | `@${string}`,
	submitted_at?:boolean | `@${string}`,
	processed_at?:boolean | `@${string}`,
	reason_code?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationItem"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
	project_name?:boolean | `@${string}`,
	plant_name?:boolean | `@${string}`,
	reference_inverter_brand?:boolean | `@${string}`,
	expected_total_inverters?:boolean | `@${string}`,
	latest_submission?:ResolverInputTypes["LatestSubmission"],
	latest_attempts?:ResolverInputTypes["LatestAttempt"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationPagination"]: AliasType<{
	page?:boolean | `@${string}`,
	page_size?:boolean | `@${string}`,
	total_items?:boolean | `@${string}`,
	total_pages?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationsListResponse"]: AliasType<{
	items?:ResolverInputTypes["RevalidationItem"],
	pagination?:ResolverInputTypes["RevalidationPagination"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationsInput"]: {
	status?: Array<ResolverInputTypes["RevalidationStatus"]> | undefined | null,
	brand?: string | undefined | null,
	sort?: string | undefined | null,
	page?: number | undefined | null,
	page_size?: number | undefined | null
};
	["RegisterRevalidationCredentialInput"]: {
	brand: string,
	username: string,
	password: string
};
	["RegisterRevalidationCredentialErrorCode"]:RegisterRevalidationCredentialErrorCode;
	["RegisterRevalidationCredentialResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionDeviceInput"]: {
	brand: string,
	serial_number: string
};
	["RevalidationSubmissionInput"]: {
	revalidation_id: string,
	monitoring_plant_name: string,
	devices: Array<ResolverInputTypes["RevalidationSubmissionDeviceInput"]>
};
	["SubmitRevalidationsInput"]: {
	platform_access_token: string,
	submissions: Array<ResolverInputTypes["RevalidationSubmissionInput"]>
};
	["RevalidationSubmissionAccepted"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	submission_number?:boolean | `@${string}`,
	total_devices?:boolean | `@${string}`,
	revalidation_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionError"]: AliasType<{
	code?:boolean | `@${string}`,
	detail?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionDevice"]: AliasType<{
	brand?:boolean | `@${string}`,
	serial_number?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionRejected"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	errors?:ResolverInputTypes["RevalidationSubmissionError"],
	devices?:ResolverInputTypes["RevalidationSubmissionDevice"],
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionReferenceBrandUpdated"]: AliasType<{
	revalidation_id?:boolean | `@${string}`,
	reference_inverter_brand?:boolean | `@${string}`,
	revalidation_status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RevalidationSubmissionsData"]: AliasType<{
	accepted?:ResolverInputTypes["RevalidationSubmissionAccepted"],
	rejected?:ResolverInputTypes["RevalidationSubmissionRejected"],
	reference_brand_updated?:ResolverInputTypes["RevalidationSubmissionReferenceBrandUpdated"],
		__typename?: boolean | `@${string}`
}>;
	["SubmitRevalidationsResponse"]: AliasType<{
	success?:boolean | `@${string}`,
	message?:boolean | `@${string}`,
	data?:ResolverInputTypes["RevalidationSubmissionsData"],
		__typename?: boolean | `@${string}`
}>;
	["AnalyzeEnergyBillInput"]: {
	person_type: string,
	project_id: string,
	document_customer: string,
	financing_id: number,
	document_owner_energy_bill: string,
	auto_cancel_flow_on_rejection: boolean
};
	["GetOpportunitiesInput"]: {
	financing_value: number,
	partner_id: number,
	project_type: string
};
	["EnergyBillAnalysisDecision"]: AliasType<{
	decision?:boolean | `@${string}`,
	details?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GetOpportunitiesResponse"]: AliasType<{
	addons_opportunities?:ResolverInputTypes["AddonsOpportunities"],
	financing_gained_points?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["AddonsOpportunities"]: AliasType<{
	addon_type?:boolean | `@${string}`,
	gained_points?:boolean | `@${string}`,
	product_slug?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["LevelBlackStatus"]: AliasType<{
	kwGoalMonth?:boolean | `@${string}`,
	kwReachedMonth?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Contact"]: AliasType<{
	landline?:boolean | `@${string}`,
	mobile?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Responsible"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	contact?:ResolverInputTypes["Contact"],
	partner?:ResolverInputTypes["Partner"],
		__typename?: boolean | `@${string}`
}>;
	["Score"]: AliasType<{
	current?:boolean | `@${string}`,
	goal?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Downgrade"]: AliasType<{
	has_risk?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Partner"]: AliasType<{
	id?:boolean | `@${string}`,
	corporate_name?:boolean | `@${string}`,
	operation_term_accepted?:boolean | `@${string}`,
	trade_name?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	category?:boolean | `@${string}`,
	state_registration?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	address?:ResolverInputTypes["Address"],
	responsible?:ResolverInputTypes["Responsible"],
	permission?:ResolverInputTypes["Permission"],
	users?:ResolverInputTypes["User"],
	sfplus?:ResolverInputTypes["Sfplus"],
		__typename?: boolean | `@${string}`
}>;
	["Post"]: AliasType<{
	id?:boolean | `@${string}`,
	title?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
	userId?:boolean | `@${string}`,
	comments?:ResolverInputTypes["Comment"],
		__typename?: boolean | `@${string}`
}>;
	["Comment"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
	body?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["OperatingAgreement"]: AliasType<{
	is_current_term_accepted?:boolean | `@${string}`,
	can_accept?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UserTerms"]: AliasType<{
	operating_agreement?:ResolverInputTypes["OperatingAgreement"],
		__typename?: boolean | `@${string}`
}>;
	["User"]: AliasType<{
	id?:boolean | `@${string}`,
	username?:boolean | `@${string}`,
	profile?:boolean | `@${string}`,
	fullname?:boolean | `@${string}`,
	document?:boolean | `@${string}`,
	birthdate?:boolean | `@${string}`,
	active?:boolean | `@${string}`,
	created_at?:boolean | `@${string}`,
	contact?:ResolverInputTypes["Contact"],
	partner?:ResolverInputTypes["Partner"],
	posts?:ResolverInputTypes["Post"],
	terms?:ResolverInputTypes["UserTerms"],
		__typename?: boolean | `@${string}`
}>;
	/** Estados que o portal NAO tem como deduzir — o backend manda, o portal traduz.

WalletPaymentModelSummary.state   ENABLED | MODEL_DISABLED | NOVICE | ESSENTIAL_PROFILE
                                  | COMMERCIAL_EXCEPTION | BLOCKED
WalletPaymentModelCard.state      ENABLED | DEFAULT | LOCKED | DISABLED | BLOCKED | WAIVED */
["WalletPaymentModelSummary"]: AliasType<{
	/** Qual das 7 variantes do card do Resumo renderizar (Figma: MR overview card). */
	state?:boolean | `@${string}`,
	/** null quando state = BLOCKED — o corpo do card vira empty state. */
	current_model?:boolean | `@${string}`,
	upfront_percentage?:boolean | `@${string}`,
	after_completion_percentage?:boolean | `@${string}`,
	/** Vem calculado do backend (que repassa o lambda). O portal NAO divide
on_time_completed/total_completed em lugar nenhum.
null quando state = NOVICE ou ESSENTIAL_PROFILE: o Figma tira o bloco de desempenho. */
	performance_percentage?:boolean | `@${string}`,
	/** Qual modelo foi desabilitado apesar do desempenho. So com state = MODEL_DISABLED. */
	disabled_model?:boolean | `@${string}`,
	/** Motivo, para 'O Modelo A foi desabilitado · Motivo: inadimplência da carteira em alerta'. */
	disabled_reason?:boolean | `@${string}`,
	/** O '3' de '3 de 5 realizadas'. So com state = NOVICE. */
	novice_completed?:boolean | `@${string}`,
	total_completed?:boolean | `@${string}`,
	on_time_completed?:boolean | `@${string}`,
	next_model?:boolean | `@${string}`,
	projects_needed_for_next_model?:boolean | `@${string}`,
	is_blocked?:boolean | `@${string}`,
	block_reason?:boolean | `@${string}`,
	updated_at?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentModelCard"]: AliasType<{
	key?:boolean | `@${string}`,
	upfront_percentage?:boolean | `@${string}`,
	after_completion_percentage?:boolean | `@${string}`,
	min_on_time_percentage?:boolean | `@${string}`,
	is_current?:boolean | `@${string}`,
	/** Substitui is_default e is_unlocked:
  LOCKED   — elegivel, ainda nao alcancou
  DISABLED — alcancou, mas um requisito entrou em alerta/critico
  BLOCKED  — conta bloqueada por fraude, atraso critico ou saude do CNPJ
Mais ENABLED, DEFAULT (so o C) e WAIVED (flexibilizacao comercial). */
	state?:boolean | `@${string}`,
	requirements?:ResolverInputTypes["WalletModelRequirement"],
		__typename?: boolean | `@${string}`
}>;
	["WalletModelRequirement"]: AliasType<{
	code?:boolean | `@${string}`,
	/** O que varia por parceiro. O portal nunca deduz isto comparando percentuais. */
	is_met?:boolean | `@${string}`,
	/** true = o portal RISCA o texto da linha (flexibilizacao comercial ativa). */
	is_waived?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletDefaultModelCondition"]: AliasType<{
	code?:boolean | `@${string}`,
	value?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentPerformance"]: AliasType<{
	total_completed?:boolean | `@${string}`,
	on_time_completed?:boolean | `@${string}`,
	late_completed?:boolean | `@${string}`,
	/** Vem calculado do backend. O portal nao divide os contadores. */
	on_time_percentage?:boolean | `@${string}`,
	thresholds?:ResolverInputTypes["WalletPerformanceThresholds"],
	challenge?:ResolverInputTypes["WalletPerformanceChallenge"],
	by_kit_type?:ResolverInputTypes["WalletPerformanceByKitType"],
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceThresholds"]: AliasType<{
	model_b?:boolean | `@${string}`,
	model_a?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceChallenge"]: AliasType<{
	target_model?:boolean | `@${string}`,
	projects_needed?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletPerformanceByKitType"]: AliasType<{
	kit_type?:boolean | `@${string}`,
	on_time_count?:boolean | `@${string}`,
	late_count?:boolean | `@${string}`,
	projects_filter?:ResolverInputTypes["WalletProjectsFilter"],
		__typename?: boolean | `@${string}`
}>;
	["WalletProjectsFilter"]: AliasType<{
	kit_type?:boolean | `@${string}`,
	status?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletCommercialException"]: AliasType<{
	is_active?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["WalletEligibilityContext"]: AliasType<{
	partner_profile?:boolean | `@${string}`,
	is_novice?:boolean | `@${string}`,
	novice_completed?:boolean | `@${string}`,
	novice_required?:boolean | `@${string}`,
	performance_model?:boolean | `@${string}`,
	delinquency_status?:boolean | `@${string}`,
	commercial_exception?:ResolverInputTypes["WalletCommercialException"],
		__typename?: boolean | `@${string}`
}>;
	["WalletPaymentModel"]: AliasType<{
	summary?:ResolverInputTypes["WalletPaymentModelSummary"],
	models?:ResolverInputTypes["WalletPaymentModelCard"],
	default_model_conditions?:ResolverInputTypes["WalletDefaultModelCondition"],
	performance?:ResolverInputTypes["WalletPaymentPerformance"],
	eligibility_context?:ResolverInputTypes["WalletEligibilityContext"],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
		__typename?: boolean | `@${string}`
}>
  }

export type ModelTypes = {
    ["Order"]:Order;
	/** The `Upload` scalar type represents a file upload. */
["Upload"]:any;
	["Combos"]: {
		data: ModelTypes["ComboData"]
};
	["Cities"]: {
		data: Array<ModelTypes["CityStateData"]>
};
	["AddressInstallation"]: {
		data: ModelTypes["AddressInstallationData"]
};
	["ComboData"]: {
		nationality?: Array<ModelTypes["CityStateData"] | undefined> | undefined,
	gender?: Array<ModelTypes["CityStateData"] | undefined> | undefined,
	occupation?: Array<ModelTypes["CityStateData"] | undefined> | undefined,
	state?: Array<ModelTypes["CityStateData"] | undefined> | undefined
};
	["CepAddress"]: {
		neighborhood: string,
	street: string,
	state: ModelTypes["CityStateData"],
	city: ModelTypes["CityStateData"]
};
	["AddressInstallationData"]: {
		postal_code: string,
	street: string,
	street_number: number,
	additional_info?: string | undefined,
	neighborhood: string,
	city: string,
	state: string,
	rural_area: boolean
};
	["CityStateData"]: {
		name: string,
	id: string
};
	["Query"]: {
		/** Get customer registration combos
param: nationality: boolean - if want nationality
param: gender: boolean - if want gender
param: occupation: boolean - if want occupation
param: state: boolean - if want state */
	address_combos: ModelTypes["Combos"],
	/** Get cities based on state
param: state_id: int - id of state */
	address_cities: ModelTypes["Cities"],
	/** Get address information from CEP
param: cep: string - address CEP */
	address_from_cep: ModelTypes["CepAddress"],
	/** Get installation address
param: project_id: string - id of project */
	address_installation: ModelTypes["AddressInstallation"],
	customer_form?: ModelTypes["CustomerFormResponse"] | undefined,
	access_user_credentials: ModelTypes["AccessUserCredentialsResponse"],
	credentials_check: ModelTypes["CredentialsCheckResponse"],
	documents?: ModelTypes["DocumentResponse"] | undefined,
	financing?: ModelTypes["Financing"] | undefined,
	financingV2?: ModelTypes["FinancingV2"] | undefined,
	financings: ModelTypes["FinancingsList"],
	financing_type?: ModelTypes["FinancingType"] | undefined,
	formalization: ModelTypes["FormalizationInfo"],
	formalization_biometry_confirm: ModelTypes["ConfirmBiometryResponse"],
	formalization_v2: ModelTypes["FormalizedFinancing"],
	formalization_metrics: ModelTypes["FormalizationMetricsResponse"],
	targetIncentivesSummary?: ModelTypes["TargetIncentiveSummary"] | undefined,
	getCommissioningStatus: ModelTypes["CommissioningStatusResponse"],
	installation?: ModelTypes["Installation"] | undefined,
	mirrorStatus?: ModelTypes["MirrorStatus"] | undefined,
	inverter_brands: ModelTypes["InverterBrands"],
	available_orders?: ModelTypes["AvailableOrders"] | undefined,
	legacyFinancing?: ModelTypes["LegacyFinancing"] | undefined,
	notifications: ModelTypes["NotificationsList"],
	partner?: ModelTypes["OnlyPartner"] | undefined,
	partners?: Array<ModelTypes["CorePartner"]> | undefined,
	payment_current_issuance_model?: ModelTypes["PaymentCurrentIssuanceModel"] | undefined,
	projects_partner_overview: ModelTypes["PartnerOverview"],
	project?: ModelTypes["Project"] | undefined,
	project_proposal_changes?: ModelTypes["ProjectProposal"] | undefined,
	project_is_combo?: ModelTypes["IsComboResponse"] | undefined,
	project_system_types: Array<string>,
	registration?: ModelTypes["RegistrationDetailsResponse"] | undefined,
	/** Whether the grid access approval is hidden, optional or required for the project and the
installation site. city: city name; state: UF, two uppercase letters. */
	registration_grid_access_approval: ModelTypes["RegistrationGridAccessApproval"],
	risk_financing_revalidation_summary?: ModelTypes["RevalidationSummary"] | undefined,
	risk_financing_revalidations: ModelTypes["RevalidationsListResponse"],
	getOpportunities?: ModelTypes["GetOpportunitiesResponse"] | undefined,
	simulation_project_shopping_cart_id_get?: string | undefined,
	user?: ModelTypes["User"] | undefined,
	/** Aba Modelo de recebimento (entrega 1). Fonte: ip.ipa.receipt-model.
partner_id e OPCIONAL e so e honrado quando ctx.user.profile == 'admin' (impersonate).
Para qualquer outro perfil o argumento e IGNORADO e vale ctx.user.partner.id.
Erro do REST: retorna null + errors[] (nunca null silencioso). */
	wallet_payment_model?: ModelTypes["WalletPaymentModel"] | undefined
};
	["PersonTypes"]:PersonTypes;
	["DocumentTypes"]:DocumentTypes;
	["LegalRepresentantTypes"]:LegalRepresentantTypes;
	["CustomerStatus"]:CustomerStatus;
	["RegistrationContactChangeResponse"]: {
		message: string,
	status?: number | undefined
};
	["CustomerFormResponse"]: {
		project_id: string,
	is_combo?: boolean | undefined,
	person_type?: ModelTypes["PersonTypes"] | undefined,
	customer?: ModelTypes["CustomerData"] | undefined,
	guarantor?: ModelTypes["CustomerData"] | undefined,
	project?: ModelTypes["CustomerProject"] | undefined,
	remaining_changes_after_confirmation?: number | undefined,
	company?: ModelTypes["CompanyData"] | undefined,
	errors?: Array<ModelTypes["CustomerErrors"] | undefined> | undefined,
	status?: ModelTypes["CustomerStatus"] | undefined
};
	["CustomerErrors"]: {
		field: string,
	title: string,
	description: string
};
	["CustomerContact"]: {
		email?: string | undefined,
	phone?: string | undefined
};
	["CustomerDocument"]: {
		type: ModelTypes["DocumentTypes"],
	status: string,
	filename: string,
	url_download: string,
	url_preview: string,
	mime_type: string,
	id: string
};
	["CustomerAddress"]: {
		zipcode?: string | undefined,
	street?: string | undefined,
	street_number?: string | undefined,
	complement?: string | undefined,
	neighborhood?: string | undefined,
	city_id?: number | undefined,
	state_id?: number | undefined,
	city?: ModelTypes["CustomerIdName"] | undefined,
	state?: ModelTypes["CustomerIdName"] | undefined,
	is_rural?: boolean | undefined
};
	["CustomerData"]: {
		cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["CustomerContact"] | undefined,
	documents?: Array<ModelTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: ModelTypes["CustomerAddress"] | undefined
};
	["CustomerEletricityBill"]: {
		is_under_customer_name?: boolean | undefined,
	holder_cpf?: string | undefined,
	distributor_id?: number | undefined
};
	["CustomerProject"]: {
		address?: ModelTypes["CustomerAddress"] | undefined,
	documents?: Array<ModelTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	electricity_bill?: ModelTypes["CustomerEletricityBill"] | undefined,
	residencial_is_the_same_of_plant?: boolean | undefined
};
	["CompanyMajorityPartner"]: {
		cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["CustomerContact"] | undefined,
	documents?: Array<ModelTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: ModelTypes["CustomerAddress"] | undefined
};
	["CompanyLegalRepresentant"]: {
		kind?: ModelTypes["LegalRepresentantTypes"] | undefined,
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["CustomerContact"] | undefined,
	documents?: Array<ModelTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: ModelTypes["CustomerAddress"] | undefined
};
	["CompanyData"]: {
		company_name?: string | undefined,
	cnpj?: string | undefined,
	contact?: ModelTypes["CustomerContact"] | undefined,
	documents?: Array<ModelTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	majority_partner?: ModelTypes["CompanyMajorityPartner"] | undefined,
	majority_partner_is_legal_representative?: boolean | undefined,
	is_only_one_legal_representative?: boolean | undefined,
	legal_representatives?: Array<ModelTypes["CompanyLegalRepresentant"] | undefined> | undefined
};
	["RegistrationV2PersonType"]:RegistrationV2PersonType;
	["CustomerIdName"]: {
		id: number,
	name: string
};
	["CustomerRegistrationAddress"]: {
	zipcode: string,
	street: string,
	street_number: string,
	complement?: string | undefined,
	neighborhood: string,
	city_id: number,
	state_id: number,
	is_rural?: boolean | undefined
};
	["CustomerRegistrationContact"]: {
	email: string,
	phone: string
};
	["CustomerRegistrationDocument"]: {
	type: string,
	docstorage_id: string
};
	["CustomerRegistrationCustomer"]: {
	full_name: string,
	birthdate: string,
	contact: ModelTypes["CustomerRegistrationContact"],
	documents: Array<ModelTypes["CustomerRegistrationDocument"]>,
	address: ModelTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationGuarantor"]: {
	full_name: string,
	birthdate: string,
	contact: ModelTypes["CustomerRegistrationContact"],
	documents: Array<ModelTypes["CustomerRegistrationDocument"]>,
	address: ModelTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationElectricityBill"]: {
	is_under_customer_name: boolean,
	holder_cpf?: string | undefined,
	distributor_id?: number | undefined
};
	["CustomerRegistrationElectricityBillWithDocuments"]: {
	electricity_bill_docstorage_id: string,
	employment_proof_docstorage_id?: string | undefined,
	additional_document_docstorage_id?: string | undefined,
	holder_cpf?: string | undefined,
	is_under_customer_name: boolean
};
	["CustomerRegistrationProject"]: {
	address: ModelTypes["CustomerRegistrationAddress"],
	documents: Array<ModelTypes["CustomerRegistrationDocument"]>,
	comment?: string | undefined,
	electricity_bill: ModelTypes["CustomerRegistrationElectricityBill"],
	electricity_bills?: Array<ModelTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined
};
	["CustomerRegistrationCompany"]: {
	company_name: string,
	contact: ModelTypes["CustomerRegistrationContact"],
	documents: Array<ModelTypes["CustomerRegistrationDocument"]>,
	majority_partner: ModelTypes["CustomerRegistrationCustomer"],
	legal_representatives: Array<ModelTypes["CustomerRegistrationLegalRepresentative"]>
};
	["CustomerRegistrationLegalRepresentative"]: {
	kind: string,
	cpf: string,
	full_name: string,
	birthdate: string,
	contact: ModelTypes["CustomerRegistrationContact"],
	documents: Array<ModelTypes["CustomerRegistrationDocument"]>,
	address: ModelTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationInput"]: {
	project_id: string,
	person_type: ModelTypes["RegistrationV2PersonType"],
	customer?: ModelTypes["CustomerRegistrationCustomer"] | undefined,
	guarantor?: ModelTypes["CustomerRegistrationGuarantor"] | undefined,
	project?: ModelTypes["CustomerRegistrationProject"] | undefined,
	company?: ModelTypes["CustomerRegistrationCompany"] | undefined,
	electricity_bills?: Array<ModelTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined
};
	["Person"]: {
	email?: string | undefined,
	partner_id: string,
	phone?: string | undefined
};
	["CustomerDocumentUpload"]: {
		id: string,
	url?: string | undefined,
	url_inline?: string | undefined,
	filename?: string | undefined,
	mimetype?: string | undefined,
	size?: number | undefined,
	docstorage_id?: string | undefined,
	created_at?: string | undefined
};
	["CustomerRegistrationError"]: {
		field: string,
	message: string,
	type: string,
	title?: string | undefined,
	description?: string | undefined
};
	["CustomerRegistrationV2Response"]: {
		errors: Array<ModelTypes["CustomerRegistrationError"] | undefined>
};
	["CustomerDocumentFormAnalysis"]: {
		id?: string | undefined,
	status?: string | undefined,
	project_id?: string | undefined,
	installation_document_matches_bill?: boolean | undefined,
	installation_address_matches_bill?: boolean | undefined,
	identity_matches_document?: boolean | undefined,
	reason?: string | undefined,
	comments?: string | undefined,
	documents?: Array<ModelTypes["CustomerDocumentUpload"] | undefined> | undefined
};
	["PersonInput"]: {
	email: string,
	phone: string
};
	["RegistrationContactChangeInput"]: {
	project_id: string,
	customer?: ModelTypes["PersonInput"] | undefined,
	guarantor?: ModelTypes["PersonInput"] | undefined,
	majority_partner?: ModelTypes["PersonInput"] | undefined,
	legal_representative_1?: ModelTypes["PersonInput"] | undefined,
	legal_representative_2?: ModelTypes["PersonInput"] | undefined
};
	["Mutation"]: {
		registration_contact_change: ModelTypes["RegistrationContactChangeResponse"],
	customer_document_upload?: Array<ModelTypes["CustomerDocumentUpload"] | undefined> | undefined,
	customer_document_form_analysis_cancel?: ModelTypes["CustomerDocumentFormAnalysis"] | undefined,
	customer_registration?: ModelTypes["CustomerRegistrationV2Response"] | undefined,
	register_device_orchestrator_gateway_credential: ModelTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"],
	device_orchestrator_credentials_change: ModelTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"],
	formalization_term_combo_connect_resend: ModelTypes["TermComboConnectResponse"],
	validateHardwareForm?: ModelTypes["HardwareFormValidation"] | undefined,
	hardware_form_showcase?: ModelTypes["HardwareFormShowcaseResponse"] | undefined,
	hardware_form_draft?: string | undefined,
	installation_mirror_upload?: ModelTypes["MirrorUploadResponse"] | undefined,
	installation_inverter_labels_upload?: ModelTypes["UploadInstallationLabelsResponse"] | undefined,
	installation_power_inverters_validate?: ModelTypes["ValidateTotalInvertersPowerResponse"] | undefined,
	installation_section_delete: boolean,
	installation_section_document_delete: boolean,
	installation_customer_reproval: boolean,
	installation_installed_inverter_create: ModelTypes["CreatedInstalledInverter"],
	installation_installed_inverter_create_with_brand: ModelTypes["CreatedInstalledInverter"],
	installation_commissioning_check?: ModelTypes["CommissioningCheckResponse"] | undefined,
	installation_commissioning_request: ModelTypes["CommissioningRequestResponse"],
	installation_commissioning_reset_customer_rejection: ModelTypes["CommissioningResetResponse"],
	installation_biometric_validation: ModelTypes["BiometricValidationResponse"],
	markNotificationsRead: boolean,
	markNotificationClicked: boolean,
	project_update_shopping_cart: string,
	project_proposal_update: boolean,
	project_create: ModelTypes["ProjectCreateResponse"],
	registration?: boolean | undefined,
	risk_financing_register_credential: ModelTypes["RegisterRevalidationCredentialResponse"],
	risk_financing_submit_revalidations: ModelTypes["SubmitRevalidationsResponse"],
	processEnergyAccountAnalysis?: ModelTypes["EnergyBillAnalysisDecision"] | undefined
};
	/** Arbitrary JSON value */
["JSON"]:any;
	["DeviceOrchestratorGatewayCredentialErrorCode"]:DeviceOrchestratorGatewayCredentialErrorCode;
	["RegisterDeviceOrchestratorGatewayCredentialResponse"]: {
		success: boolean,
	message?: ModelTypes["DeviceOrchestratorGatewayCredentialErrorCode"] | undefined
};
	["RegisterDeviceOrchestratorGatewayCredentialInput"]: {
	brand: string,
	username: string,
	password: string
};
	["AccessUserCredentialsData"]: {
		access_user: string,
	platform: string,
	partner_id: number
};
	["AccessUserCredentialsResponse"]: {
		success: boolean,
	message?: string | undefined,
	data?: ModelTypes["AccessUserCredentialsData"] | undefined
};
	["CredentialsCheckResponse"]: {
		has_credentials: boolean,
	is_valid: boolean,
	access_token?: string | undefined
};
	["DocumentResponse"]: {
		data?: ModelTypes["DocumentData"] | undefined
};
	["DocumentData"]: {
		project?: Array<ModelTypes["Documents"] | undefined> | undefined,
	customer?: Array<ModelTypes["Documents"] | undefined> | undefined,
	guarantor?: Array<ModelTypes["DocumentFile"] | undefined> | undefined,
	company?: Array<ModelTypes["DocumentFile"] | undefined> | undefined
};
	["Documents"]: {
		id?: string | undefined,
	docstorage_id?: string | undefined,
	kind?: string | undefined,
	validated_at?: string | undefined,
	validation_mode?: string | undefined,
	deleted_at?: string | undefined,
	submitted_at?: string | undefined,
	canceled_at?: string | undefined,
	status?: string | undefined,
	reason?: ModelTypes["DocumentReason"] | undefined,
	file?: ModelTypes["DocumentFile"] | undefined
};
	["DocumentFile"]: {
		public_id?: string | undefined,
	filename?: string | undefined,
	mimetype?: string | undefined,
	size?: number | undefined,
	url?: string | undefined,
	url_inline?: string | undefined
};
	["DocumentReason"]: {
		title?: string | undefined,
	description?: string | undefined
};
	["PersonType"]:PersonType;
	["FinancingStatus"]:FinancingStatus;
	["FinancingSteps"]:FinancingSteps;
	["StatusList"]:StatusList;
	["FinancingV2"]: {
		id: number,
	project_id: string,
	financed_value: number,
	customer_name: string,
	document: string,
	expires_at: string,
	created_at: string,
	formalized_at?: string | undefined,
	installed_at?: string | undefined,
	status: ModelTypes["FinancingStatus"],
	step: string,
	is_combo: boolean,
	is_combo_connect?: boolean | undefined,
	payments: Array<ModelTypes["Payment"]>,
	flow_provider: string,
	person_type: ModelTypes["PersonType"],
	all_payments_sent: boolean,
	section_statuses: ModelTypes["FinancingSectionStatusesV2"],
	updated_at?: string | undefined,
	is_expired: boolean,
	system_power?: number | undefined,
	system_type?: string | undefined,
	inverters_power_kw?: number | undefined,
	new_journey?: boolean | undefined,
	legacy_id?: number | undefined,
	reason?: string | undefined,
	openable_steps?: ModelTypes["FormalizationStatuses"] | undefined,
	is_aproved?: boolean | undefined,
	is_final?: boolean | undefined
};
	["FinancingSectionStatusesV2"]: {
		simulation: ModelTypes["FinancingStep"],
	installation: ModelTypes["FinancingStep"],
	customer_data: ModelTypes["FinancingStep"],
	equipment: ModelTypes["FinancingStep"],
	biometry_and_contract: ModelTypes["BiometryAndContractStep"],
	payment_model: ModelTypes["FinancingStep"]
};
	["GenericFinancingStep"]: ModelTypes["FinancingStep"] | ModelTypes["BiometryAndContractStep"];
	["FinancingStep"]: {
		completed_at?: string | undefined,
	reproved_at?: string | undefined,
	status?: string | undefined,
	submitted_at?: string | undefined
};
	["MetadataItem"]: {
		completed_at?: string | undefined,
	first_submitted_at?: string | undefined,
	last_submitted_at?: string | undefined
};
	["BiometryAndContractMetadata"]: {
		biometry?: ModelTypes["MetadataItem"] | undefined,
	contract?: ModelTypes["MetadataItem"] | undefined,
	term?: ModelTypes["MetadataItem"] | undefined
};
	["BiometryAndContractStep"]: {
		completed_at?: string | undefined,
	reproved_at?: string | undefined,
	status?: string | undefined,
	submitted_at?: string | undefined,
	metadata?: ModelTypes["BiometryAndContractMetadata"] | undefined
};
	["Payment"]: {
		id?: number | undefined,
	financing_id?: number | undefined,
	value?: number | undefined,
	total_value?: number | undefined,
	payment_percentage?: number | undefined,
	created_at?: string | undefined
};
	["Financing"]: {
		id: number,
	project_id: string,
	financed_value: number,
	project_value: number,
	customer_name: string,
	document: string,
	expires_at: string,
	created_at: string,
	formalized_at?: string | undefined,
	installed_at?: string | undefined,
	status: ModelTypes["FinancingStatus"],
	step: string,
	is_combo: boolean,
	is_combo_connect?: boolean | undefined,
	payments: Array<ModelTypes["Payment"]>,
	flow_provider: string,
	person_type: ModelTypes["PersonType"],
	all_payments_sent: boolean,
	section_statuses: ModelTypes["FinancingSectionStatus"],
	updated_at?: string | undefined,
	is_expired: boolean,
	system_power?: number | undefined,
	new_journey?: boolean | undefined,
	legacy_id?: number | undefined,
	reason?: string | undefined,
	openable_steps?: ModelTypes["FormalizationStatuses"] | undefined,
	is_aproved?: boolean | undefined,
	is_final?: boolean | undefined,
	loan_value: number
};
	["FormalizationStatuses"]: {
		hardware: boolean,
	registration: boolean,
	documentation: boolean,
	contract: boolean,
	receiptModel: boolean
};
	["FinancingProposal"]: {
		customer_data?: string | undefined,
	equipment?: string | undefined,
	biometry_and_contract?: string | undefined,
	payment_model?: string | undefined
};
	["FinancingFormalization"]: {
		contract?: string | undefined,
	hardware?: string | undefined,
	registration?: string | undefined,
	documentation?: string | undefined,
	receipt_model?: string | undefined
};
	["FinancingSectionStatus"]: {
		concluded?: string | undefined,
	simulation?: string | undefined,
	installation?: string | undefined,
	proposal?: ModelTypes["FinancingProposal"] | undefined,
	formalization?: ModelTypes["FinancingFormalization"] | undefined
};
	["FinancingsList"]: {
		data: Array<ModelTypes["Financing"]>,
	has_next?: boolean | undefined,
	statuses?: Array<ModelTypes["StatusList"] | undefined> | undefined,
	all_steps: Array<ModelTypes["Item"]>
};
	["Item"]: {
		name: string,
	value: string
};
	["FinancingsInput"]: {
	formalized_gte?: number | undefined,
	formalized_lte?: number | undefined,
	is_canceled?: boolean | undefined,
	is_combo?: string | undefined,
	is_combo_connect?: boolean | undefined,
	is_expired?: boolean | undefined,
	is_installed?: boolean | undefined,
	order_by?: string | undefined,
	page?: number | undefined,
	page_size?: number | undefined,
	partner_id?: string | undefined,
	provider?: string | undefined,
	query?: string | undefined,
	status?: Array<ModelTypes["FinancingStatus"]> | undefined,
	steps?: Array<ModelTypes["FinancingSteps"]> | undefined
};
	["FinancingType"]: {
		max_financing_value: number,
	min_financing_value: number,
	max_financing_installments: number,
	grace_period_financing: ModelTypes["GracePeriod"],
	max_bnpl_value?: number | undefined,
	max_bnpl_installments?: number | undefined,
	grace_period_bnpl?: ModelTypes["GracePeriod"] | undefined
};
	["GracePeriod"]: {
		label?: string | undefined,
	value: number
};
	["FormalizationInfo"]: {
		approval: string,
	biometry: ModelTypes["Biometry"],
	cancel: boolean,
	contract: ModelTypes["Contract"],
	cancellation_type?: string | undefined,
	contracts?: ModelTypes["FormalizationContracts"] | undefined,
	term?: ModelTypes["Term"] | undefined,
	download: ModelTypes["Download"],
	order_id?: string | undefined,
	pendencies?: ModelTypes["Pendencies"] | undefined,
	remaining_contract_days_until_expiration: number,
	resend: boolean,
	send_biometry_contract: ModelTypes["SendBiometryContract"],
	status: string,
	status_reason?: ModelTypes["FormalizationStatusReason"] | undefined
};
	["FormalizationStatusReason"]: {
		code?: string | undefined,
	description?: string | undefined
};
	["Biometry"]: {
		pending: boolean,
	signers: Array<ModelTypes["Signer"]>,
	status: string
};
	["Contract"]: {
		has_biometric?: boolean | undefined,
	signers: Array<ModelTypes["ContractSigner"]>,
	status: string
};
	["FormalizationContractSection"]: {
		status: string,
	document_signed?: string | undefined,
	signers: Array<ModelTypes["ContractSigner"]>
};
	["FormalizationContracts"]: {
		financing_amendment_term?: Array<ModelTypes["FormalizationContractSection"]> | undefined,
	loan?: ModelTypes["FormalizationContractSection"] | undefined,
	lender_insurance?: ModelTypes["FormalizationContractSection"] | undefined,
	diverse_risks_insurance?: ModelTypes["FormalizationContractSection"] | undefined,
	combo_connect_term?: ModelTypes["FormalizationContractSection"] | undefined
};
	["Term"]: {
		signers: Array<ModelTypes["ContractSigner"]>,
	status: string
};
	["Signer"]: {
		name: string,
	checked: boolean,
	status?: string | undefined
};
	["ContractSigner"]: {
		name: string,
	checked: boolean
};
	["Download"]: {
		contract?: string | undefined,
	insurance?: string | undefined,
	term?: string | undefined
};
	["Pendencies"]: {
		expired_at: string,
	items: Array<ModelTypes["PendencyItem"]>
};
	["PendencyItem"]: {
		category: string,
	message: string
};
	["SendBiometryContract"]: {
		message: ModelTypes["BiometryMessage"],
	method_receipt: string
};
	["BiometryMessage"]: {
		days: number,
	time: number
};
	["ConfirmBiometryResponse"]: {
		is_done: boolean
};
	["TermComboConnectResponse"]: {
		success: boolean,
	message?: string | undefined
};
	["FormalizedFinancing"]: {
		id: number,
	new_journey: boolean,
	project_id: string,
	partner_commission_percent?: number | undefined,
	financing_line?: string | undefined,
	company?: ModelTypes["FormalizedFinancingCompany"] | undefined,
	customer?: ModelTypes["FormalizedFinancingCustomer"] | undefined,
	guarantor?: ModelTypes["FormalizedFinancingGuarantor"] | undefined,
	legal_representatives?: Array<ModelTypes["FormalizedFinancingLegalRepresentative"]> | undefined,
	majority_partner?: ModelTypes["FormalizedFinancingMajorityPartner"] | undefined,
	proposal?: ModelTypes["FormalizedFinancingProposal"] | undefined,
	contract?: ModelTypes["FormalizedFinancingContract"] | undefined,
	partner?: ModelTypes["FormalizedFinancingPartner"] | undefined,
	securitization?: ModelTypes["FormalizedFinancingSecuritization"] | undefined,
	funding?: string | undefined,
	project?: ModelTypes["FormalizedFinancingProject"] | undefined
};
	["FormalizedFinancingCustomer"]: {
		address: ModelTypes["FormalizedFinancingCustomerAddress"],
	birthdate: string,
	contact: ModelTypes["FormalizedFinancingCustomerContact"],
	cpf: string,
	full_name: string
};
	["FormalizedFinancingCustomerAddress"]: {
		city: string,
	complement?: string | undefined,
	neighborhood: string,
	state: string,
	street: string,
	street_number: string,
	zipcode: string
};
	["FormalizedFinancingCustomerContact"]: {
		email: string,
	phone: string
};
	["FormalizedFinancingContract"]: {
		banking?: string | undefined,
	ccb_number?: string | undefined,
	formalized_at?: string | undefined,
	generate_date?: string | undefined,
	signed_date?: string | undefined
};
	["FormalizedFinancingPartner"]: {
		id: string,
	cnpj: string,
	company_name: string,
	payment_institution: string
};
	["FormalizedFinancingProposal"]: {
		installments_number: number,
	rate_type: string,
	installment_amount: number,
	gross_amount: number,
	down_payment: number,
	grace_period: number,
	registration_fee: number,
	interest_fee: number,
	iof: number,
	ipca_type: string,
	cet: number
};
	["FormalizedFinancingSecuritization"]: {
		cnpj: string,
	slug: string,
	corporate_name: string,
	name: string
};
	["FormalizedFinancingProject"]: {
		electrical_phase?: string | undefined,
	installed_at?: string | undefined,
	inverter_type?: string | undefined,
	inverters: Array<ModelTypes["FormalizedFinancingInverter"]>,
	modules: Array<ModelTypes["FormalizedFinancingModule"]>,
	total_powers: ModelTypes["FormalizedFinancingTotalPowers"]
};
	["FormalizedFinancingInverter"]: {
		brand: string,
	contactor_switch?: string | undefined,
	model: string,
	phase: string,
	power: number,
	voltage: number,
	quantity: number
};
	["FormalizedFinancingModule"]: {
		brand: string,
	model: string,
	phase: string,
	power: number,
	voltage?: number | undefined,
	quantity: number
};
	["FormalizedFinancingTotalPowers"]: {
		system: number,
	modules: number,
	inverters: number
};
	["FormalizedFinancingCompany"]: {
		company_name: string,
	cnpj: string
};
	["FormalizedFinancingGuarantor"]: {
		full_name?: string | undefined,
	cpf?: string | undefined
};
	["FormalizedFinancingMajorityPartner"]: {
		full_name: string,
	cpf: string,
	percentage?: number | undefined,
	contact: ModelTypes["FormalizedFinancingCustomerContact"]
};
	["FormalizedFinancingLegalRepresentative"]: {
		full_name: string,
	cpf: string,
	role?: string | undefined
};
	["FormalizationBucket"]: {
		amount: number,
	count: number,
	pct: number
};
	["FormalizationBuckets"]: {
		lte_45: ModelTypes["FormalizationBucket"],
	d46_60: ModelTypes["FormalizationBucket"],
	d61_90: ModelTypes["FormalizationBucket"],
	gt_90: ModelTypes["FormalizationBucket"],
	lte_60: ModelTypes["FormalizationBucket"],
	lte_90: ModelTypes["FormalizationBucket"]
};
	["FormalizationIntegratorMetrics"]: {
		partner_id: string,
	partner_name: string,
	total_formalized: number,
	total_formalized_in_window: number,
	total_installed: number,
	total_installed_in_window: number,
	buckets: ModelTypes["FormalizationBuckets"],
	buckets_pending: ModelTypes["FormalizationBuckets"]
};
	["FormalizationMetricsResponse"]: {
		window_days: number,
	items: Array<ModelTypes["FormalizationIntegratorMetrics"]>,
	has_next: boolean
};
	["Incentive"]: {
		title_ptbr: string,
	description_ptbr: string,
	banner_url?: string | undefined
};
	["TargetIncentiveSummary"]: {
		campaign_id: string,
	incentive: ModelTypes["Incentive"]
};
	["FileStatusType"]:FileStatusType;
	["DocumentStatusType"]:DocumentStatusType;
	["TypeSection"]:TypeSection;
	["MirrorStatuses"]:MirrorStatuses;
	["Status"]: {
		description: string,
	id: number,
	slug: ModelTypes["DocumentStatusType"]
};
	["Document"]: {
		filename: string,
	filetype: string,
	id: string,
	status?: ModelTypes["Status"] | undefined,
	type: string,
	url: string
};
	["Section"]: {
		documents?: Array<ModelTypes["Document"] | undefined> | undefined,
	id: string,
	status: ModelTypes["Status"],
	type: ModelTypes["TypeSection"]
};
	["InstallationStatus"]: {
		description: string,
	id: number,
	slug: ModelTypes["FileStatusType"]
};
	["Installation"]: {
		comment?: string | undefined,
	concluded_at?: string | undefined,
	grade: number,
	has_ampera: boolean,
	has_ampera_activated: boolean,
	has_minimal_projects: boolean,
	id: string,
	new_journey: boolean,
	plant_id?: string | undefined,
	plant_url?: string | undefined,
	project_id: string,
	project_name: string,
	sections: Array<ModelTypes["Section"]>,
	status: ModelTypes["InstallationStatus"],
	installed_inverters?: ModelTypes["InstalledInverters"] | undefined,
	stage?: number | undefined,
	stage_updated_at?: string | undefined,
	stage_error?: string | undefined,
	stage_customer_phone?: string | undefined
};
	["HardwareFormInverter"]: {
	id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormModule"]: {
	id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormComboEquipment"]: {
	sku: string,
	power?: number | undefined,
	quantity: number
};
	["HardwareFormBatteries"]: {
	id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormComboMetadata"]: {
	project_id: string,
	sku?: string | undefined,
	power?: number | undefined,
	price?: number | undefined,
	inverters: Array<ModelTypes["HardwareFormComboEquipment"]>,
	modules: Array<ModelTypes["HardwareFormComboEquipment"]>
};
	["HardwareFormInput"]: {
	is_combo: boolean,
	id?: string | undefined,
	combo_price?: number | undefined,
	inverter_type?: string | undefined,
	project_id: string,
	distributor_id: number,
	phase_id: number,
	inverters: Array<ModelTypes["HardwareFormInverter"]>,
	modules: Array<ModelTypes["HardwareFormModule"]>,
	batteries?: Array<ModelTypes["HardwareFormBatteries"]> | undefined,
	combo_metadata?: ModelTypes["HardwareFormComboMetadata"] | undefined,
	is_showcase?: boolean | undefined,
	shopping_cart_id?: string | undefined
};
	["HardwareFormShowcaseInput"]: {
	price?: number | undefined,
	project_id: string,
	inverters: Array<ModelTypes["HardwareFormInverter"]>,
	modules: Array<ModelTypes["HardwareFormModule"]>,
	shopping_cart_id?: string | undefined
};
	["ValidateTotalInvertersPowerInput"]: {
	project_id: string,
	total_inverters_power_kw: number
};
	["CustomerReprovalInput"]: {
	validation_message_id: string
};
	["BiometricValidationInput"]: {
	project_id: string
};
	["BiometricValidationStatus"]:BiometricValidationStatus;
	["BiometricValidationReason"]:BiometricValidationReason;
	["BiometricValidationResponse"]: {
		reason: ModelTypes["BiometricValidationReason"],
	retry_after_seconds: number,
	retry_at: string,
	status: ModelTypes["BiometricValidationStatus"]
};
	["ValidateTotalInvertersPowerResponse"]: {
		is_valid: boolean,
	error?: string | undefined
};
	["ValidateHardwareFormPricePerWatt"]: {
		is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormSystemPower"]: {
		is_valid?: boolean | undefined
};
	["ValidateHardwareFormModules"]: {
		price_per_watt?: ModelTypes["ValidateHardwareFormPricePerWatt"] | undefined,
	system_power?: ModelTypes["ValidateHardwareFormSystemPower"] | undefined
};
	["ValidateHardwareFormOverload"]: {
		is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormInverters"]: {
		overload?: ModelTypes["ValidateHardwareFormOverload"] | undefined
};
	["ValidateHardwareFormCapacity"]: {
		is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormBatteries"]: {
		capacity?: ModelTypes["ValidateHardwareFormCapacity"] | undefined
};
	["ValidateHardwareFormHardware"]: {
		modules?: ModelTypes["ValidateHardwareFormModules"] | undefined,
	inverters?: ModelTypes["ValidateHardwareFormInverters"] | undefined,
	batteries?: ModelTypes["ValidateHardwareFormBatteries"] | undefined
};
	["HardwareFormValidation"]: {
		is_valid?: boolean | undefined,
	hardware?: ModelTypes["ValidateHardwareFormHardware"] | undefined
};
	["HardwareFormShowcaseResponse"]: {
		overload_is_valid?: boolean | undefined,
	price_per_watt_is_valid?: boolean | undefined,
	percentage_of_service_with_combo_is_valid?: boolean | undefined
};
	["MirrorStatus"]: {
		status: ModelTypes["MirrorStatuses"]
};
	["MirrorUploadResponse"]: {
		id: string,
	url: string
};
	["HardwareDraftEquipment"]: {
	sku: string,
	quantity: number,
	power?: number | undefined,
	model: string,
	brand: string
};
	["HardwareDraft"]: {
	project_id: string,
	sku?: string | undefined,
	power?: number | undefined,
	price?: number | undefined,
	inverters: Array<ModelTypes["HardwareDraftEquipment"]>,
	modules: Array<ModelTypes["HardwareDraftEquipment"]>
};
	["CreateInstalledInverterInput"]: {
	model?: string | undefined,
	power_kw: number,
	serial_number: string
};
	["CreateInstalledInverterWithBrandInput"]: {
	brand: string,
	model?: string | undefined,
	power_kw: number,
	serial_number: string
};
	["CreatedInstalledInverter"]: {
		id: string,
	installation_id: string,
	brand: string,
	model?: string | undefined,
	power_kw: number,
	serial_number: string,
	entry_mode: string,
	status: ModelTypes["InstalledInverterStatus"]
};
	["UploadInstallationLabelsResponse"]: {
		inverter_label_file: string,
	inverter_label_file_url: string,
	datalogger_label_file?: string | undefined,
	datalogger_label_file_url?: string | undefined
};
	["InstalledInverterGlobalStatus"]:InstalledInverterGlobalStatus;
	["InstalledInverterStatus"]:InstalledInverterStatus;
	["InstalledInverters"]: {
		status: ModelTypes["InstalledInverterGlobalStatus"],
	inverters?: Array<ModelTypes["InstalledInverter"]> | undefined
};
	["InstalledInverter"]: {
		id: string,
	model?: string | undefined,
	brand?: string | undefined,
	power_kw?: number | undefined,
	serial_number?: string | undefined,
	datalogger_serial_number?: string | undefined,
	status: ModelTypes["InstalledInverterStatus"],
	entry_mode: string,
	created_at: string,
	updated_at: string
};
	["CommissioningCheckStatus"]:CommissioningCheckStatus;
	["CommissioningMonitoringStatus"]:CommissioningMonitoringStatus;
	["CommissioningFailureReason"]:CommissioningFailureReason;
	["CommissioningCheckResponse"]: {
		checked_at?: string | undefined,
	status: ModelTypes["CommissioningCheckStatus"],
	access_user?: string | undefined
};
	["InverterBrands"]: {
		brands: Array<string>
};
	["AvailableOrderKitItemCategory"]: {
		id?: number | undefined,
	description?: string | undefined
};
	["AvailableOrderKitItem"]: {
		item_id?: string | undefined,
	description?: string | undefined,
	quantity?: number | undefined,
	value?: number | undefined,
	type?: string | undefined,
	power?: number | undefined,
	category?: ModelTypes["AvailableOrderKitItemCategory"] | undefined
};
	["AvailableOrderKitChannel"]: {
		channel?: string | undefined,
	source?: string | undefined
};
	["AvailableOrderKitCustomer"]: {
		type?: string | undefined,
	document_number?: string | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	billing_type?: string | undefined,
	street?: string | undefined,
	number?: string | undefined,
	neighborhood?: string | undefined,
	city?: string | undefined,
	state?: string | undefined,
	ibge_code?: string | undefined,
	zip_code?: string | undefined,
	complement?: string | undefined
};
	["AvailableOrderKitShipping"]: {
		freight_type?: string | undefined,
	freight_value?: number | undefined,
	recipient_name?: string | undefined,
	recipient_phone?: string | undefined,
	recipient_email?: string | undefined,
	rural_zone?: boolean | undefined,
	street?: string | undefined,
	number?: string | undefined,
	neighborhood?: string | undefined,
	city?: string | undefined,
	state?: string | undefined,
	ibge_code?: string | undefined,
	zip_code?: string | undefined,
	complement?: string | undefined
};
	["AvailableOrderKitUser"]: {
		partner_id?: number | undefined,
	partner_cnpj?: string | undefined,
	user_id?: number | undefined
};
	["AvailableOrderKitPayment"]: {
		origin?: string | undefined,
	value?: number | undefined,
	installments?: number | undefined
};
	["AvailableOrderKit"]: {
		error?: string | undefined,
	id?: string | undefined,
	order_number?: number | undefined,
	legacy_id?: number | undefined,
	cart_id?: string | undefined,
	type?: string | undefined,
	category?: string | undefined,
	created_at?: string | undefined,
	region?: string | undefined,
	dc_id?: number | undefined,
	reservation_id?: string | undefined,
	raw_value?: number | undefined,
	total_value?: number | undefined,
	items?: Array<ModelTypes["AvailableOrderKitItem"]> | undefined,
	channel?: ModelTypes["AvailableOrderKitChannel"] | undefined,
	customer?: ModelTypes["AvailableOrderKitCustomer"] | undefined,
	shipping?: ModelTypes["AvailableOrderKitShipping"] | undefined,
	user?: ModelTypes["AvailableOrderKitUser"] | undefined,
	payment?: ModelTypes["AvailableOrderKitPayment"] | undefined,
	status?: ModelTypes["JSON"] | undefined,
	erp_code?: string | undefined,
	erp_branch?: string | undefined,
	summary?: ModelTypes["JSON"] | undefined,
	expires_at?: string | undefined
};
	["AvailableOrder"]: {
		order_id: number,
	value: string,
	created_at?: string | undefined,
	expire_at?: string | undefined,
	kit?: ModelTypes["AvailableOrderKit"] | undefined
};
	["AvailableOrdersPagination"]: {
		page?: number | undefined,
	page_size?: number | undefined,
	total?: number | undefined,
	has_next?: boolean | undefined
};
	["AvailableOrders"]: {
		data: Array<ModelTypes["AvailableOrder"]>,
	pagination?: ModelTypes["AvailableOrdersPagination"] | undefined
};
	["MonitoringInput"]: {
	brand: string,
	expected_plant_name?: string | undefined,
	inverters: Array<string>
};
	["CommissioningRequestInput"]: {
	installation_id: string,
	total_power_kw: number,
	monitorings: Array<ModelTypes["MonitoringInput"]>
};
	["CommissioningInstalledInverter"]: {
		id: string,
	serial_number: string,
	status: string
};
	["CommissioningMonitoring"]: {
		id: string,
	brand: string,
	status: string,
	installed_inverters: Array<ModelTypes["CommissioningInstalledInverter"]>
};
	["CommissioningRequestData"]: {
		installation_id?: string | undefined,
	code?: string | undefined,
	monitorings: Array<ModelTypes["CommissioningMonitoring"]>
};
	["CommissioningRequestResponse"]: {
		success: boolean,
	message: string,
	data: ModelTypes["CommissioningRequestData"]
};
	["CommissioningResetData"]: {
		project_id?: string | undefined,
	installation_id?: string | undefined,
	removed_monitorings?: number | undefined,
	removed_inverters?: number | undefined,
	code?: string | undefined
};
	["CommissioningResetResponse"]: {
		success: boolean,
	message: string,
	data: ModelTypes["CommissioningResetData"]
};
	["CommissioningStatusInstalledInverter"]: {
		id: string,
	serial_number: string,
	model?: string | undefined,
	power_kw?: number | undefined,
	status: ModelTypes["InstalledInverterStatus"]
};
	["CommissioningStatusMonitoring"]: {
		brand: string,
	status: ModelTypes["CommissioningMonitoringStatus"],
	plant_name?: string | undefined,
	commissioning_failure_reason?: ModelTypes["CommissioningFailureReason"] | undefined,
	installed_inverters: Array<ModelTypes["CommissioningStatusInstalledInverter"]>
};
	["CommissioningInstallationStatus"]:CommissioningInstallationStatus;
	["CommissioningStatusCustomerValidationRequest"]: {
		id: string,
	status: string,
	attempt_number: number,
	initiated_at: string
};
	["CommissioningStatusData"]: {
		installation_id?: string | undefined,
	installation_status?: ModelTypes["CommissioningInstallationStatus"] | undefined,
	access_user?: string | undefined,
	monitorings: Array<ModelTypes["CommissioningStatusMonitoring"]>,
	customer_validation_requests: Array<ModelTypes["CommissioningStatusCustomerValidationRequest"]>
};
	["CommissioningStatusResponse"]: {
		success: boolean,
	message: string,
	data: ModelTypes["CommissioningStatusData"]
};
	["LegacyFinancing"]: {
		projectId: string,
	financingId: number,
	formalizedAt?: string | undefined,
	stage: string,
	status: string
};
	["NotificationData"]: {
		id: number,
	clickedAt?: string | undefined,
	readAt?: string | undefined,
	createdAt: string,
	notification: ModelTypes["Notification"]
};
	["Notification"]: {
		actionUrl: string,
	templateName: string,
	message: string,
	title: string
};
	["Metrics"]: {
		totalCount: number,
	totalUnreadCount: number,
	totalUnclickedCount: number
};
	["NotificationsList"]: {
		count: number,
	totalCount: number,
	nextCursor?: string | undefined,
	nextPage?: string | undefined,
	previousCursor?: string | undefined,
	previousPage?: string | undefined,
	data: Array<ModelTypes["NotificationData"]>,
	metrics: ModelTypes["Metrics"]
};
	["ContactPartner"]: {
		phone?: string | undefined,
	email: string
};
	["Address"]: {
		street: string,
	number: string,
	complement?: string | undefined,
	reference?: string | undefined,
	district: string,
	zipcode: string,
	city: string,
	state: string
};
	["ResponsiblePartner"]: {
		username?: string | undefined,
	profile: string,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	contact: ModelTypes["ContactPartner"]
};
	["Permission"]: {
		store: boolean,
	financing: boolean
};
	["Sfplus"]: {
		level: number,
	is_level_black: boolean,
	next_transition_date?: string | undefined,
	score?: ModelTypes["Score"] | undefined,
	black_status?: ModelTypes["LevelBlackStatus"] | undefined,
	downgrade?: ModelTypes["Downgrade"] | undefined
};
	["OnlyPartner"]: {
		id: number,
	corporate_name: string,
	trade_name: string,
	document: string,
	category?: string | undefined,
	state_registration: string,
	active: boolean,
	operation_term_accepted: boolean,
	address: ModelTypes["Address"],
	responsible: ModelTypes["ResponsiblePartner"],
	permission: ModelTypes["Permission"],
	sfplus: ModelTypes["Sfplus"],
	blocklist?: ModelTypes["PartnerBlocklist"] | undefined,
	registration_type: string
};
	["PartnerBlocklist"]: {
		is_blocked: boolean,
	nature?: string | undefined,
	title?: string | undefined,
	description?: string | undefined,
	action?: string | undefined
};
	["CorePartner"]: {
		id: number,
	cnpj?: string | undefined,
	responsible?: ModelTypes["CoreParterResponsible"] | undefined,
	company_name: string,
	fantasy_name: string,
	status: Array<ModelTypes["CoreParterStatus"] | undefined>
};
	["CoreParterResponsible"]: {
		id?: number | undefined,
	full_name?: string | undefined
};
	["CoreParterStatus"]: {
		active?: boolean | undefined,
	reason?: string | undefined,
	date?: string | undefined
};
	["CoreGetPartnersInput"]: {
	page?: number | undefined,
	search_term?: string | undefined
};
	["PaymentCurrentIssuanceModel"]: {
		payout_options: Array<string>,
	best_payout_option: string
};
	["ProjectProposal"]: {
		value_changed?: boolean | undefined
};
	["ProjectPersonType"]:ProjectPersonType;
	["ProjectSystemType"]:ProjectSystemType;
	["AppliedModifierOption"]: {
		type: string,
	value: string
};
	["AppliedModifier"]: {
		name: string,
	type: string,
	options: Array<ModelTypes["AppliedModifierOption"]>
};
	["AddonProduct"]: {
		id: string,
	product_name: string,
	product_external_id: string,
	simulation_id: string,
	type: string,
	product_slug: string,
	applied: boolean,
	partner_commission: number,
	installment_price: number,
	total_price: number,
	monthly_interest_rate?: number | undefined,
	engine_simulation_id: string,
	previous_engine_simulation_id: string,
	cet?: number | undefined,
	applied_modifiers: Array<ModelTypes["AppliedModifier"]>,
	addon_type?: string | undefined
};
	["SelectedInstallments"]: {
		cet: string,
	iof: number,
	ipca: string,
	addons: Array<ModelTypes["AddonProduct"]>,
	aggregated_addons: Array<ModelTypes["AddonProduct"]>,
	user_id: number,
	document: string,
	is_combo: boolean,
	commission: number,
	partner_id: number,
	aliquot_iof: number,
	new_journey: boolean,
	person_type: string,
	down_payment: number,
	due_day?: number | undefined,
	first_due_date?: string | undefined,
	grace_period: number,
	installments: number,
	project_name: string,
	system_power: number,
	interest_rate: number,
	cet_percentage: number,
	commission_raw: number,
	financing_value: number,
	taxa_de_cadastro?: number | undefined,
	taxa_de_juros?: number | undefined,
	installment_value: number,
	is_from_suggested: boolean,
	registration_fee_gross: number,
	registration_fee_raw_dry: number,
	registration_fee_raw_final: number,
	is_combo_connect?: boolean | undefined
};
	["RiskInfo"]: {
		title: string,
	description: string,
	todo: string,
	reason?: string | undefined,
	decision: number
};
	["BNPL"]: {
		decision_pre_analysis: number,
	min_entry_value: number,
	max_installments: number,
	pre_approved_value: number,
	status?: string | undefined
};
	["Guarantor"]: {
		id?: string | undefined,
	document?: string | undefined,
	birth_date?: string | undefined,
	border_line?: boolean | undefined,
	created_at?: string | undefined,
	customer_second_financing_policy?: boolean | undefined,
	decision_pre_analysis?: number | undefined,
	max_approved_project_value?: number | undefined,
	max_financing_value?: number | undefined,
	max_grace_period?: number | undefined,
	max_installments?: number | undefined,
	min_approved_project_value?: number | undefined,
	min_installment_value?: number | undefined,
	pre_approved_value?: number | undefined,
	project_name?: string | undefined,
	project_state?: string | undefined,
	risk_class?: string | undefined,
	status?: string | undefined
};
	["InstallmentsConditions"]: {
		suggested_installments?: number | undefined,
	suggested_installments_value?: number | undefined
};
	["Project"]: {
		id: string,
	user_id: number,
	partner_id: number,
	person_type: string,
	document: string,
	created_at: string,
	representative_document?: string | undefined,
	project_value: number,
	system_power?: number | undefined,
	system_type: string,
	grace_period: number,
	down_payment: number,
	status: string,
	project_status: string,
	min_installments?: number | undefined,
	max_installments: number,
	max_grace_period: number,
	project_name: string,
	project_state: string,
	partner_profile: string,
	pre_approved_value: number,
	products_applieds?: string | undefined,
	installments?: string | undefined,
	risk_info?: ModelTypes["RiskInfo"] | undefined,
	state_registration?: string | undefined,
	complete: boolean,
	selected_installments?: ModelTypes["SelectedInstallments"] | undefined,
	guarantor?: ModelTypes["Guarantor"] | undefined,
	birth_date: string,
	decision_pre_analysis: number,
	score_sol_facil: number,
	simulation_id?: string | undefined,
	addons: Array<ModelTypes["AddonProduct"]>,
	max_approved_project_value: number,
	min_approved_project_value: number,
	max_financing_value: number,
	border_line: boolean,
	is_formalized: boolean,
	new_journey: boolean,
	formalized_at?: string | undefined,
	shopping_cart_id?: string | undefined,
	bnpl?: ModelTypes["BNPL"] | undefined,
	bnpl_simulation_id?: string | undefined,
	bnpl_status?: string | undefined,
	is_onflex_partner: boolean,
	is_turbo_prime?: boolean | undefined,
	can_select_ampera: boolean,
	has_energy_bill_analysis: boolean,
	insurance_commission?: number | undefined,
	gained_points?: number | undefined,
	original_installment_value?: number | undefined,
	is_contract_signed?: boolean | undefined,
	commission?: number | undefined,
	risk_class?: string | undefined,
	selected_installment?: number | undefined,
	credit_analysis_status?: string | undefined,
	bill_value: number,
	installments_conditions?: ModelTypes["InstallmentsConditions"] | undefined
};
	["ProjectProposalUpdatePayloadInput"]: {
	engine_simulation_id: string,
	simulation_id: string,
	is_combo: boolean,
	is_ampera: boolean,
	commission: number,
	applied_addons: Array<string>
};
	["ProjectProposalUpdateResponse"]: {
		engine_simulation_id: string,
	simulation_id: string,
	project_id: string,
	is_combo: boolean,
	is_ampera: boolean,
	commission: number,
	applied_addons: Array<string>
};
	["IsComboResponse"]: {
		data?: boolean | undefined
};
	["ProjectCreateInput"]: {
	person_type: ModelTypes["ProjectPersonType"],
	project_name?: string | undefined,
	document: string,
	project_value: number,
	down_payment: number,
	partner_id: number,
	user_id: number,
	representative_document?: string | undefined,
	system_power: number,
	new_journey: boolean,
	shopping_cart_id?: string | undefined,
	provider: string,
	bill_value: number,
	system_type: ModelTypes["ProjectSystemType"],
	engine_pricing?: string | undefined
};
	["ProjectCreateStatus"]:ProjectCreateStatus;
	["ProjectCreateResponse"]: {
		status: ModelTypes["ProjectCreateStatus"],
	id?: string | undefined
};
	["PartnerOverviewAll"]: {
		total?: number | undefined,
	in_progress?: number | undefined,
	in_reassassement?: number | undefined,
	finish?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewSimulation"]: {
		total?: number | undefined,
	approved?: number | undefined,
	reassassement?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewProposal"]: {
		total?: number | undefined,
	in_equipments?: number | undefined,
	in_customer_data?: number | undefined,
	in_biometry_and_contract?: number | undefined,
	in_payment_model?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewInstallation"]: {
		total?: number | undefined,
	in_progress?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverview"]: {
		partner_id?: number | undefined,
	all?: ModelTypes["PartnerOverviewAll"] | undefined,
	simulation?: ModelTypes["PartnerOverviewSimulation"] | undefined,
	proposal?: ModelTypes["PartnerOverviewProposal"] | undefined,
	installation?: ModelTypes["PartnerOverviewInstallation"] | undefined,
	status: string,
	last_updated_at?: string | undefined,
	next_update_at?: string | undefined
};
	["RegistrationPersonType"]:RegistrationPersonType;
	["RegistrationDocumentTypes"]:RegistrationDocumentTypes;
	["RegistrationRepresentantTypes"]:RegistrationRepresentantTypes;
	["RegistrationContact"]: {
		email: string,
	phone: string
};
	["RegistrationAddressCity"]: {
		id: number,
	name: string
};
	["RegistrationAddressState"]: {
		id: number,
	name: string
};
	["RegistrationDocumentModel"]:RegistrationDocumentModel;
	["RegistrationElectricityBill"]: {
		holder_cpf: string,
	is_under_customer_name: boolean,
	distributor_id?: number | undefined,
	inverters_power_above_limit?: boolean | undefined
};
	["RegistrationElectricityBillWithDocuments"]: {
		id: string,
	holder_cpf?: string | undefined,
	is_under_customer_name: boolean,
	documents: Array<ModelTypes["RegistrationDocument"]>
};
	["RegistrationDocument"]: {
		type: ModelTypes["RegistrationDocumentTypes"],
	status: string,
	filename: string,
	url_download: string,
	url_preview: string,
	mime_type: string,
	docstorage_id: string,
	id: string
};
	["RegistrationAddress"]: {
		zipcode?: string | undefined,
	street?: string | undefined,
	street_number?: string | undefined,
	complement?: string | undefined,
	neighborhood?: string | undefined,
	city_id?: number | undefined,
	state_id?: number | undefined,
	city?: ModelTypes["RegistrationAddressCity"] | undefined,
	state?: ModelTypes["RegistrationAddressState"] | undefined,
	is_rural?: boolean | undefined
};
	["RegistrationProject"]: {
		address?: ModelTypes["RegistrationAddress"] | undefined,
	documents?: Array<ModelTypes["RegistrationDocument"] | undefined> | undefined,
	electricity_bill?: ModelTypes["RegistrationElectricityBill"] | undefined,
	residencial_is_the_same_of_plant?: boolean | undefined,
	comment?: string | undefined
};
	["RegistrationCustomer"]: {
		cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["RegistrationContact"] | undefined,
	documents: Array<ModelTypes["RegistrationDocument"]>,
	document_type?: ModelTypes["RegistrationDocumentModel"] | undefined,
	address?: ModelTypes["RegistrationAddress"] | undefined
};
	["RegistrationCompany"]: {
		company_name: string,
	cnpj: string,
	contact?: ModelTypes["RegistrationContact"] | undefined,
	documents: Array<ModelTypes["RegistrationDocument"]>,
	majority_partner: ModelTypes["RegistrationCompanyMajorityPartner"],
	legal_representatives: Array<ModelTypes["RegistrationLegalRepresentative"]>,
	majority_partner_is_legal_representative?: boolean | undefined,
	is_only_one_legal_representative?: boolean | undefined
};
	["RegistrationLegalRepresentative"]: {
		cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["RegistrationContact"] | undefined,
	documents: Array<ModelTypes["RegistrationDocument"]>,
	address?: ModelTypes["RegistrationAddress"] | undefined,
	kind: ModelTypes["RegistrationRepresentantTypes"],
	document_type?: ModelTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationCompanyMajorityPartner"]: {
		cpf: string,
	is_legal_representative?: boolean | undefined,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: ModelTypes["RegistrationContact"] | undefined,
	documents: Array<ModelTypes["RegistrationDocument"]>,
	address?: ModelTypes["RegistrationAddress"] | undefined,
	document_type?: ModelTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationGuarantor"]: {
		cpf: string,
	full_name: string,
	birthdate?: string | undefined,
	contact?: ModelTypes["RegistrationContact"] | undefined,
	documents: Array<ModelTypes["RegistrationDocument"]>,
	address?: ModelTypes["RegistrationAddress"] | undefined,
	document_type?: ModelTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationError"]: {
		title?: string | undefined,
	description: string,
	field: string,
	type?: string | undefined
};
	["RegistrationUpdateInput"]: {
	project_id: string
};
	["RegistrationDetailsResponse"]: {
		project_id: string,
	status: string,
	is_combo: boolean,
	remaining_changes_after_confirmation?: number | undefined,
	person_type: ModelTypes["RegistrationPersonType"],
	customer?: ModelTypes["RegistrationCustomer"] | undefined,
	company?: ModelTypes["RegistrationCompany"] | undefined,
	guarantor?: ModelTypes["RegistrationGuarantor"] | undefined,
	project?: ModelTypes["RegistrationProject"] | undefined,
	errors: Array<ModelTypes["RegistrationError"]>,
	electricity_bills?: Array<ModelTypes["RegistrationElectricityBillWithDocuments"]> | undefined,
	has_other_beneficiary_units: boolean
};
	["GridAccessApprovalDisplayMode"]:GridAccessApprovalDisplayMode;
	["RegistrationGridAccessApproval"]: {
		display_mode: ModelTypes["GridAccessApprovalDisplayMode"]
};
	["RevalidationStatus"]:RevalidationStatus;
	["AttemptStatus"]:AttemptStatus;
	["RevalidationStatusCount"]: {
		status: string,
	count: number
};
	["RevalidationBrandSummary"]: {
		brand: string,
	total: number,
	statuses: Array<ModelTypes["RevalidationStatusCount"]>
};
	["RevalidationSummary"]: {
		total: number,
	statuses: Array<ModelTypes["RevalidationStatusCount"]>,
	brands: Array<ModelTypes["RevalidationBrandSummary"]>
};
	["LatestSubmission"]: {
		serial_number: string,
	attempt_status: ModelTypes["AttemptStatus"]
};
	["LatestAttempt"]: {
		serial_number: string,
	attempt_status: ModelTypes["AttemptStatus"],
	brand: string,
	submitted_at: string,
	processed_at?: string | undefined,
	reason_code?: string | undefined
};
	["RevalidationItem"]: {
		revalidation_id: string,
	status: ModelTypes["RevalidationStatus"],
	project_name?: string | undefined,
	plant_name?: string | undefined,
	reference_inverter_brand?: string | undefined,
	expected_total_inverters: number,
	latest_submission: Array<ModelTypes["LatestSubmission"]>,
	latest_attempts: Array<ModelTypes["LatestAttempt"]>
};
	["RevalidationPagination"]: {
		page: number,
	page_size: number,
	total_items: number,
	total_pages: number
};
	["RevalidationsListResponse"]: {
		items: Array<ModelTypes["RevalidationItem"]>,
	pagination: ModelTypes["RevalidationPagination"]
};
	["RevalidationsInput"]: {
	status?: Array<ModelTypes["RevalidationStatus"]> | undefined,
	brand?: string | undefined,
	sort?: string | undefined,
	page?: number | undefined,
	page_size?: number | undefined
};
	["RegisterRevalidationCredentialInput"]: {
	brand: string,
	username: string,
	password: string
};
	["RegisterRevalidationCredentialErrorCode"]:RegisterRevalidationCredentialErrorCode;
	["RegisterRevalidationCredentialResponse"]: {
		success: boolean,
	message?: ModelTypes["RegisterRevalidationCredentialErrorCode"] | undefined
};
	["RevalidationSubmissionDeviceInput"]: {
	brand: string,
	serial_number: string
};
	["RevalidationSubmissionInput"]: {
	revalidation_id: string,
	monitoring_plant_name: string,
	devices: Array<ModelTypes["RevalidationSubmissionDeviceInput"]>
};
	["SubmitRevalidationsInput"]: {
	platform_access_token: string,
	submissions: Array<ModelTypes["RevalidationSubmissionInput"]>
};
	["RevalidationSubmissionAccepted"]: {
		revalidation_id: string,
	submission_number: number,
	total_devices: number,
	revalidation_status: ModelTypes["RevalidationStatus"]
};
	["RevalidationSubmissionError"]: {
		code: string,
	detail: string
};
	["RevalidationSubmissionDevice"]: {
		brand: string,
	serial_number: string
};
	["RevalidationSubmissionRejected"]: {
		revalidation_id: string,
	errors: Array<ModelTypes["RevalidationSubmissionError"]>,
	devices: Array<ModelTypes["RevalidationSubmissionDevice"]>
};
	["RevalidationSubmissionReferenceBrandUpdated"]: {
		revalidation_id: string,
	reference_inverter_brand: string,
	revalidation_status: ModelTypes["RevalidationStatus"]
};
	["RevalidationSubmissionsData"]: {
		accepted: Array<ModelTypes["RevalidationSubmissionAccepted"]>,
	rejected: Array<ModelTypes["RevalidationSubmissionRejected"]>,
	reference_brand_updated: Array<ModelTypes["RevalidationSubmissionReferenceBrandUpdated"]>
};
	["SubmitRevalidationsResponse"]: {
		success: boolean,
	message: string,
	data: ModelTypes["RevalidationSubmissionsData"]
};
	["AnalyzeEnergyBillInput"]: {
	person_type: string,
	project_id: string,
	document_customer: string,
	financing_id: number,
	document_owner_energy_bill: string,
	auto_cancel_flow_on_rejection: boolean
};
	["GetOpportunitiesInput"]: {
	financing_value: number,
	partner_id: number,
	project_type: string
};
	["EnergyBillAnalysisDecision"]: {
		decision: string,
	details?: string | undefined
};
	["GetOpportunitiesResponse"]: {
		addons_opportunities: Array<ModelTypes["AddonsOpportunities"]>,
	financing_gained_points?: number | undefined
};
	["AddonsOpportunities"]: {
		addon_type?: string | undefined,
	gained_points?: number | undefined,
	product_slug?: string | undefined
};
	["LevelBlackStatus"]: {
		kwGoalMonth: number,
	kwReachedMonth: number
};
	["Contact"]: {
		landline?: string | undefined,
	mobile: string,
	email: string
};
	["Responsible"]: {
		id: number,
	username?: string | undefined,
	profile: string,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	created_at: string,
	contact: ModelTypes["Contact"],
	partner?: ModelTypes["Partner"] | undefined
};
	["Score"]: {
		current: number,
	goal: number
};
	["Downgrade"]: {
		has_risk: boolean
};
	["Partner"]: {
		id: number,
	corporate_name: string,
	operation_term_accepted: boolean,
	trade_name: string,
	document: string,
	category?: string | undefined,
	state_registration: string,
	active: boolean,
	created_at: string,
	address: ModelTypes["Address"],
	responsible: ModelTypes["Responsible"],
	permission: ModelTypes["Permission"],
	users?: Array<ModelTypes["User"] | undefined> | undefined,
	sfplus?: ModelTypes["Sfplus"] | undefined
};
	["Post"]: {
		id: number,
	title: string,
	body: string,
	userId: string,
	comments?: Array<ModelTypes["Comment"] | undefined> | undefined
};
	["Comment"]: {
		id: number,
	name: string,
	email: string,
	body: string
};
	["OperatingAgreement"]: {
		is_current_term_accepted: boolean,
	can_accept: boolean
};
	["UserTerms"]: {
		operating_agreement: ModelTypes["OperatingAgreement"]
};
	["User"]: {
		id: number,
	username?: string | undefined,
	profile?: string | undefined,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	created_at: string,
	contact: ModelTypes["Contact"],
	partner?: ModelTypes["Partner"] | undefined,
	posts?: Array<ModelTypes["Post"] | undefined> | undefined,
	terms?: ModelTypes["UserTerms"] | undefined
};
	/** Estados que o portal NAO tem como deduzir — o backend manda, o portal traduz.

WalletPaymentModelSummary.state   ENABLED | MODEL_DISABLED | NOVICE | ESSENTIAL_PROFILE
                                  | COMMERCIAL_EXCEPTION | BLOCKED
WalletPaymentModelCard.state      ENABLED | DEFAULT | LOCKED | DISABLED | BLOCKED | WAIVED */
["WalletPaymentModelSummary"]: {
		/** Qual das 7 variantes do card do Resumo renderizar (Figma: MR overview card). */
	state: string,
	/** null quando state = BLOCKED — o corpo do card vira empty state. */
	current_model?: string | undefined,
	upfront_percentage: number,
	after_completion_percentage: number,
	/** Vem calculado do backend (que repassa o lambda). O portal NAO divide
on_time_completed/total_completed em lugar nenhum.
null quando state = NOVICE ou ESSENTIAL_PROFILE: o Figma tira o bloco de desempenho. */
	performance_percentage?: number | undefined,
	/** Qual modelo foi desabilitado apesar do desempenho. So com state = MODEL_DISABLED. */
	disabled_model?: string | undefined,
	/** Motivo, para 'O Modelo A foi desabilitado · Motivo: inadimplência da carteira em alerta'. */
	disabled_reason?: string | undefined,
	/** O '3' de '3 de 5 realizadas'. So com state = NOVICE. */
	novice_completed?: number | undefined,
	total_completed: number,
	on_time_completed: number,
	next_model?: string | undefined,
	projects_needed_for_next_model?: number | undefined,
	is_blocked: boolean,
	block_reason?: string | undefined,
	updated_at: string
};
	["WalletPaymentModelCard"]: {
		key: string,
	upfront_percentage: number,
	after_completion_percentage: number,
	min_on_time_percentage?: number | undefined,
	is_current: boolean,
	/** Substitui is_default e is_unlocked:
  LOCKED   — elegivel, ainda nao alcancou
  DISABLED — alcancou, mas um requisito entrou em alerta/critico
  BLOCKED  — conta bloqueada por fraude, atraso critico ou saude do CNPJ
Mais ENABLED, DEFAULT (so o C) e WAIVED (flexibilizacao comercial). */
	state: string,
	requirements: Array<ModelTypes["WalletModelRequirement"]>
};
	["WalletModelRequirement"]: {
		code: string,
	/** O que varia por parceiro. O portal nunca deduz isto comparando percentuais. */
	is_met: boolean,
	/** true = o portal RISCA o texto da linha (flexibilizacao comercial ativa). */
	is_waived: boolean
};
	["WalletDefaultModelCondition"]: {
		code: string,
	value?: number | undefined
};
	["WalletPaymentPerformance"]: {
		total_completed: number,
	on_time_completed: number,
	late_completed: number,
	/** Vem calculado do backend. O portal nao divide os contadores. */
	on_time_percentage: number,
	thresholds: ModelTypes["WalletPerformanceThresholds"],
	challenge?: ModelTypes["WalletPerformanceChallenge"] | undefined,
	by_kit_type: Array<ModelTypes["WalletPerformanceByKitType"]>
};
	["WalletPerformanceThresholds"]: {
		model_b: number,
	model_a: number
};
	["WalletPerformanceChallenge"]: {
		target_model?: string | undefined,
	projects_needed?: number | undefined
};
	["WalletPerformanceByKitType"]: {
		kit_type: string,
	on_time_count: number,
	late_count: number,
	projects_filter?: ModelTypes["WalletProjectsFilter"] | undefined
};
	["WalletProjectsFilter"]: {
		kit_type?: string | undefined,
	status?: string | undefined
};
	["WalletCommercialException"]: {
		is_active: boolean
};
	["WalletEligibilityContext"]: {
		partner_profile: string,
	is_novice: boolean,
	novice_completed: number,
	novice_required: number,
	performance_model: string,
	delinquency_status?: string | undefined,
	commercial_exception?: ModelTypes["WalletCommercialException"] | undefined
};
	["WalletPaymentModel"]: {
		summary: ModelTypes["WalletPaymentModelSummary"],
	models?: Array<ModelTypes["WalletPaymentModelCard"]> | undefined,
	default_model_conditions?: Array<ModelTypes["WalletDefaultModelCondition"]> | undefined,
	performance?: ModelTypes["WalletPaymentPerformance"] | undefined,
	eligibility_context?: ModelTypes["WalletEligibilityContext"] | undefined
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined,
	mutation?: ModelTypes["Mutation"] | undefined
}
    }

export type GraphQLTypes = {
    ["Order"]: Order;
	/** The `Upload` scalar type represents a file upload. */
["Upload"]: "scalar" & { name: "Upload" };
	["Combos"]: {
	__typename: "Combos",
	data: GraphQLTypes["ComboData"]
};
	["Cities"]: {
	__typename: "Cities",
	data: Array<GraphQLTypes["CityStateData"]>
};
	["AddressInstallation"]: {
	__typename: "AddressInstallation",
	data: GraphQLTypes["AddressInstallationData"]
};
	["ComboData"]: {
	__typename: "ComboData",
	nationality?: Array<GraphQLTypes["CityStateData"] | undefined> | undefined,
	gender?: Array<GraphQLTypes["CityStateData"] | undefined> | undefined,
	occupation?: Array<GraphQLTypes["CityStateData"] | undefined> | undefined,
	state?: Array<GraphQLTypes["CityStateData"] | undefined> | undefined
};
	["CepAddress"]: {
	__typename: "CepAddress",
	neighborhood: string,
	street: string,
	state: GraphQLTypes["CityStateData"],
	city: GraphQLTypes["CityStateData"]
};
	["AddressInstallationData"]: {
	__typename: "AddressInstallationData",
	postal_code: string,
	street: string,
	street_number: number,
	additional_info?: string | undefined,
	neighborhood: string,
	city: string,
	state: string,
	rural_area: boolean
};
	["CityStateData"]: {
	__typename: "CityStateData",
	name: string,
	id: string
};
	["Query"]: {
	__typename: "Query",
	/** Get customer registration combos
param: nationality: boolean - if want nationality
param: gender: boolean - if want gender
param: occupation: boolean - if want occupation
param: state: boolean - if want state */
	address_combos: GraphQLTypes["Combos"],
	/** Get cities based on state
param: state_id: int - id of state */
	address_cities: GraphQLTypes["Cities"],
	/** Get address information from CEP
param: cep: string - address CEP */
	address_from_cep: GraphQLTypes["CepAddress"],
	/** Get installation address
param: project_id: string - id of project */
	address_installation: GraphQLTypes["AddressInstallation"],
	customer_form?: GraphQLTypes["CustomerFormResponse"] | undefined,
	access_user_credentials: GraphQLTypes["AccessUserCredentialsResponse"],
	credentials_check: GraphQLTypes["CredentialsCheckResponse"],
	documents?: GraphQLTypes["DocumentResponse"] | undefined,
	financing?: GraphQLTypes["Financing"] | undefined,
	financingV2?: GraphQLTypes["FinancingV2"] | undefined,
	financings: GraphQLTypes["FinancingsList"],
	financing_type?: GraphQLTypes["FinancingType"] | undefined,
	formalization: GraphQLTypes["FormalizationInfo"],
	formalization_biometry_confirm: GraphQLTypes["ConfirmBiometryResponse"],
	formalization_v2: GraphQLTypes["FormalizedFinancing"],
	formalization_metrics: GraphQLTypes["FormalizationMetricsResponse"],
	targetIncentivesSummary?: GraphQLTypes["TargetIncentiveSummary"] | undefined,
	getCommissioningStatus: GraphQLTypes["CommissioningStatusResponse"],
	installation?: GraphQLTypes["Installation"] | undefined,
	mirrorStatus?: GraphQLTypes["MirrorStatus"] | undefined,
	inverter_brands: GraphQLTypes["InverterBrands"],
	available_orders?: GraphQLTypes["AvailableOrders"] | undefined,
	legacyFinancing?: GraphQLTypes["LegacyFinancing"] | undefined,
	notifications: GraphQLTypes["NotificationsList"],
	partner?: GraphQLTypes["OnlyPartner"] | undefined,
	partners?: Array<GraphQLTypes["CorePartner"]> | undefined,
	payment_current_issuance_model?: GraphQLTypes["PaymentCurrentIssuanceModel"] | undefined,
	projects_partner_overview: GraphQLTypes["PartnerOverview"],
	project?: GraphQLTypes["Project"] | undefined,
	project_proposal_changes?: GraphQLTypes["ProjectProposal"] | undefined,
	project_is_combo?: GraphQLTypes["IsComboResponse"] | undefined,
	project_system_types: Array<string>,
	registration?: GraphQLTypes["RegistrationDetailsResponse"] | undefined,
	/** Whether the grid access approval is hidden, optional or required for the project and the
installation site. city: city name; state: UF, two uppercase letters. */
	registration_grid_access_approval: GraphQLTypes["RegistrationGridAccessApproval"],
	risk_financing_revalidation_summary?: GraphQLTypes["RevalidationSummary"] | undefined,
	risk_financing_revalidations: GraphQLTypes["RevalidationsListResponse"],
	getOpportunities?: GraphQLTypes["GetOpportunitiesResponse"] | undefined,
	simulation_project_shopping_cart_id_get?: string | undefined,
	user?: GraphQLTypes["User"] | undefined,
	/** Aba Modelo de recebimento (entrega 1). Fonte: ip.ipa.receipt-model.
partner_id e OPCIONAL e so e honrado quando ctx.user.profile == 'admin' (impersonate).
Para qualquer outro perfil o argumento e IGNORADO e vale ctx.user.partner.id.
Erro do REST: retorna null + errors[] (nunca null silencioso). */
	wallet_payment_model?: GraphQLTypes["WalletPaymentModel"] | undefined
};
	["PersonTypes"]: PersonTypes;
	["DocumentTypes"]: DocumentTypes;
	["LegalRepresentantTypes"]: LegalRepresentantTypes;
	["CustomerStatus"]: CustomerStatus;
	["RegistrationContactChangeResponse"]: {
	__typename: "RegistrationContactChangeResponse",
	message: string,
	status?: number | undefined
};
	["CustomerFormResponse"]: {
	__typename: "CustomerFormResponse",
	project_id: string,
	is_combo?: boolean | undefined,
	person_type?: GraphQLTypes["PersonTypes"] | undefined,
	customer?: GraphQLTypes["CustomerData"] | undefined,
	guarantor?: GraphQLTypes["CustomerData"] | undefined,
	project?: GraphQLTypes["CustomerProject"] | undefined,
	remaining_changes_after_confirmation?: number | undefined,
	company?: GraphQLTypes["CompanyData"] | undefined,
	errors?: Array<GraphQLTypes["CustomerErrors"] | undefined> | undefined,
	status?: GraphQLTypes["CustomerStatus"] | undefined
};
	["CustomerErrors"]: {
	__typename: "CustomerErrors",
	field: string,
	title: string,
	description: string
};
	["CustomerContact"]: {
	__typename: "CustomerContact",
	email?: string | undefined,
	phone?: string | undefined
};
	["CustomerDocument"]: {
	__typename: "CustomerDocument",
	type: GraphQLTypes["DocumentTypes"],
	status: string,
	filename: string,
	url_download: string,
	url_preview: string,
	mime_type: string,
	id: string
};
	["CustomerAddress"]: {
	__typename: "CustomerAddress",
	zipcode?: string | undefined,
	street?: string | undefined,
	street_number?: string | undefined,
	complement?: string | undefined,
	neighborhood?: string | undefined,
	city_id?: number | undefined,
	state_id?: number | undefined,
	city?: GraphQLTypes["CustomerIdName"] | undefined,
	state?: GraphQLTypes["CustomerIdName"] | undefined,
	is_rural?: boolean | undefined
};
	["CustomerData"]: {
	__typename: "CustomerData",
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["CustomerContact"] | undefined,
	documents?: Array<GraphQLTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: GraphQLTypes["CustomerAddress"] | undefined
};
	["CustomerEletricityBill"]: {
	__typename: "CustomerEletricityBill",
	is_under_customer_name?: boolean | undefined,
	holder_cpf?: string | undefined,
	distributor_id?: number | undefined
};
	["CustomerProject"]: {
	__typename: "CustomerProject",
	address?: GraphQLTypes["CustomerAddress"] | undefined,
	documents?: Array<GraphQLTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	electricity_bill?: GraphQLTypes["CustomerEletricityBill"] | undefined,
	residencial_is_the_same_of_plant?: boolean | undefined
};
	["CompanyMajorityPartner"]: {
	__typename: "CompanyMajorityPartner",
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["CustomerContact"] | undefined,
	documents?: Array<GraphQLTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: GraphQLTypes["CustomerAddress"] | undefined
};
	["CompanyLegalRepresentant"]: {
	__typename: "CompanyLegalRepresentant",
	kind?: GraphQLTypes["LegalRepresentantTypes"] | undefined,
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["CustomerContact"] | undefined,
	documents?: Array<GraphQLTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	address?: GraphQLTypes["CustomerAddress"] | undefined
};
	["CompanyData"]: {
	__typename: "CompanyData",
	company_name?: string | undefined,
	cnpj?: string | undefined,
	contact?: GraphQLTypes["CustomerContact"] | undefined,
	documents?: Array<GraphQLTypes["CustomerDocument"] | undefined> | undefined,
	document_type?: string | undefined,
	comment?: string | undefined,
	majority_partner?: GraphQLTypes["CompanyMajorityPartner"] | undefined,
	majority_partner_is_legal_representative?: boolean | undefined,
	is_only_one_legal_representative?: boolean | undefined,
	legal_representatives?: Array<GraphQLTypes["CompanyLegalRepresentant"] | undefined> | undefined
};
	["RegistrationV2PersonType"]: RegistrationV2PersonType;
	["CustomerIdName"]: {
	__typename: "CustomerIdName",
	id: number,
	name: string
};
	["CustomerRegistrationAddress"]: {
		zipcode: string,
	street: string,
	street_number: string,
	complement?: string | undefined,
	neighborhood: string,
	city_id: number,
	state_id: number,
	is_rural?: boolean | undefined
};
	["CustomerRegistrationContact"]: {
		email: string,
	phone: string
};
	["CustomerRegistrationDocument"]: {
		type: string,
	docstorage_id: string
};
	["CustomerRegistrationCustomer"]: {
		full_name: string,
	birthdate: string,
	contact: GraphQLTypes["CustomerRegistrationContact"],
	documents: Array<GraphQLTypes["CustomerRegistrationDocument"]>,
	address: GraphQLTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationGuarantor"]: {
		full_name: string,
	birthdate: string,
	contact: GraphQLTypes["CustomerRegistrationContact"],
	documents: Array<GraphQLTypes["CustomerRegistrationDocument"]>,
	address: GraphQLTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationElectricityBill"]: {
		is_under_customer_name: boolean,
	holder_cpf?: string | undefined,
	distributor_id?: number | undefined
};
	["CustomerRegistrationElectricityBillWithDocuments"]: {
		electricity_bill_docstorage_id: string,
	employment_proof_docstorage_id?: string | undefined,
	additional_document_docstorage_id?: string | undefined,
	holder_cpf?: string | undefined,
	is_under_customer_name: boolean
};
	["CustomerRegistrationProject"]: {
		address: GraphQLTypes["CustomerRegistrationAddress"],
	documents: Array<GraphQLTypes["CustomerRegistrationDocument"]>,
	comment?: string | undefined,
	electricity_bill: GraphQLTypes["CustomerRegistrationElectricityBill"],
	electricity_bills?: Array<GraphQLTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined
};
	["CustomerRegistrationCompany"]: {
		company_name: string,
	contact: GraphQLTypes["CustomerRegistrationContact"],
	documents: Array<GraphQLTypes["CustomerRegistrationDocument"]>,
	majority_partner: GraphQLTypes["CustomerRegistrationCustomer"],
	legal_representatives: Array<GraphQLTypes["CustomerRegistrationLegalRepresentative"]>
};
	["CustomerRegistrationLegalRepresentative"]: {
		kind: string,
	cpf: string,
	full_name: string,
	birthdate: string,
	contact: GraphQLTypes["CustomerRegistrationContact"],
	documents: Array<GraphQLTypes["CustomerRegistrationDocument"]>,
	address: GraphQLTypes["CustomerRegistrationAddress"]
};
	["CustomerRegistrationInput"]: {
		project_id: string,
	person_type: GraphQLTypes["RegistrationV2PersonType"],
	customer?: GraphQLTypes["CustomerRegistrationCustomer"] | undefined,
	guarantor?: GraphQLTypes["CustomerRegistrationGuarantor"] | undefined,
	project?: GraphQLTypes["CustomerRegistrationProject"] | undefined,
	company?: GraphQLTypes["CustomerRegistrationCompany"] | undefined,
	electricity_bills?: Array<GraphQLTypes["CustomerRegistrationElectricityBillWithDocuments"]> | undefined
};
	["Person"]: {
		email?: string | undefined,
	partner_id: string,
	phone?: string | undefined
};
	["CustomerDocumentUpload"]: {
	__typename: "CustomerDocumentUpload",
	id: string,
	url?: string | undefined,
	url_inline?: string | undefined,
	filename?: string | undefined,
	mimetype?: string | undefined,
	size?: number | undefined,
	docstorage_id?: string | undefined,
	created_at?: string | undefined
};
	["CustomerRegistrationError"]: {
	__typename: "CustomerRegistrationError",
	field: string,
	message: string,
	type: string,
	title?: string | undefined,
	description?: string | undefined
};
	["CustomerRegistrationV2Response"]: {
	__typename: "CustomerRegistrationV2Response",
	errors: Array<GraphQLTypes["CustomerRegistrationError"] | undefined>
};
	["CustomerDocumentFormAnalysis"]: {
	__typename: "CustomerDocumentFormAnalysis",
	id?: string | undefined,
	status?: string | undefined,
	project_id?: string | undefined,
	installation_document_matches_bill?: boolean | undefined,
	installation_address_matches_bill?: boolean | undefined,
	identity_matches_document?: boolean | undefined,
	reason?: string | undefined,
	comments?: string | undefined,
	documents?: Array<GraphQLTypes["CustomerDocumentUpload"] | undefined> | undefined
};
	["PersonInput"]: {
		email: string,
	phone: string
};
	["RegistrationContactChangeInput"]: {
		project_id: string,
	customer?: GraphQLTypes["PersonInput"] | undefined,
	guarantor?: GraphQLTypes["PersonInput"] | undefined,
	majority_partner?: GraphQLTypes["PersonInput"] | undefined,
	legal_representative_1?: GraphQLTypes["PersonInput"] | undefined,
	legal_representative_2?: GraphQLTypes["PersonInput"] | undefined
};
	["Mutation"]: {
	__typename: "Mutation",
	registration_contact_change: GraphQLTypes["RegistrationContactChangeResponse"],
	customer_document_upload?: Array<GraphQLTypes["CustomerDocumentUpload"] | undefined> | undefined,
	customer_document_form_analysis_cancel?: GraphQLTypes["CustomerDocumentFormAnalysis"] | undefined,
	customer_registration?: GraphQLTypes["CustomerRegistrationV2Response"] | undefined,
	register_device_orchestrator_gateway_credential: GraphQLTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"],
	device_orchestrator_credentials_change: GraphQLTypes["RegisterDeviceOrchestratorGatewayCredentialResponse"],
	formalization_term_combo_connect_resend: GraphQLTypes["TermComboConnectResponse"],
	validateHardwareForm?: GraphQLTypes["HardwareFormValidation"] | undefined,
	hardware_form_showcase?: GraphQLTypes["HardwareFormShowcaseResponse"] | undefined,
	hardware_form_draft?: string | undefined,
	installation_mirror_upload?: GraphQLTypes["MirrorUploadResponse"] | undefined,
	installation_inverter_labels_upload?: GraphQLTypes["UploadInstallationLabelsResponse"] | undefined,
	installation_power_inverters_validate?: GraphQLTypes["ValidateTotalInvertersPowerResponse"] | undefined,
	installation_section_delete: boolean,
	installation_section_document_delete: boolean,
	installation_customer_reproval: boolean,
	installation_installed_inverter_create: GraphQLTypes["CreatedInstalledInverter"],
	installation_installed_inverter_create_with_brand: GraphQLTypes["CreatedInstalledInverter"],
	installation_commissioning_check?: GraphQLTypes["CommissioningCheckResponse"] | undefined,
	installation_commissioning_request: GraphQLTypes["CommissioningRequestResponse"],
	installation_commissioning_reset_customer_rejection: GraphQLTypes["CommissioningResetResponse"],
	installation_biometric_validation: GraphQLTypes["BiometricValidationResponse"],
	markNotificationsRead: boolean,
	markNotificationClicked: boolean,
	project_update_shopping_cart: string,
	project_proposal_update: boolean,
	project_create: GraphQLTypes["ProjectCreateResponse"],
	registration?: boolean | undefined,
	risk_financing_register_credential: GraphQLTypes["RegisterRevalidationCredentialResponse"],
	risk_financing_submit_revalidations: GraphQLTypes["SubmitRevalidationsResponse"],
	processEnergyAccountAnalysis?: GraphQLTypes["EnergyBillAnalysisDecision"] | undefined
};
	/** Arbitrary JSON value */
["JSON"]: "scalar" & { name: "JSON" };
	["DeviceOrchestratorGatewayCredentialErrorCode"]: DeviceOrchestratorGatewayCredentialErrorCode;
	["RegisterDeviceOrchestratorGatewayCredentialResponse"]: {
	__typename: "RegisterDeviceOrchestratorGatewayCredentialResponse",
	success: boolean,
	message?: GraphQLTypes["DeviceOrchestratorGatewayCredentialErrorCode"] | undefined
};
	["RegisterDeviceOrchestratorGatewayCredentialInput"]: {
		brand: string,
	username: string,
	password: string
};
	["AccessUserCredentialsData"]: {
	__typename: "AccessUserCredentialsData",
	access_user: string,
	platform: string,
	partner_id: number
};
	["AccessUserCredentialsResponse"]: {
	__typename: "AccessUserCredentialsResponse",
	success: boolean,
	message?: string | undefined,
	data?: GraphQLTypes["AccessUserCredentialsData"] | undefined
};
	["CredentialsCheckResponse"]: {
	__typename: "CredentialsCheckResponse",
	has_credentials: boolean,
	is_valid: boolean,
	access_token?: string | undefined
};
	["DocumentResponse"]: {
	__typename: "DocumentResponse",
	data?: GraphQLTypes["DocumentData"] | undefined
};
	["DocumentData"]: {
	__typename: "DocumentData",
	project?: Array<GraphQLTypes["Documents"] | undefined> | undefined,
	customer?: Array<GraphQLTypes["Documents"] | undefined> | undefined,
	guarantor?: Array<GraphQLTypes["DocumentFile"] | undefined> | undefined,
	company?: Array<GraphQLTypes["DocumentFile"] | undefined> | undefined
};
	["Documents"]: {
	__typename: "Documents",
	id?: string | undefined,
	docstorage_id?: string | undefined,
	kind?: string | undefined,
	validated_at?: string | undefined,
	validation_mode?: string | undefined,
	deleted_at?: string | undefined,
	submitted_at?: string | undefined,
	canceled_at?: string | undefined,
	status?: string | undefined,
	reason?: GraphQLTypes["DocumentReason"] | undefined,
	file?: GraphQLTypes["DocumentFile"] | undefined
};
	["DocumentFile"]: {
	__typename: "DocumentFile",
	public_id?: string | undefined,
	filename?: string | undefined,
	mimetype?: string | undefined,
	size?: number | undefined,
	url?: string | undefined,
	url_inline?: string | undefined
};
	["DocumentReason"]: {
	__typename: "DocumentReason",
	title?: string | undefined,
	description?: string | undefined
};
	["PersonType"]: PersonType;
	["FinancingStatus"]: FinancingStatus;
	["FinancingSteps"]: FinancingSteps;
	["StatusList"]: StatusList;
	["FinancingV2"]: {
	__typename: "FinancingV2",
	id: number,
	project_id: string,
	financed_value: number,
	customer_name: string,
	document: string,
	expires_at: string,
	created_at: string,
	formalized_at?: string | undefined,
	installed_at?: string | undefined,
	status: GraphQLTypes["FinancingStatus"],
	step: string,
	is_combo: boolean,
	is_combo_connect?: boolean | undefined,
	payments: Array<GraphQLTypes["Payment"]>,
	flow_provider: string,
	person_type: GraphQLTypes["PersonType"],
	all_payments_sent: boolean,
	section_statuses: GraphQLTypes["FinancingSectionStatusesV2"],
	updated_at?: string | undefined,
	is_expired: boolean,
	system_power?: number | undefined,
	system_type?: string | undefined,
	inverters_power_kw?: number | undefined,
	new_journey?: boolean | undefined,
	legacy_id?: number | undefined,
	reason?: string | undefined,
	openable_steps?: GraphQLTypes["FormalizationStatuses"] | undefined,
	is_aproved?: boolean | undefined,
	is_final?: boolean | undefined
};
	["FinancingSectionStatusesV2"]: {
	__typename: "FinancingSectionStatusesV2",
	simulation: GraphQLTypes["FinancingStep"],
	installation: GraphQLTypes["FinancingStep"],
	customer_data: GraphQLTypes["FinancingStep"],
	equipment: GraphQLTypes["FinancingStep"],
	biometry_and_contract: GraphQLTypes["BiometryAndContractStep"],
	payment_model: GraphQLTypes["FinancingStep"]
};
	["GenericFinancingStep"]: {
	__typename:"FinancingStep" | "BiometryAndContractStep",
	completed_at?: string | undefined,
	reproved_at?: string | undefined,
	status?: string | undefined,
	submitted_at?: string | undefined
	['...on FinancingStep']: '__union' & GraphQLTypes["FinancingStep"];
	['...on BiometryAndContractStep']: '__union' & GraphQLTypes["BiometryAndContractStep"];
};
	["FinancingStep"]: {
	__typename: "FinancingStep",
	completed_at?: string | undefined,
	reproved_at?: string | undefined,
	status?: string | undefined,
	submitted_at?: string | undefined
};
	["MetadataItem"]: {
	__typename: "MetadataItem",
	completed_at?: string | undefined,
	first_submitted_at?: string | undefined,
	last_submitted_at?: string | undefined
};
	["BiometryAndContractMetadata"]: {
	__typename: "BiometryAndContractMetadata",
	biometry?: GraphQLTypes["MetadataItem"] | undefined,
	contract?: GraphQLTypes["MetadataItem"] | undefined,
	term?: GraphQLTypes["MetadataItem"] | undefined
};
	["BiometryAndContractStep"]: {
	__typename: "BiometryAndContractStep",
	completed_at?: string | undefined,
	reproved_at?: string | undefined,
	status?: string | undefined,
	submitted_at?: string | undefined,
	metadata?: GraphQLTypes["BiometryAndContractMetadata"] | undefined
};
	["Payment"]: {
	__typename: "Payment",
	id?: number | undefined,
	financing_id?: number | undefined,
	value?: number | undefined,
	total_value?: number | undefined,
	payment_percentage?: number | undefined,
	created_at?: string | undefined
};
	["Financing"]: {
	__typename: "Financing",
	id: number,
	project_id: string,
	financed_value: number,
	project_value: number,
	customer_name: string,
	document: string,
	expires_at: string,
	created_at: string,
	formalized_at?: string | undefined,
	installed_at?: string | undefined,
	status: GraphQLTypes["FinancingStatus"],
	step: string,
	is_combo: boolean,
	is_combo_connect?: boolean | undefined,
	payments: Array<GraphQLTypes["Payment"]>,
	flow_provider: string,
	person_type: GraphQLTypes["PersonType"],
	all_payments_sent: boolean,
	section_statuses: GraphQLTypes["FinancingSectionStatus"],
	updated_at?: string | undefined,
	is_expired: boolean,
	system_power?: number | undefined,
	new_journey?: boolean | undefined,
	legacy_id?: number | undefined,
	reason?: string | undefined,
	openable_steps?: GraphQLTypes["FormalizationStatuses"] | undefined,
	is_aproved?: boolean | undefined,
	is_final?: boolean | undefined,
	loan_value: number
};
	["FormalizationStatuses"]: {
	__typename: "FormalizationStatuses",
	hardware: boolean,
	registration: boolean,
	documentation: boolean,
	contract: boolean,
	receiptModel: boolean
};
	["FinancingProposal"]: {
	__typename: "FinancingProposal",
	customer_data?: string | undefined,
	equipment?: string | undefined,
	biometry_and_contract?: string | undefined,
	payment_model?: string | undefined
};
	["FinancingFormalization"]: {
	__typename: "FinancingFormalization",
	contract?: string | undefined,
	hardware?: string | undefined,
	registration?: string | undefined,
	documentation?: string | undefined,
	receipt_model?: string | undefined
};
	["FinancingSectionStatus"]: {
	__typename: "FinancingSectionStatus",
	concluded?: string | undefined,
	simulation?: string | undefined,
	installation?: string | undefined,
	proposal?: GraphQLTypes["FinancingProposal"] | undefined,
	formalization?: GraphQLTypes["FinancingFormalization"] | undefined
};
	["FinancingsList"]: {
	__typename: "FinancingsList",
	data: Array<GraphQLTypes["Financing"]>,
	has_next?: boolean | undefined,
	statuses?: Array<GraphQLTypes["StatusList"] | undefined> | undefined,
	all_steps: Array<GraphQLTypes["Item"]>
};
	["Item"]: {
	__typename: "Item",
	name: string,
	value: string
};
	["FinancingsInput"]: {
		formalized_gte?: number | undefined,
	formalized_lte?: number | undefined,
	is_canceled?: boolean | undefined,
	is_combo?: string | undefined,
	is_combo_connect?: boolean | undefined,
	is_expired?: boolean | undefined,
	is_installed?: boolean | undefined,
	order_by?: string | undefined,
	page?: number | undefined,
	page_size?: number | undefined,
	partner_id?: string | undefined,
	provider?: string | undefined,
	query?: string | undefined,
	status?: Array<GraphQLTypes["FinancingStatus"]> | undefined,
	steps?: Array<GraphQLTypes["FinancingSteps"]> | undefined
};
	["FinancingType"]: {
	__typename: "FinancingType",
	max_financing_value: number,
	min_financing_value: number,
	max_financing_installments: number,
	grace_period_financing: GraphQLTypes["GracePeriod"],
	max_bnpl_value?: number | undefined,
	max_bnpl_installments?: number | undefined,
	grace_period_bnpl?: GraphQLTypes["GracePeriod"] | undefined
};
	["GracePeriod"]: {
	__typename: "GracePeriod",
	label?: string | undefined,
	value: number
};
	["FormalizationInfo"]: {
	__typename: "FormalizationInfo",
	approval: string,
	biometry: GraphQLTypes["Biometry"],
	cancel: boolean,
	contract: GraphQLTypes["Contract"],
	cancellation_type?: string | undefined,
	contracts?: GraphQLTypes["FormalizationContracts"] | undefined,
	term?: GraphQLTypes["Term"] | undefined,
	download: GraphQLTypes["Download"],
	order_id?: string | undefined,
	pendencies?: GraphQLTypes["Pendencies"] | undefined,
	remaining_contract_days_until_expiration: number,
	resend: boolean,
	send_biometry_contract: GraphQLTypes["SendBiometryContract"],
	status: string,
	status_reason?: GraphQLTypes["FormalizationStatusReason"] | undefined
};
	["FormalizationStatusReason"]: {
	__typename: "FormalizationStatusReason",
	code?: string | undefined,
	description?: string | undefined
};
	["Biometry"]: {
	__typename: "Biometry",
	pending: boolean,
	signers: Array<GraphQLTypes["Signer"]>,
	status: string
};
	["Contract"]: {
	__typename: "Contract",
	has_biometric?: boolean | undefined,
	signers: Array<GraphQLTypes["ContractSigner"]>,
	status: string
};
	["FormalizationContractSection"]: {
	__typename: "FormalizationContractSection",
	status: string,
	document_signed?: string | undefined,
	signers: Array<GraphQLTypes["ContractSigner"]>
};
	["FormalizationContracts"]: {
	__typename: "FormalizationContracts",
	financing_amendment_term?: Array<GraphQLTypes["FormalizationContractSection"]> | undefined,
	loan?: GraphQLTypes["FormalizationContractSection"] | undefined,
	lender_insurance?: GraphQLTypes["FormalizationContractSection"] | undefined,
	diverse_risks_insurance?: GraphQLTypes["FormalizationContractSection"] | undefined,
	combo_connect_term?: GraphQLTypes["FormalizationContractSection"] | undefined
};
	["Term"]: {
	__typename: "Term",
	signers: Array<GraphQLTypes["ContractSigner"]>,
	status: string
};
	["Signer"]: {
	__typename: "Signer",
	name: string,
	checked: boolean,
	status?: string | undefined
};
	["ContractSigner"]: {
	__typename: "ContractSigner",
	name: string,
	checked: boolean
};
	["Download"]: {
	__typename: "Download",
	contract?: string | undefined,
	insurance?: string | undefined,
	term?: string | undefined
};
	["Pendencies"]: {
	__typename: "Pendencies",
	expired_at: string,
	items: Array<GraphQLTypes["PendencyItem"]>
};
	["PendencyItem"]: {
	__typename: "PendencyItem",
	category: string,
	message: string
};
	["SendBiometryContract"]: {
	__typename: "SendBiometryContract",
	message: GraphQLTypes["BiometryMessage"],
	method_receipt: string
};
	["BiometryMessage"]: {
	__typename: "BiometryMessage",
	days: number,
	time: number
};
	["ConfirmBiometryResponse"]: {
	__typename: "ConfirmBiometryResponse",
	is_done: boolean
};
	["TermComboConnectResponse"]: {
	__typename: "TermComboConnectResponse",
	success: boolean,
	message?: string | undefined
};
	["FormalizedFinancing"]: {
	__typename: "FormalizedFinancing",
	id: number,
	new_journey: boolean,
	project_id: string,
	partner_commission_percent?: number | undefined,
	financing_line?: string | undefined,
	company?: GraphQLTypes["FormalizedFinancingCompany"] | undefined,
	customer?: GraphQLTypes["FormalizedFinancingCustomer"] | undefined,
	guarantor?: GraphQLTypes["FormalizedFinancingGuarantor"] | undefined,
	legal_representatives?: Array<GraphQLTypes["FormalizedFinancingLegalRepresentative"]> | undefined,
	majority_partner?: GraphQLTypes["FormalizedFinancingMajorityPartner"] | undefined,
	proposal?: GraphQLTypes["FormalizedFinancingProposal"] | undefined,
	contract?: GraphQLTypes["FormalizedFinancingContract"] | undefined,
	partner?: GraphQLTypes["FormalizedFinancingPartner"] | undefined,
	securitization?: GraphQLTypes["FormalizedFinancingSecuritization"] | undefined,
	funding?: string | undefined,
	project?: GraphQLTypes["FormalizedFinancingProject"] | undefined
};
	["FormalizedFinancingCustomer"]: {
	__typename: "FormalizedFinancingCustomer",
	address: GraphQLTypes["FormalizedFinancingCustomerAddress"],
	birthdate: string,
	contact: GraphQLTypes["FormalizedFinancingCustomerContact"],
	cpf: string,
	full_name: string
};
	["FormalizedFinancingCustomerAddress"]: {
	__typename: "FormalizedFinancingCustomerAddress",
	city: string,
	complement?: string | undefined,
	neighborhood: string,
	state: string,
	street: string,
	street_number: string,
	zipcode: string
};
	["FormalizedFinancingCustomerContact"]: {
	__typename: "FormalizedFinancingCustomerContact",
	email: string,
	phone: string
};
	["FormalizedFinancingContract"]: {
	__typename: "FormalizedFinancingContract",
	banking?: string | undefined,
	ccb_number?: string | undefined,
	formalized_at?: string | undefined,
	generate_date?: string | undefined,
	signed_date?: string | undefined
};
	["FormalizedFinancingPartner"]: {
	__typename: "FormalizedFinancingPartner",
	id: string,
	cnpj: string,
	company_name: string,
	payment_institution: string
};
	["FormalizedFinancingProposal"]: {
	__typename: "FormalizedFinancingProposal",
	installments_number: number,
	rate_type: string,
	installment_amount: number,
	gross_amount: number,
	down_payment: number,
	grace_period: number,
	registration_fee: number,
	interest_fee: number,
	iof: number,
	ipca_type: string,
	cet: number
};
	["FormalizedFinancingSecuritization"]: {
	__typename: "FormalizedFinancingSecuritization",
	cnpj: string,
	slug: string,
	corporate_name: string,
	name: string
};
	["FormalizedFinancingProject"]: {
	__typename: "FormalizedFinancingProject",
	electrical_phase?: string | undefined,
	installed_at?: string | undefined,
	inverter_type?: string | undefined,
	inverters: Array<GraphQLTypes["FormalizedFinancingInverter"]>,
	modules: Array<GraphQLTypes["FormalizedFinancingModule"]>,
	total_powers: GraphQLTypes["FormalizedFinancingTotalPowers"]
};
	["FormalizedFinancingInverter"]: {
	__typename: "FormalizedFinancingInverter",
	brand: string,
	contactor_switch?: string | undefined,
	model: string,
	phase: string,
	power: number,
	voltage: number,
	quantity: number
};
	["FormalizedFinancingModule"]: {
	__typename: "FormalizedFinancingModule",
	brand: string,
	model: string,
	phase: string,
	power: number,
	voltage?: number | undefined,
	quantity: number
};
	["FormalizedFinancingTotalPowers"]: {
	__typename: "FormalizedFinancingTotalPowers",
	system: number,
	modules: number,
	inverters: number
};
	["FormalizedFinancingCompany"]: {
	__typename: "FormalizedFinancingCompany",
	company_name: string,
	cnpj: string
};
	["FormalizedFinancingGuarantor"]: {
	__typename: "FormalizedFinancingGuarantor",
	full_name?: string | undefined,
	cpf?: string | undefined
};
	["FormalizedFinancingMajorityPartner"]: {
	__typename: "FormalizedFinancingMajorityPartner",
	full_name: string,
	cpf: string,
	percentage?: number | undefined,
	contact: GraphQLTypes["FormalizedFinancingCustomerContact"]
};
	["FormalizedFinancingLegalRepresentative"]: {
	__typename: "FormalizedFinancingLegalRepresentative",
	full_name: string,
	cpf: string,
	role?: string | undefined
};
	["FormalizationBucket"]: {
	__typename: "FormalizationBucket",
	amount: number,
	count: number,
	pct: number
};
	["FormalizationBuckets"]: {
	__typename: "FormalizationBuckets",
	lte_45: GraphQLTypes["FormalizationBucket"],
	d46_60: GraphQLTypes["FormalizationBucket"],
	d61_90: GraphQLTypes["FormalizationBucket"],
	gt_90: GraphQLTypes["FormalizationBucket"],
	lte_60: GraphQLTypes["FormalizationBucket"],
	lte_90: GraphQLTypes["FormalizationBucket"]
};
	["FormalizationIntegratorMetrics"]: {
	__typename: "FormalizationIntegratorMetrics",
	partner_id: string,
	partner_name: string,
	total_formalized: number,
	total_formalized_in_window: number,
	total_installed: number,
	total_installed_in_window: number,
	buckets: GraphQLTypes["FormalizationBuckets"],
	buckets_pending: GraphQLTypes["FormalizationBuckets"]
};
	["FormalizationMetricsResponse"]: {
	__typename: "FormalizationMetricsResponse",
	window_days: number,
	items: Array<GraphQLTypes["FormalizationIntegratorMetrics"]>,
	has_next: boolean
};
	["Incentive"]: {
	__typename: "Incentive",
	title_ptbr: string,
	description_ptbr: string,
	banner_url?: string | undefined
};
	["TargetIncentiveSummary"]: {
	__typename: "TargetIncentiveSummary",
	campaign_id: string,
	incentive: GraphQLTypes["Incentive"]
};
	["FileStatusType"]: FileStatusType;
	["DocumentStatusType"]: DocumentStatusType;
	["TypeSection"]: TypeSection;
	["MirrorStatuses"]: MirrorStatuses;
	["Status"]: {
	__typename: "Status",
	description: string,
	id: number,
	slug: GraphQLTypes["DocumentStatusType"]
};
	["Document"]: {
	__typename: "Document",
	filename: string,
	filetype: string,
	id: string,
	status?: GraphQLTypes["Status"] | undefined,
	type: string,
	url: string
};
	["Section"]: {
	__typename: "Section",
	documents?: Array<GraphQLTypes["Document"] | undefined> | undefined,
	id: string,
	status: GraphQLTypes["Status"],
	type: GraphQLTypes["TypeSection"]
};
	["InstallationStatus"]: {
	__typename: "InstallationStatus",
	description: string,
	id: number,
	slug: GraphQLTypes["FileStatusType"]
};
	["Installation"]: {
	__typename: "Installation",
	comment?: string | undefined,
	concluded_at?: string | undefined,
	grade: number,
	has_ampera: boolean,
	has_ampera_activated: boolean,
	has_minimal_projects: boolean,
	id: string,
	new_journey: boolean,
	plant_id?: string | undefined,
	plant_url?: string | undefined,
	project_id: string,
	project_name: string,
	sections: Array<GraphQLTypes["Section"]>,
	status: GraphQLTypes["InstallationStatus"],
	installed_inverters?: GraphQLTypes["InstalledInverters"] | undefined,
	stage?: number | undefined,
	stage_updated_at?: string | undefined,
	stage_error?: string | undefined,
	stage_customer_phone?: string | undefined
};
	["HardwareFormInverter"]: {
		id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormModule"]: {
		id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormComboEquipment"]: {
		sku: string,
	power?: number | undefined,
	quantity: number
};
	["HardwareFormBatteries"]: {
		id: number,
	quantity: number,
	power?: number | undefined
};
	["HardwareFormComboMetadata"]: {
		project_id: string,
	sku?: string | undefined,
	power?: number | undefined,
	price?: number | undefined,
	inverters: Array<GraphQLTypes["HardwareFormComboEquipment"]>,
	modules: Array<GraphQLTypes["HardwareFormComboEquipment"]>
};
	["HardwareFormInput"]: {
		is_combo: boolean,
	id?: string | undefined,
	combo_price?: number | undefined,
	inverter_type?: string | undefined,
	project_id: string,
	distributor_id: number,
	phase_id: number,
	inverters: Array<GraphQLTypes["HardwareFormInverter"]>,
	modules: Array<GraphQLTypes["HardwareFormModule"]>,
	batteries?: Array<GraphQLTypes["HardwareFormBatteries"]> | undefined,
	combo_metadata?: GraphQLTypes["HardwareFormComboMetadata"] | undefined,
	is_showcase?: boolean | undefined,
	shopping_cart_id?: string | undefined
};
	["HardwareFormShowcaseInput"]: {
		price?: number | undefined,
	project_id: string,
	inverters: Array<GraphQLTypes["HardwareFormInverter"]>,
	modules: Array<GraphQLTypes["HardwareFormModule"]>,
	shopping_cart_id?: string | undefined
};
	["ValidateTotalInvertersPowerInput"]: {
		project_id: string,
	total_inverters_power_kw: number
};
	["CustomerReprovalInput"]: {
		validation_message_id: string
};
	["BiometricValidationInput"]: {
		project_id: string
};
	["BiometricValidationStatus"]: BiometricValidationStatus;
	["BiometricValidationReason"]: BiometricValidationReason;
	["BiometricValidationResponse"]: {
	__typename: "BiometricValidationResponse",
	reason: GraphQLTypes["BiometricValidationReason"],
	retry_after_seconds: number,
	retry_at: string,
	status: GraphQLTypes["BiometricValidationStatus"]
};
	["ValidateTotalInvertersPowerResponse"]: {
	__typename: "ValidateTotalInvertersPowerResponse",
	is_valid: boolean,
	error?: string | undefined
};
	["ValidateHardwareFormPricePerWatt"]: {
	__typename: "ValidateHardwareFormPricePerWatt",
	is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormSystemPower"]: {
	__typename: "ValidateHardwareFormSystemPower",
	is_valid?: boolean | undefined
};
	["ValidateHardwareFormModules"]: {
	__typename: "ValidateHardwareFormModules",
	price_per_watt?: GraphQLTypes["ValidateHardwareFormPricePerWatt"] | undefined,
	system_power?: GraphQLTypes["ValidateHardwareFormSystemPower"] | undefined
};
	["ValidateHardwareFormOverload"]: {
	__typename: "ValidateHardwareFormOverload",
	is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormInverters"]: {
	__typename: "ValidateHardwareFormInverters",
	overload?: GraphQLTypes["ValidateHardwareFormOverload"] | undefined
};
	["ValidateHardwareFormCapacity"]: {
	__typename: "ValidateHardwareFormCapacity",
	is_valid?: boolean | undefined,
	is_under_expected?: boolean | undefined,
	is_over_expected?: boolean | undefined
};
	["ValidateHardwareFormBatteries"]: {
	__typename: "ValidateHardwareFormBatteries",
	capacity?: GraphQLTypes["ValidateHardwareFormCapacity"] | undefined
};
	["ValidateHardwareFormHardware"]: {
	__typename: "ValidateHardwareFormHardware",
	modules?: GraphQLTypes["ValidateHardwareFormModules"] | undefined,
	inverters?: GraphQLTypes["ValidateHardwareFormInverters"] | undefined,
	batteries?: GraphQLTypes["ValidateHardwareFormBatteries"] | undefined
};
	["HardwareFormValidation"]: {
	__typename: "HardwareFormValidation",
	is_valid?: boolean | undefined,
	hardware?: GraphQLTypes["ValidateHardwareFormHardware"] | undefined
};
	["HardwareFormShowcaseResponse"]: {
	__typename: "HardwareFormShowcaseResponse",
	overload_is_valid?: boolean | undefined,
	price_per_watt_is_valid?: boolean | undefined,
	percentage_of_service_with_combo_is_valid?: boolean | undefined
};
	["MirrorStatus"]: {
	__typename: "MirrorStatus",
	status: GraphQLTypes["MirrorStatuses"]
};
	["MirrorUploadResponse"]: {
	__typename: "MirrorUploadResponse",
	id: string,
	url: string
};
	["HardwareDraftEquipment"]: {
		sku: string,
	quantity: number,
	power?: number | undefined,
	model: string,
	brand: string
};
	["HardwareDraft"]: {
		project_id: string,
	sku?: string | undefined,
	power?: number | undefined,
	price?: number | undefined,
	inverters: Array<GraphQLTypes["HardwareDraftEquipment"]>,
	modules: Array<GraphQLTypes["HardwareDraftEquipment"]>
};
	["CreateInstalledInverterInput"]: {
		model?: string | undefined,
	power_kw: number,
	serial_number: string
};
	["CreateInstalledInverterWithBrandInput"]: {
		brand: string,
	model?: string | undefined,
	power_kw: number,
	serial_number: string
};
	["CreatedInstalledInverter"]: {
	__typename: "CreatedInstalledInverter",
	id: string,
	installation_id: string,
	brand: string,
	model?: string | undefined,
	power_kw: number,
	serial_number: string,
	entry_mode: string,
	status: GraphQLTypes["InstalledInverterStatus"]
};
	["UploadInstallationLabelsResponse"]: {
	__typename: "UploadInstallationLabelsResponse",
	inverter_label_file: string,
	inverter_label_file_url: string,
	datalogger_label_file?: string | undefined,
	datalogger_label_file_url?: string | undefined
};
	["InstalledInverterGlobalStatus"]: InstalledInverterGlobalStatus;
	["InstalledInverterStatus"]: InstalledInverterStatus;
	["InstalledInverters"]: {
	__typename: "InstalledInverters",
	status: GraphQLTypes["InstalledInverterGlobalStatus"],
	inverters?: Array<GraphQLTypes["InstalledInverter"]> | undefined
};
	["InstalledInverter"]: {
	__typename: "InstalledInverter",
	id: string,
	model?: string | undefined,
	brand?: string | undefined,
	power_kw?: number | undefined,
	serial_number?: string | undefined,
	datalogger_serial_number?: string | undefined,
	status: GraphQLTypes["InstalledInverterStatus"],
	entry_mode: string,
	created_at: string,
	updated_at: string
};
	["CommissioningCheckStatus"]: CommissioningCheckStatus;
	["CommissioningMonitoringStatus"]: CommissioningMonitoringStatus;
	["CommissioningFailureReason"]: CommissioningFailureReason;
	["CommissioningCheckResponse"]: {
	__typename: "CommissioningCheckResponse",
	checked_at?: string | undefined,
	status: GraphQLTypes["CommissioningCheckStatus"],
	access_user?: string | undefined
};
	["InverterBrands"]: {
	__typename: "InverterBrands",
	brands: Array<string>
};
	["AvailableOrderKitItemCategory"]: {
	__typename: "AvailableOrderKitItemCategory",
	id?: number | undefined,
	description?: string | undefined
};
	["AvailableOrderKitItem"]: {
	__typename: "AvailableOrderKitItem",
	item_id?: string | undefined,
	description?: string | undefined,
	quantity?: number | undefined,
	value?: number | undefined,
	type?: string | undefined,
	power?: number | undefined,
	category?: GraphQLTypes["AvailableOrderKitItemCategory"] | undefined
};
	["AvailableOrderKitChannel"]: {
	__typename: "AvailableOrderKitChannel",
	channel?: string | undefined,
	source?: string | undefined
};
	["AvailableOrderKitCustomer"]: {
	__typename: "AvailableOrderKitCustomer",
	type?: string | undefined,
	document_number?: string | undefined,
	name?: string | undefined,
	phone?: string | undefined,
	email?: string | undefined,
	billing_type?: string | undefined,
	street?: string | undefined,
	number?: string | undefined,
	neighborhood?: string | undefined,
	city?: string | undefined,
	state?: string | undefined,
	ibge_code?: string | undefined,
	zip_code?: string | undefined,
	complement?: string | undefined
};
	["AvailableOrderKitShipping"]: {
	__typename: "AvailableOrderKitShipping",
	freight_type?: string | undefined,
	freight_value?: number | undefined,
	recipient_name?: string | undefined,
	recipient_phone?: string | undefined,
	recipient_email?: string | undefined,
	rural_zone?: boolean | undefined,
	street?: string | undefined,
	number?: string | undefined,
	neighborhood?: string | undefined,
	city?: string | undefined,
	state?: string | undefined,
	ibge_code?: string | undefined,
	zip_code?: string | undefined,
	complement?: string | undefined
};
	["AvailableOrderKitUser"]: {
	__typename: "AvailableOrderKitUser",
	partner_id?: number | undefined,
	partner_cnpj?: string | undefined,
	user_id?: number | undefined
};
	["AvailableOrderKitPayment"]: {
	__typename: "AvailableOrderKitPayment",
	origin?: string | undefined,
	value?: number | undefined,
	installments?: number | undefined
};
	["AvailableOrderKit"]: {
	__typename: "AvailableOrderKit",
	error?: string | undefined,
	id?: string | undefined,
	order_number?: number | undefined,
	legacy_id?: number | undefined,
	cart_id?: string | undefined,
	type?: string | undefined,
	category?: string | undefined,
	created_at?: string | undefined,
	region?: string | undefined,
	dc_id?: number | undefined,
	reservation_id?: string | undefined,
	raw_value?: number | undefined,
	total_value?: number | undefined,
	items?: Array<GraphQLTypes["AvailableOrderKitItem"]> | undefined,
	channel?: GraphQLTypes["AvailableOrderKitChannel"] | undefined,
	customer?: GraphQLTypes["AvailableOrderKitCustomer"] | undefined,
	shipping?: GraphQLTypes["AvailableOrderKitShipping"] | undefined,
	user?: GraphQLTypes["AvailableOrderKitUser"] | undefined,
	payment?: GraphQLTypes["AvailableOrderKitPayment"] | undefined,
	status?: GraphQLTypes["JSON"] | undefined,
	erp_code?: string | undefined,
	erp_branch?: string | undefined,
	summary?: GraphQLTypes["JSON"] | undefined,
	expires_at?: string | undefined
};
	["AvailableOrder"]: {
	__typename: "AvailableOrder",
	order_id: number,
	value: string,
	created_at?: string | undefined,
	expire_at?: string | undefined,
	kit?: GraphQLTypes["AvailableOrderKit"] | undefined
};
	["AvailableOrdersPagination"]: {
	__typename: "AvailableOrdersPagination",
	page?: number | undefined,
	page_size?: number | undefined,
	total?: number | undefined,
	has_next?: boolean | undefined
};
	["AvailableOrders"]: {
	__typename: "AvailableOrders",
	data: Array<GraphQLTypes["AvailableOrder"]>,
	pagination?: GraphQLTypes["AvailableOrdersPagination"] | undefined
};
	["MonitoringInput"]: {
		brand: string,
	expected_plant_name?: string | undefined,
	inverters: Array<string>
};
	["CommissioningRequestInput"]: {
		installation_id: string,
	total_power_kw: number,
	monitorings: Array<GraphQLTypes["MonitoringInput"]>
};
	["CommissioningInstalledInverter"]: {
	__typename: "CommissioningInstalledInverter",
	id: string,
	serial_number: string,
	status: string
};
	["CommissioningMonitoring"]: {
	__typename: "CommissioningMonitoring",
	id: string,
	brand: string,
	status: string,
	installed_inverters: Array<GraphQLTypes["CommissioningInstalledInverter"]>
};
	["CommissioningRequestData"]: {
	__typename: "CommissioningRequestData",
	installation_id?: string | undefined,
	code?: string | undefined,
	monitorings: Array<GraphQLTypes["CommissioningMonitoring"]>
};
	["CommissioningRequestResponse"]: {
	__typename: "CommissioningRequestResponse",
	success: boolean,
	message: string,
	data: GraphQLTypes["CommissioningRequestData"]
};
	["CommissioningResetData"]: {
	__typename: "CommissioningResetData",
	project_id?: string | undefined,
	installation_id?: string | undefined,
	removed_monitorings?: number | undefined,
	removed_inverters?: number | undefined,
	code?: string | undefined
};
	["CommissioningResetResponse"]: {
	__typename: "CommissioningResetResponse",
	success: boolean,
	message: string,
	data: GraphQLTypes["CommissioningResetData"]
};
	["CommissioningStatusInstalledInverter"]: {
	__typename: "CommissioningStatusInstalledInverter",
	id: string,
	serial_number: string,
	model?: string | undefined,
	power_kw?: number | undefined,
	status: GraphQLTypes["InstalledInverterStatus"]
};
	["CommissioningStatusMonitoring"]: {
	__typename: "CommissioningStatusMonitoring",
	brand: string,
	status: GraphQLTypes["CommissioningMonitoringStatus"],
	plant_name?: string | undefined,
	commissioning_failure_reason?: GraphQLTypes["CommissioningFailureReason"] | undefined,
	installed_inverters: Array<GraphQLTypes["CommissioningStatusInstalledInverter"]>
};
	["CommissioningInstallationStatus"]: CommissioningInstallationStatus;
	["CommissioningStatusCustomerValidationRequest"]: {
	__typename: "CommissioningStatusCustomerValidationRequest",
	id: string,
	status: string,
	attempt_number: number,
	initiated_at: string
};
	["CommissioningStatusData"]: {
	__typename: "CommissioningStatusData",
	installation_id?: string | undefined,
	installation_status?: GraphQLTypes["CommissioningInstallationStatus"] | undefined,
	access_user?: string | undefined,
	monitorings: Array<GraphQLTypes["CommissioningStatusMonitoring"]>,
	customer_validation_requests: Array<GraphQLTypes["CommissioningStatusCustomerValidationRequest"]>
};
	["CommissioningStatusResponse"]: {
	__typename: "CommissioningStatusResponse",
	success: boolean,
	message: string,
	data: GraphQLTypes["CommissioningStatusData"]
};
	["LegacyFinancing"]: {
	__typename: "LegacyFinancing",
	projectId: string,
	financingId: number,
	formalizedAt?: string | undefined,
	stage: string,
	status: string
};
	["NotificationData"]: {
	__typename: "NotificationData",
	id: number,
	clickedAt?: string | undefined,
	readAt?: string | undefined,
	createdAt: string,
	notification: GraphQLTypes["Notification"]
};
	["Notification"]: {
	__typename: "Notification",
	actionUrl: string,
	templateName: string,
	message: string,
	title: string
};
	["Metrics"]: {
	__typename: "Metrics",
	totalCount: number,
	totalUnreadCount: number,
	totalUnclickedCount: number
};
	["NotificationsList"]: {
	__typename: "NotificationsList",
	count: number,
	totalCount: number,
	nextCursor?: string | undefined,
	nextPage?: string | undefined,
	previousCursor?: string | undefined,
	previousPage?: string | undefined,
	data: Array<GraphQLTypes["NotificationData"]>,
	metrics: GraphQLTypes["Metrics"]
};
	["ContactPartner"]: {
	__typename: "ContactPartner",
	phone?: string | undefined,
	email: string
};
	["Address"]: {
	__typename: "Address",
	street: string,
	number: string,
	complement?: string | undefined,
	reference?: string | undefined,
	district: string,
	zipcode: string,
	city: string,
	state: string
};
	["ResponsiblePartner"]: {
	__typename: "ResponsiblePartner",
	username?: string | undefined,
	profile: string,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	contact: GraphQLTypes["ContactPartner"]
};
	["Permission"]: {
	__typename: "Permission",
	store: boolean,
	financing: boolean
};
	["Sfplus"]: {
	__typename: "Sfplus",
	level: number,
	is_level_black: boolean,
	next_transition_date?: string | undefined,
	score?: GraphQLTypes["Score"] | undefined,
	black_status?: GraphQLTypes["LevelBlackStatus"] | undefined,
	downgrade?: GraphQLTypes["Downgrade"] | undefined
};
	["OnlyPartner"]: {
	__typename: "OnlyPartner",
	id: number,
	corporate_name: string,
	trade_name: string,
	document: string,
	category?: string | undefined,
	state_registration: string,
	active: boolean,
	operation_term_accepted: boolean,
	address: GraphQLTypes["Address"],
	responsible: GraphQLTypes["ResponsiblePartner"],
	permission: GraphQLTypes["Permission"],
	sfplus: GraphQLTypes["Sfplus"],
	blocklist?: GraphQLTypes["PartnerBlocklist"] | undefined,
	registration_type: string
};
	["PartnerBlocklist"]: {
	__typename: "PartnerBlocklist",
	is_blocked: boolean,
	nature?: string | undefined,
	title?: string | undefined,
	description?: string | undefined,
	action?: string | undefined
};
	["CorePartner"]: {
	__typename: "CorePartner",
	id: number,
	cnpj?: string | undefined,
	responsible?: GraphQLTypes["CoreParterResponsible"] | undefined,
	company_name: string,
	fantasy_name: string,
	status: Array<GraphQLTypes["CoreParterStatus"] | undefined>
};
	["CoreParterResponsible"]: {
	__typename: "CoreParterResponsible",
	id?: number | undefined,
	full_name?: string | undefined
};
	["CoreParterStatus"]: {
	__typename: "CoreParterStatus",
	active?: boolean | undefined,
	reason?: string | undefined,
	date?: string | undefined
};
	["CoreGetPartnersInput"]: {
		page?: number | undefined,
	search_term?: string | undefined
};
	["PaymentCurrentIssuanceModel"]: {
	__typename: "PaymentCurrentIssuanceModel",
	payout_options: Array<string>,
	best_payout_option: string
};
	["ProjectProposal"]: {
	__typename: "ProjectProposal",
	value_changed?: boolean | undefined
};
	["ProjectPersonType"]: ProjectPersonType;
	["ProjectSystemType"]: ProjectSystemType;
	["AppliedModifierOption"]: {
	__typename: "AppliedModifierOption",
	type: string,
	value: string
};
	["AppliedModifier"]: {
	__typename: "AppliedModifier",
	name: string,
	type: string,
	options: Array<GraphQLTypes["AppliedModifierOption"]>
};
	["AddonProduct"]: {
	__typename: "AddonProduct",
	id: string,
	product_name: string,
	product_external_id: string,
	simulation_id: string,
	type: string,
	product_slug: string,
	applied: boolean,
	partner_commission: number,
	installment_price: number,
	total_price: number,
	monthly_interest_rate?: number | undefined,
	engine_simulation_id: string,
	previous_engine_simulation_id: string,
	cet?: number | undefined,
	applied_modifiers: Array<GraphQLTypes["AppliedModifier"]>,
	addon_type?: string | undefined
};
	["SelectedInstallments"]: {
	__typename: "SelectedInstallments",
	cet: string,
	iof: number,
	ipca: string,
	addons: Array<GraphQLTypes["AddonProduct"]>,
	aggregated_addons: Array<GraphQLTypes["AddonProduct"]>,
	user_id: number,
	document: string,
	is_combo: boolean,
	commission: number,
	partner_id: number,
	aliquot_iof: number,
	new_journey: boolean,
	person_type: string,
	down_payment: number,
	due_day?: number | undefined,
	first_due_date?: string | undefined,
	grace_period: number,
	installments: number,
	project_name: string,
	system_power: number,
	interest_rate: number,
	cet_percentage: number,
	commission_raw: number,
	financing_value: number,
	taxa_de_cadastro?: number | undefined,
	taxa_de_juros?: number | undefined,
	installment_value: number,
	is_from_suggested: boolean,
	registration_fee_gross: number,
	registration_fee_raw_dry: number,
	registration_fee_raw_final: number,
	is_combo_connect?: boolean | undefined
};
	["RiskInfo"]: {
	__typename: "RiskInfo",
	title: string,
	description: string,
	todo: string,
	reason?: string | undefined,
	decision: number
};
	["BNPL"]: {
	__typename: "BNPL",
	decision_pre_analysis: number,
	min_entry_value: number,
	max_installments: number,
	pre_approved_value: number,
	status?: string | undefined
};
	["Guarantor"]: {
	__typename: "Guarantor",
	id?: string | undefined,
	document?: string | undefined,
	birth_date?: string | undefined,
	border_line?: boolean | undefined,
	created_at?: string | undefined,
	customer_second_financing_policy?: boolean | undefined,
	decision_pre_analysis?: number | undefined,
	max_approved_project_value?: number | undefined,
	max_financing_value?: number | undefined,
	max_grace_period?: number | undefined,
	max_installments?: number | undefined,
	min_approved_project_value?: number | undefined,
	min_installment_value?: number | undefined,
	pre_approved_value?: number | undefined,
	project_name?: string | undefined,
	project_state?: string | undefined,
	risk_class?: string | undefined,
	status?: string | undefined
};
	["InstallmentsConditions"]: {
	__typename: "InstallmentsConditions",
	suggested_installments?: number | undefined,
	suggested_installments_value?: number | undefined
};
	["Project"]: {
	__typename: "Project",
	id: string,
	user_id: number,
	partner_id: number,
	person_type: string,
	document: string,
	created_at: string,
	representative_document?: string | undefined,
	project_value: number,
	system_power?: number | undefined,
	system_type: string,
	grace_period: number,
	down_payment: number,
	status: string,
	project_status: string,
	min_installments?: number | undefined,
	max_installments: number,
	max_grace_period: number,
	project_name: string,
	project_state: string,
	partner_profile: string,
	pre_approved_value: number,
	products_applieds?: string | undefined,
	installments?: string | undefined,
	risk_info?: GraphQLTypes["RiskInfo"] | undefined,
	state_registration?: string | undefined,
	complete: boolean,
	selected_installments?: GraphQLTypes["SelectedInstallments"] | undefined,
	guarantor?: GraphQLTypes["Guarantor"] | undefined,
	birth_date: string,
	decision_pre_analysis: number,
	score_sol_facil: number,
	simulation_id?: string | undefined,
	addons: Array<GraphQLTypes["AddonProduct"]>,
	max_approved_project_value: number,
	min_approved_project_value: number,
	max_financing_value: number,
	border_line: boolean,
	is_formalized: boolean,
	new_journey: boolean,
	formalized_at?: string | undefined,
	shopping_cart_id?: string | undefined,
	bnpl?: GraphQLTypes["BNPL"] | undefined,
	bnpl_simulation_id?: string | undefined,
	bnpl_status?: string | undefined,
	is_onflex_partner: boolean,
	is_turbo_prime?: boolean | undefined,
	can_select_ampera: boolean,
	has_energy_bill_analysis: boolean,
	insurance_commission?: number | undefined,
	gained_points?: number | undefined,
	original_installment_value?: number | undefined,
	is_contract_signed?: boolean | undefined,
	commission?: number | undefined,
	risk_class?: string | undefined,
	selected_installment?: number | undefined,
	credit_analysis_status?: string | undefined,
	bill_value: number,
	installments_conditions?: GraphQLTypes["InstallmentsConditions"] | undefined
};
	["ProjectProposalUpdatePayloadInput"]: {
		engine_simulation_id: string,
	simulation_id: string,
	is_combo: boolean,
	is_ampera: boolean,
	commission: number,
	applied_addons: Array<string>
};
	["ProjectProposalUpdateResponse"]: {
	__typename: "ProjectProposalUpdateResponse",
	engine_simulation_id: string,
	simulation_id: string,
	project_id: string,
	is_combo: boolean,
	is_ampera: boolean,
	commission: number,
	applied_addons: Array<string>
};
	["IsComboResponse"]: {
	__typename: "IsComboResponse",
	data?: boolean | undefined
};
	["ProjectCreateInput"]: {
		person_type: GraphQLTypes["ProjectPersonType"],
	project_name?: string | undefined,
	document: string,
	project_value: number,
	down_payment: number,
	partner_id: number,
	user_id: number,
	representative_document?: string | undefined,
	system_power: number,
	new_journey: boolean,
	shopping_cart_id?: string | undefined,
	provider: string,
	bill_value: number,
	system_type: GraphQLTypes["ProjectSystemType"],
	engine_pricing?: string | undefined
};
	["ProjectCreateStatus"]: ProjectCreateStatus;
	["ProjectCreateResponse"]: {
	__typename: "ProjectCreateResponse",
	status: GraphQLTypes["ProjectCreateStatus"],
	id?: string | undefined
};
	["PartnerOverviewAll"]: {
	__typename: "PartnerOverviewAll",
	total?: number | undefined,
	in_progress?: number | undefined,
	in_reassassement?: number | undefined,
	finish?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewSimulation"]: {
	__typename: "PartnerOverviewSimulation",
	total?: number | undefined,
	approved?: number | undefined,
	reassassement?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewProposal"]: {
	__typename: "PartnerOverviewProposal",
	total?: number | undefined,
	in_equipments?: number | undefined,
	in_customer_data?: number | undefined,
	in_biometry_and_contract?: number | undefined,
	in_payment_model?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverviewInstallation"]: {
	__typename: "PartnerOverviewInstallation",
	total?: number | undefined,
	in_progress?: number | undefined,
	canceled?: number | undefined,
	expired?: number | undefined
};
	["PartnerOverview"]: {
	__typename: "PartnerOverview",
	partner_id?: number | undefined,
	all?: GraphQLTypes["PartnerOverviewAll"] | undefined,
	simulation?: GraphQLTypes["PartnerOverviewSimulation"] | undefined,
	proposal?: GraphQLTypes["PartnerOverviewProposal"] | undefined,
	installation?: GraphQLTypes["PartnerOverviewInstallation"] | undefined,
	status: string,
	last_updated_at?: string | undefined,
	next_update_at?: string | undefined
};
	["RegistrationPersonType"]: RegistrationPersonType;
	["RegistrationDocumentTypes"]: RegistrationDocumentTypes;
	["RegistrationRepresentantTypes"]: RegistrationRepresentantTypes;
	["RegistrationContact"]: {
	__typename: "RegistrationContact",
	email: string,
	phone: string
};
	["RegistrationAddressCity"]: {
	__typename: "RegistrationAddressCity",
	id: number,
	name: string
};
	["RegistrationAddressState"]: {
	__typename: "RegistrationAddressState",
	id: number,
	name: string
};
	["RegistrationDocumentModel"]: RegistrationDocumentModel;
	["RegistrationElectricityBill"]: {
	__typename: "RegistrationElectricityBill",
	holder_cpf: string,
	is_under_customer_name: boolean,
	distributor_id?: number | undefined,
	inverters_power_above_limit?: boolean | undefined
};
	["RegistrationElectricityBillWithDocuments"]: {
	__typename: "RegistrationElectricityBillWithDocuments",
	id: string,
	holder_cpf?: string | undefined,
	is_under_customer_name: boolean,
	documents: Array<GraphQLTypes["RegistrationDocument"]>
};
	["RegistrationDocument"]: {
	__typename: "RegistrationDocument",
	type: GraphQLTypes["RegistrationDocumentTypes"],
	status: string,
	filename: string,
	url_download: string,
	url_preview: string,
	mime_type: string,
	docstorage_id: string,
	id: string
};
	["RegistrationAddress"]: {
	__typename: "RegistrationAddress",
	zipcode?: string | undefined,
	street?: string | undefined,
	street_number?: string | undefined,
	complement?: string | undefined,
	neighborhood?: string | undefined,
	city_id?: number | undefined,
	state_id?: number | undefined,
	city?: GraphQLTypes["RegistrationAddressCity"] | undefined,
	state?: GraphQLTypes["RegistrationAddressState"] | undefined,
	is_rural?: boolean | undefined
};
	["RegistrationProject"]: {
	__typename: "RegistrationProject",
	address?: GraphQLTypes["RegistrationAddress"] | undefined,
	documents?: Array<GraphQLTypes["RegistrationDocument"] | undefined> | undefined,
	electricity_bill?: GraphQLTypes["RegistrationElectricityBill"] | undefined,
	residencial_is_the_same_of_plant?: boolean | undefined,
	comment?: string | undefined
};
	["RegistrationCustomer"]: {
	__typename: "RegistrationCustomer",
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["RegistrationContact"] | undefined,
	documents: Array<GraphQLTypes["RegistrationDocument"]>,
	document_type?: GraphQLTypes["RegistrationDocumentModel"] | undefined,
	address?: GraphQLTypes["RegistrationAddress"] | undefined
};
	["RegistrationCompany"]: {
	__typename: "RegistrationCompany",
	company_name: string,
	cnpj: string,
	contact?: GraphQLTypes["RegistrationContact"] | undefined,
	documents: Array<GraphQLTypes["RegistrationDocument"]>,
	majority_partner: GraphQLTypes["RegistrationCompanyMajorityPartner"],
	legal_representatives: Array<GraphQLTypes["RegistrationLegalRepresentative"]>,
	majority_partner_is_legal_representative?: boolean | undefined,
	is_only_one_legal_representative?: boolean | undefined
};
	["RegistrationLegalRepresentative"]: {
	__typename: "RegistrationLegalRepresentative",
	cpf: string,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["RegistrationContact"] | undefined,
	documents: Array<GraphQLTypes["RegistrationDocument"]>,
	address?: GraphQLTypes["RegistrationAddress"] | undefined,
	kind: GraphQLTypes["RegistrationRepresentantTypes"],
	document_type?: GraphQLTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationCompanyMajorityPartner"]: {
	__typename: "RegistrationCompanyMajorityPartner",
	cpf: string,
	is_legal_representative?: boolean | undefined,
	full_name?: string | undefined,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["RegistrationContact"] | undefined,
	documents: Array<GraphQLTypes["RegistrationDocument"]>,
	address?: GraphQLTypes["RegistrationAddress"] | undefined,
	document_type?: GraphQLTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationGuarantor"]: {
	__typename: "RegistrationGuarantor",
	cpf: string,
	full_name: string,
	birthdate?: string | undefined,
	contact?: GraphQLTypes["RegistrationContact"] | undefined,
	documents: Array<GraphQLTypes["RegistrationDocument"]>,
	address?: GraphQLTypes["RegistrationAddress"] | undefined,
	document_type?: GraphQLTypes["RegistrationDocumentModel"] | undefined
};
	["RegistrationError"]: {
	__typename: "RegistrationError",
	title?: string | undefined,
	description: string,
	field: string,
	type?: string | undefined
};
	["RegistrationUpdateInput"]: {
		project_id: string
};
	["RegistrationDetailsResponse"]: {
	__typename: "RegistrationDetailsResponse",
	project_id: string,
	status: string,
	is_combo: boolean,
	remaining_changes_after_confirmation?: number | undefined,
	person_type: GraphQLTypes["RegistrationPersonType"],
	customer?: GraphQLTypes["RegistrationCustomer"] | undefined,
	company?: GraphQLTypes["RegistrationCompany"] | undefined,
	guarantor?: GraphQLTypes["RegistrationGuarantor"] | undefined,
	project?: GraphQLTypes["RegistrationProject"] | undefined,
	errors: Array<GraphQLTypes["RegistrationError"]>,
	electricity_bills?: Array<GraphQLTypes["RegistrationElectricityBillWithDocuments"]> | undefined,
	has_other_beneficiary_units: boolean
};
	/** Display mode of the grid access approval (parecer de acesso) field for the installation site.
HIDDEN: the field is not shown. SHOW: the field is optional. SHOW_REQUIRED: the field is required. */
["GridAccessApprovalDisplayMode"]: GridAccessApprovalDisplayMode;
	["RegistrationGridAccessApproval"]: {
	__typename: "RegistrationGridAccessApproval",
	display_mode: GraphQLTypes["GridAccessApprovalDisplayMode"]
};
	["RevalidationStatus"]: RevalidationStatus;
	["AttemptStatus"]: AttemptStatus;
	["RevalidationStatusCount"]: {
	__typename: "RevalidationStatusCount",
	status: string,
	count: number
};
	["RevalidationBrandSummary"]: {
	__typename: "RevalidationBrandSummary",
	brand: string,
	total: number,
	statuses: Array<GraphQLTypes["RevalidationStatusCount"]>
};
	["RevalidationSummary"]: {
	__typename: "RevalidationSummary",
	total: number,
	statuses: Array<GraphQLTypes["RevalidationStatusCount"]>,
	brands: Array<GraphQLTypes["RevalidationBrandSummary"]>
};
	["LatestSubmission"]: {
	__typename: "LatestSubmission",
	serial_number: string,
	attempt_status: GraphQLTypes["AttemptStatus"]
};
	["LatestAttempt"]: {
	__typename: "LatestAttempt",
	serial_number: string,
	attempt_status: GraphQLTypes["AttemptStatus"],
	brand: string,
	submitted_at: string,
	processed_at?: string | undefined,
	reason_code?: string | undefined
};
	["RevalidationItem"]: {
	__typename: "RevalidationItem",
	revalidation_id: string,
	status: GraphQLTypes["RevalidationStatus"],
	project_name?: string | undefined,
	plant_name?: string | undefined,
	reference_inverter_brand?: string | undefined,
	expected_total_inverters: number,
	latest_submission: Array<GraphQLTypes["LatestSubmission"]>,
	latest_attempts: Array<GraphQLTypes["LatestAttempt"]>
};
	["RevalidationPagination"]: {
	__typename: "RevalidationPagination",
	page: number,
	page_size: number,
	total_items: number,
	total_pages: number
};
	["RevalidationsListResponse"]: {
	__typename: "RevalidationsListResponse",
	items: Array<GraphQLTypes["RevalidationItem"]>,
	pagination: GraphQLTypes["RevalidationPagination"]
};
	["RevalidationsInput"]: {
		status?: Array<GraphQLTypes["RevalidationStatus"]> | undefined,
	brand?: string | undefined,
	sort?: string | undefined,
	page?: number | undefined,
	page_size?: number | undefined
};
	["RegisterRevalidationCredentialInput"]: {
		brand: string,
	username: string,
	password: string
};
	["RegisterRevalidationCredentialErrorCode"]: RegisterRevalidationCredentialErrorCode;
	["RegisterRevalidationCredentialResponse"]: {
	__typename: "RegisterRevalidationCredentialResponse",
	success: boolean,
	message?: GraphQLTypes["RegisterRevalidationCredentialErrorCode"] | undefined
};
	["RevalidationSubmissionDeviceInput"]: {
		brand: string,
	serial_number: string
};
	["RevalidationSubmissionInput"]: {
		revalidation_id: string,
	monitoring_plant_name: string,
	devices: Array<GraphQLTypes["RevalidationSubmissionDeviceInput"]>
};
	["SubmitRevalidationsInput"]: {
		platform_access_token: string,
	submissions: Array<GraphQLTypes["RevalidationSubmissionInput"]>
};
	["RevalidationSubmissionAccepted"]: {
	__typename: "RevalidationSubmissionAccepted",
	revalidation_id: string,
	submission_number: number,
	total_devices: number,
	revalidation_status: GraphQLTypes["RevalidationStatus"]
};
	["RevalidationSubmissionError"]: {
	__typename: "RevalidationSubmissionError",
	code: string,
	detail: string
};
	["RevalidationSubmissionDevice"]: {
	__typename: "RevalidationSubmissionDevice",
	brand: string,
	serial_number: string
};
	["RevalidationSubmissionRejected"]: {
	__typename: "RevalidationSubmissionRejected",
	revalidation_id: string,
	errors: Array<GraphQLTypes["RevalidationSubmissionError"]>,
	devices: Array<GraphQLTypes["RevalidationSubmissionDevice"]>
};
	["RevalidationSubmissionReferenceBrandUpdated"]: {
	__typename: "RevalidationSubmissionReferenceBrandUpdated",
	revalidation_id: string,
	reference_inverter_brand: string,
	revalidation_status: GraphQLTypes["RevalidationStatus"]
};
	["RevalidationSubmissionsData"]: {
	__typename: "RevalidationSubmissionsData",
	accepted: Array<GraphQLTypes["RevalidationSubmissionAccepted"]>,
	rejected: Array<GraphQLTypes["RevalidationSubmissionRejected"]>,
	reference_brand_updated: Array<GraphQLTypes["RevalidationSubmissionReferenceBrandUpdated"]>
};
	["SubmitRevalidationsResponse"]: {
	__typename: "SubmitRevalidationsResponse",
	success: boolean,
	message: string,
	data: GraphQLTypes["RevalidationSubmissionsData"]
};
	["AnalyzeEnergyBillInput"]: {
		person_type: string,
	project_id: string,
	document_customer: string,
	financing_id: number,
	document_owner_energy_bill: string,
	auto_cancel_flow_on_rejection: boolean
};
	["GetOpportunitiesInput"]: {
		financing_value: number,
	partner_id: number,
	project_type: string
};
	["EnergyBillAnalysisDecision"]: {
	__typename: "EnergyBillAnalysisDecision",
	decision: string,
	details?: string | undefined
};
	["GetOpportunitiesResponse"]: {
	__typename: "GetOpportunitiesResponse",
	addons_opportunities: Array<GraphQLTypes["AddonsOpportunities"]>,
	financing_gained_points?: number | undefined
};
	["AddonsOpportunities"]: {
	__typename: "AddonsOpportunities",
	addon_type?: string | undefined,
	gained_points?: number | undefined,
	product_slug?: string | undefined
};
	["LevelBlackStatus"]: {
	__typename: "LevelBlackStatus",
	kwGoalMonth: number,
	kwReachedMonth: number
};
	["Contact"]: {
	__typename: "Contact",
	landline?: string | undefined,
	mobile: string,
	email: string
};
	["Responsible"]: {
	__typename: "Responsible",
	id: number,
	username?: string | undefined,
	profile: string,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	created_at: string,
	contact: GraphQLTypes["Contact"],
	partner?: GraphQLTypes["Partner"] | undefined
};
	["Score"]: {
	__typename: "Score",
	current: number,
	goal: number
};
	["Downgrade"]: {
	__typename: "Downgrade",
	has_risk: boolean
};
	["Partner"]: {
	__typename: "Partner",
	id: number,
	corporate_name: string,
	operation_term_accepted: boolean,
	trade_name: string,
	document: string,
	category?: string | undefined,
	state_registration: string,
	active: boolean,
	created_at: string,
	address: GraphQLTypes["Address"],
	responsible: GraphQLTypes["Responsible"],
	permission: GraphQLTypes["Permission"],
	users?: Array<GraphQLTypes["User"] | undefined> | undefined,
	sfplus?: GraphQLTypes["Sfplus"] | undefined
};
	["Post"]: {
	__typename: "Post",
	id: number,
	title: string,
	body: string,
	userId: string,
	comments?: Array<GraphQLTypes["Comment"] | undefined> | undefined
};
	["Comment"]: {
	__typename: "Comment",
	id: number,
	name: string,
	email: string,
	body: string
};
	["OperatingAgreement"]: {
	__typename: "OperatingAgreement",
	is_current_term_accepted: boolean,
	can_accept: boolean
};
	["UserTerms"]: {
	__typename: "UserTerms",
	operating_agreement: GraphQLTypes["OperatingAgreement"]
};
	["User"]: {
	__typename: "User",
	id: number,
	username?: string | undefined,
	profile?: string | undefined,
	fullname: string,
	document?: string | undefined,
	birthdate?: string | undefined,
	active: boolean,
	created_at: string,
	contact: GraphQLTypes["Contact"],
	partner?: GraphQLTypes["Partner"] | undefined,
	posts?: Array<GraphQLTypes["Post"] | undefined> | undefined,
	terms?: GraphQLTypes["UserTerms"] | undefined
};
	/** Estados que o portal NAO tem como deduzir — o backend manda, o portal traduz.

WalletPaymentModelSummary.state   ENABLED | MODEL_DISABLED | NOVICE | ESSENTIAL_PROFILE
                                  | COMMERCIAL_EXCEPTION | BLOCKED
WalletPaymentModelCard.state      ENABLED | DEFAULT | LOCKED | DISABLED | BLOCKED | WAIVED */
["WalletPaymentModelSummary"]: {
	__typename: "WalletPaymentModelSummary",
	/** Qual das 7 variantes do card do Resumo renderizar (Figma: MR overview card). */
	state: string,
	/** null quando state = BLOCKED — o corpo do card vira empty state. */
	current_model?: string | undefined,
	upfront_percentage: number,
	after_completion_percentage: number,
	/** Vem calculado do backend (que repassa o lambda). O portal NAO divide
on_time_completed/total_completed em lugar nenhum.
null quando state = NOVICE ou ESSENTIAL_PROFILE: o Figma tira o bloco de desempenho. */
	performance_percentage?: number | undefined,
	/** Qual modelo foi desabilitado apesar do desempenho. So com state = MODEL_DISABLED. */
	disabled_model?: string | undefined,
	/** Motivo, para 'O Modelo A foi desabilitado · Motivo: inadimplência da carteira em alerta'. */
	disabled_reason?: string | undefined,
	/** O '3' de '3 de 5 realizadas'. So com state = NOVICE. */
	novice_completed?: number | undefined,
	total_completed: number,
	on_time_completed: number,
	next_model?: string | undefined,
	projects_needed_for_next_model?: number | undefined,
	is_blocked: boolean,
	block_reason?: string | undefined,
	updated_at: string
};
	["WalletPaymentModelCard"]: {
	__typename: "WalletPaymentModelCard",
	key: string,
	upfront_percentage: number,
	after_completion_percentage: number,
	min_on_time_percentage?: number | undefined,
	is_current: boolean,
	/** Substitui is_default e is_unlocked:
  LOCKED   — elegivel, ainda nao alcancou
  DISABLED — alcancou, mas um requisito entrou em alerta/critico
  BLOCKED  — conta bloqueada por fraude, atraso critico ou saude do CNPJ
Mais ENABLED, DEFAULT (so o C) e WAIVED (flexibilizacao comercial). */
	state: string,
	requirements: Array<GraphQLTypes["WalletModelRequirement"]>
};
	["WalletModelRequirement"]: {
	__typename: "WalletModelRequirement",
	code: string,
	/** O que varia por parceiro. O portal nunca deduz isto comparando percentuais. */
	is_met: boolean,
	/** true = o portal RISCA o texto da linha (flexibilizacao comercial ativa). */
	is_waived: boolean
};
	["WalletDefaultModelCondition"]: {
	__typename: "WalletDefaultModelCondition",
	code: string,
	value?: number | undefined
};
	["WalletPaymentPerformance"]: {
	__typename: "WalletPaymentPerformance",
	total_completed: number,
	on_time_completed: number,
	late_completed: number,
	/** Vem calculado do backend. O portal nao divide os contadores. */
	on_time_percentage: number,
	thresholds: GraphQLTypes["WalletPerformanceThresholds"],
	challenge?: GraphQLTypes["WalletPerformanceChallenge"] | undefined,
	by_kit_type: Array<GraphQLTypes["WalletPerformanceByKitType"]>
};
	["WalletPerformanceThresholds"]: {
	__typename: "WalletPerformanceThresholds",
	model_b: number,
	model_a: number
};
	["WalletPerformanceChallenge"]: {
	__typename: "WalletPerformanceChallenge",
	target_model?: string | undefined,
	projects_needed?: number | undefined
};
	["WalletPerformanceByKitType"]: {
	__typename: "WalletPerformanceByKitType",
	kit_type: string,
	on_time_count: number,
	late_count: number,
	projects_filter?: GraphQLTypes["WalletProjectsFilter"] | undefined
};
	["WalletProjectsFilter"]: {
	__typename: "WalletProjectsFilter",
	kit_type?: string | undefined,
	status?: string | undefined
};
	["WalletCommercialException"]: {
	__typename: "WalletCommercialException",
	is_active: boolean
};
	["WalletEligibilityContext"]: {
	__typename: "WalletEligibilityContext",
	partner_profile: string,
	is_novice: boolean,
	novice_completed: number,
	novice_required: number,
	performance_model: string,
	delinquency_status?: string | undefined,
	commercial_exception?: GraphQLTypes["WalletCommercialException"] | undefined
};
	["WalletPaymentModel"]: {
	__typename: "WalletPaymentModel",
	summary: GraphQLTypes["WalletPaymentModelSummary"],
	models?: Array<GraphQLTypes["WalletPaymentModelCard"]> | undefined,
	default_model_conditions?: Array<GraphQLTypes["WalletDefaultModelCondition"]> | undefined,
	performance?: GraphQLTypes["WalletPaymentPerformance"] | undefined,
	eligibility_context?: GraphQLTypes["WalletEligibilityContext"] | undefined
}
    }
export const enum Order {
	asc = "asc",
	desc = "desc"
}
export const enum PersonTypes {
	pf = "pf",
	pj = "pj",
	pr = "pr"
}
export const enum DocumentTypes {
	driver_license_front = "driver_license_front",
	driver_license_back = "driver_license_back",
	digital_driver_license = "digital_driver_license",
	identity_document_front = "identity_document_front",
	identity_document_back = "identity_document_back",
	employment_proof = "employment_proof",
	electricity_bill = "electricity_bill",
	additional = "additional",
	company_official_document = "company_official_document",
	grid_access_approval = "grid_access_approval"
}
export const enum LegalRepresentantTypes {
	legal_representative_1 = "legal_representative_1",
	legal_representative_2 = "legal_representative_2",
	majority_partner = "majority_partner"
}
export const enum CustomerStatus {
	in_progress = "in_progress",
	under_analysis = "under_analysis",
	approved = "approved",
	reproved = "reproved",
	to_review = "to_review"
}
export const enum RegistrationV2PersonType {
	pf = "pf",
	pj = "pj"
}
export const enum DeviceOrchestratorGatewayCredentialErrorCode {
	VALIDATION_ERROR = "VALIDATION_ERROR",
	CREDENTIAL_MISMATCH = "CREDENTIAL_MISMATCH",
	CREDENTIAL_ALREADY_EXISTS = "CREDENTIAL_ALREADY_EXISTS",
	END_CUSTOMER_CREDENTIAL = "END_CUSTOMER_CREDENTIAL",
	TECHNICAL_FAILURE = "TECHNICAL_FAILURE"
}
export const enum PersonType {
	PF = "PF",
	PJ = "PJ",
	PR = "PR"
}
export const enum FinancingStatus {
	expired = "expired",
	reproved = "reproved",
	approved = "approved",
	under_analysis = "under_analysis",
	canceled = "canceled",
	in_progress = "in_progress",
	waiting_customer = "waiting_customer",
	to_review = "to_review"
}
export const enum FinancingSteps {
	simulation = "simulation",
	installation = "installation",
	biometry_and_contract = "biometry_and_contract",
	customer_data = "customer_data",
	equipment = "equipment",
	payment_model = "payment_model"
}
export const enum StatusList {
	approved = "approved",
	canceled = "canceled",
	waiting_customer = "waiting_customer",
	under_analysis = "under_analysis",
	expired = "expired",
	cancelled = "cancelled",
	to_review = "to_review",
	reproved = "reproved",
	in_progress = "in_progress"
}
export const enum FileStatusType {
	error = "error",
	processing = "processing",
	success = "success",
	waiting = "waiting"
}
export const enum DocumentStatusType {
	approved = "approved",
	pending = "pending",
	reproved = "reproved"
}
export const enum TypeSection {
	ampera = "ampera",
	datalogger_label = "datalogger_label",
	installation = "installation",
	inverters = "inverters",
	inverter_label = "inverter_label",
	battery_label = "battery_label"
}
export const enum MirrorStatuses {
	approved = "approved",
	reproved = "reproved",
	pending = "pending"
}
export const enum BiometricValidationStatus {
	blocked = "blocked",
	sent = "sent"
}
export const enum BiometricValidationReason {
	daily_quota_reached = "daily_quota_reached",
	rate_limit = "rate_limit",
	success = "success"
}
export const enum InstalledInverterGlobalStatus {
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED_WITH_VALID_DATA = "COMPLETED_WITH_VALID_DATA",
	COMPLETED_WITH_INVALID_DATA = "COMPLETED_WITH_INVALID_DATA"
}
export const enum InstalledInverterStatus {
	WAITING_EXTRACTION_RESPONSE = "WAITING_EXTRACTION_RESPONSE",
	INVERTER_DATA_EXTRACTION_FAILED = "INVERTER_DATA_EXTRACTION_FAILED",
	DUPLICATE_SERIAL_NUMBER = "DUPLICATE_SERIAL_NUMBER",
	WAITING_PARTNER_CONFIRMATION = "WAITING_PARTNER_CONFIRMATION",
	WAITING_GENERATION_CHECK = "WAITING_GENERATION_CHECK",
	GENERATION_CHECK_ERROR = "GENERATION_CHECK_ERROR",
	GENERATION_CHECK_FINISHED = "GENERATION_CHECK_FINISHED",
	GENERATION_CHECK_BYPASSED = "GENERATION_CHECK_BYPASSED",
	WAITING_CUSTOMER_CONFIRMATION = "WAITING_CUSTOMER_CONFIRMATION",
	REJECTED_BY_CUSTOMER = "REJECTED_BY_CUSTOMER",
	APPROVED = "APPROVED"
}
export const enum CommissioningCheckStatus {
	COMMISSIONED_AND_POWER_OK = "COMMISSIONED_AND_POWER_OK",
	NO_ENERGY_PRODUCED = "NO_ENERGY_PRODUCED",
	POWER_MISMATCH = "POWER_MISMATCH",
	SERIAL_NUMBER_NOT_FOUND = "SERIAL_NUMBER_NOT_FOUND",
	TECHNICAL_FAILURE = "TECHNICAL_FAILURE",
	CREDENTIAL_NOT_FOUND = "CREDENTIAL_NOT_FOUND",
	CREDENTIAL_MISMATCH = "CREDENTIAL_MISMATCH"
}
export const enum CommissioningMonitoringStatus {
	WAITING_COMMISSIONING = "WAITING_COMMISSIONING",
	COMMISSIONED = "COMMISSIONED",
	COMMISSIONING_FAILED = "COMMISSIONING_FAILED",
	COMMISSIONING_BYPASSED = "COMMISSIONING_BYPASSED"
}
export const enum CommissioningFailureReason {
	CREDENTIALS_NOT_FOUND = "CREDENTIALS_NOT_FOUND",
	CREDENTIALS_MISMATCH = "CREDENTIALS_MISMATCH",
	END_CUSTOMER_CREDENTIAL = "END_CUSTOMER_CREDENTIAL",
	SERIAL_NUMBER_NOT_FOUND = "SERIAL_NUMBER_NOT_FOUND",
	INSTALLATION_NOT_FOUND = "INSTALLATION_NOT_FOUND",
	INVERTERS_NOT_FOUND = "INVERTERS_NOT_FOUND",
	PLANT_DATA_NOT_FOUND = "PLANT_DATA_NOT_FOUND",
	NO_ENERGY_PRODUCED = "NO_ENERGY_PRODUCED",
	POWER_MISMATCH = "POWER_MISMATCH",
	TECHNICAL_FAILURE = "TECHNICAL_FAILURE"
}
export const enum CommissioningInstallationStatus {
	APPROVED = "APPROVED",
	COMMISSIONING_FAILED = "COMMISSIONING_FAILED",
	COMMISSIONING_FINISHED = "COMMISSIONING_FINISHED",
	COMMISSIONING_IN_PROGRESS = "COMMISSIONING_IN_PROGRESS",
	REJECTED_BY_CUSTOMER = "REJECTED_BY_CUSTOMER",
	WAITING_CUSTOMER_CONFIRMATION = "WAITING_CUSTOMER_CONFIRMATION",
	WAITING_PARTNER_SUBMISSION = "WAITING_PARTNER_SUBMISSION"
}
export const enum ProjectPersonType {
	PF = "PF",
	PJ = "PJ"
}
export const enum ProjectSystemType {
	with_battery = "with_battery",
	without_battery = "without_battery",
	only_battery = "only_battery"
}
export const enum ProjectCreateStatus {
	SUCCESS = "SUCCESS",
	CREATING = "CREATING"
}
export const enum RegistrationPersonType {
	pf = "pf",
	pj = "pj",
	pr = "pr"
}
export const enum RegistrationDocumentTypes {
	driver_license_front = "driver_license_front",
	driver_license_back = "driver_license_back",
	digital_driver_license = "digital_driver_license",
	identity_document_front = "identity_document_front",
	identity_document_back = "identity_document_back",
	employment_proof = "employment_proof",
	electricity_bill = "electricity_bill",
	additional = "additional",
	company_official_document = "company_official_document",
	grid_access_approval = "grid_access_approval"
}
export const enum RegistrationRepresentantTypes {
	legal_representative_1 = "legal_representative_1",
	legal_representative_2 = "legal_representative_2",
	majority_partner = "majority_partner"
}
export const enum RegistrationDocumentModel {
	rg = "rg",
	cnh = "cnh",
	cnh_digital = "cnh_digital"
}
/** Display mode of the grid access approval (parecer de acesso) field for the installation site.
HIDDEN: the field is not shown. SHOW: the field is optional. SHOW_REQUIRED: the field is required. */
export const enum GridAccessApprovalDisplayMode {
	HIDDEN = "HIDDEN",
	SHOW = "SHOW",
	SHOW_REQUIRED = "SHOW_REQUIRED"
}
export const enum RevalidationStatus {
	PENDING_SUBMISSION = "PENDING_SUBMISSION",
	INVALID_DATA = "INVALID_DATA",
	WAITING_COMMISSIONING_RESULT = "WAITING_COMMISSIONING_RESULT",
	APPROVED = "APPROVED"
}
export const enum AttemptStatus {
	PENDING_PROCESSING = "PENDING_PROCESSING",
	PROCESSING = "PROCESSING",
	APPROVED = "APPROVED",
	INVALID_DATA = "INVALID_DATA",
	TECHNICAL_ERROR = "TECHNICAL_ERROR"
}
export const enum RegisterRevalidationCredentialErrorCode {
	VALIDATION_ERROR = "VALIDATION_ERROR",
	CREDENTIAL_MISMATCH = "CREDENTIAL_MISMATCH",
	CREDENTIAL_ALREADY_EXISTS = "CREDENTIAL_ALREADY_EXISTS",
	END_CUSTOMER_CREDENTIAL = "END_CUSTOMER_CREDENTIAL",
	TECHNICAL_FAILURE = "TECHNICAL_FAILURE"
}

type ZEUS_VARIABLES = {
	["Order"]: ValueTypes["Order"];
	["Upload"]: ValueTypes["Upload"];
	["PersonTypes"]: ValueTypes["PersonTypes"];
	["DocumentTypes"]: ValueTypes["DocumentTypes"];
	["LegalRepresentantTypes"]: ValueTypes["LegalRepresentantTypes"];
	["CustomerStatus"]: ValueTypes["CustomerStatus"];
	["RegistrationV2PersonType"]: ValueTypes["RegistrationV2PersonType"];
	["CustomerRegistrationAddress"]: ValueTypes["CustomerRegistrationAddress"];
	["CustomerRegistrationContact"]: ValueTypes["CustomerRegistrationContact"];
	["CustomerRegistrationDocument"]: ValueTypes["CustomerRegistrationDocument"];
	["CustomerRegistrationCustomer"]: ValueTypes["CustomerRegistrationCustomer"];
	["CustomerRegistrationGuarantor"]: ValueTypes["CustomerRegistrationGuarantor"];
	["CustomerRegistrationElectricityBill"]: ValueTypes["CustomerRegistrationElectricityBill"];
	["CustomerRegistrationElectricityBillWithDocuments"]: ValueTypes["CustomerRegistrationElectricityBillWithDocuments"];
	["CustomerRegistrationProject"]: ValueTypes["CustomerRegistrationProject"];
	["CustomerRegistrationCompany"]: ValueTypes["CustomerRegistrationCompany"];
	["CustomerRegistrationLegalRepresentative"]: ValueTypes["CustomerRegistrationLegalRepresentative"];
	["CustomerRegistrationInput"]: ValueTypes["CustomerRegistrationInput"];
	["Person"]: ValueTypes["Person"];
	["PersonInput"]: ValueTypes["PersonInput"];
	["RegistrationContactChangeInput"]: ValueTypes["RegistrationContactChangeInput"];
	["JSON"]: ValueTypes["JSON"];
	["DeviceOrchestratorGatewayCredentialErrorCode"]: ValueTypes["DeviceOrchestratorGatewayCredentialErrorCode"];
	["RegisterDeviceOrchestratorGatewayCredentialInput"]: ValueTypes["RegisterDeviceOrchestratorGatewayCredentialInput"];
	["PersonType"]: ValueTypes["PersonType"];
	["FinancingStatus"]: ValueTypes["FinancingStatus"];
	["FinancingSteps"]: ValueTypes["FinancingSteps"];
	["StatusList"]: ValueTypes["StatusList"];
	["FinancingsInput"]: ValueTypes["FinancingsInput"];
	["FileStatusType"]: ValueTypes["FileStatusType"];
	["DocumentStatusType"]: ValueTypes["DocumentStatusType"];
	["TypeSection"]: ValueTypes["TypeSection"];
	["MirrorStatuses"]: ValueTypes["MirrorStatuses"];
	["HardwareFormInverter"]: ValueTypes["HardwareFormInverter"];
	["HardwareFormModule"]: ValueTypes["HardwareFormModule"];
	["HardwareFormComboEquipment"]: ValueTypes["HardwareFormComboEquipment"];
	["HardwareFormBatteries"]: ValueTypes["HardwareFormBatteries"];
	["HardwareFormComboMetadata"]: ValueTypes["HardwareFormComboMetadata"];
	["HardwareFormInput"]: ValueTypes["HardwareFormInput"];
	["HardwareFormShowcaseInput"]: ValueTypes["HardwareFormShowcaseInput"];
	["ValidateTotalInvertersPowerInput"]: ValueTypes["ValidateTotalInvertersPowerInput"];
	["CustomerReprovalInput"]: ValueTypes["CustomerReprovalInput"];
	["BiometricValidationInput"]: ValueTypes["BiometricValidationInput"];
	["BiometricValidationStatus"]: ValueTypes["BiometricValidationStatus"];
	["BiometricValidationReason"]: ValueTypes["BiometricValidationReason"];
	["HardwareDraftEquipment"]: ValueTypes["HardwareDraftEquipment"];
	["HardwareDraft"]: ValueTypes["HardwareDraft"];
	["CreateInstalledInverterInput"]: ValueTypes["CreateInstalledInverterInput"];
	["CreateInstalledInverterWithBrandInput"]: ValueTypes["CreateInstalledInverterWithBrandInput"];
	["InstalledInverterGlobalStatus"]: ValueTypes["InstalledInverterGlobalStatus"];
	["InstalledInverterStatus"]: ValueTypes["InstalledInverterStatus"];
	["CommissioningCheckStatus"]: ValueTypes["CommissioningCheckStatus"];
	["CommissioningMonitoringStatus"]: ValueTypes["CommissioningMonitoringStatus"];
	["CommissioningFailureReason"]: ValueTypes["CommissioningFailureReason"];
	["MonitoringInput"]: ValueTypes["MonitoringInput"];
	["CommissioningRequestInput"]: ValueTypes["CommissioningRequestInput"];
	["CommissioningInstallationStatus"]: ValueTypes["CommissioningInstallationStatus"];
	["CoreGetPartnersInput"]: ValueTypes["CoreGetPartnersInput"];
	["ProjectPersonType"]: ValueTypes["ProjectPersonType"];
	["ProjectSystemType"]: ValueTypes["ProjectSystemType"];
	["ProjectProposalUpdatePayloadInput"]: ValueTypes["ProjectProposalUpdatePayloadInput"];
	["ProjectCreateInput"]: ValueTypes["ProjectCreateInput"];
	["ProjectCreateStatus"]: ValueTypes["ProjectCreateStatus"];
	["RegistrationPersonType"]: ValueTypes["RegistrationPersonType"];
	["RegistrationDocumentTypes"]: ValueTypes["RegistrationDocumentTypes"];
	["RegistrationRepresentantTypes"]: ValueTypes["RegistrationRepresentantTypes"];
	["RegistrationDocumentModel"]: ValueTypes["RegistrationDocumentModel"];
	["RegistrationUpdateInput"]: ValueTypes["RegistrationUpdateInput"];
	["GridAccessApprovalDisplayMode"]: ValueTypes["GridAccessApprovalDisplayMode"];
	["RevalidationStatus"]: ValueTypes["RevalidationStatus"];
	["AttemptStatus"]: ValueTypes["AttemptStatus"];
	["RevalidationsInput"]: ValueTypes["RevalidationsInput"];
	["RegisterRevalidationCredentialInput"]: ValueTypes["RegisterRevalidationCredentialInput"];
	["RegisterRevalidationCredentialErrorCode"]: ValueTypes["RegisterRevalidationCredentialErrorCode"];
	["RevalidationSubmissionDeviceInput"]: ValueTypes["RevalidationSubmissionDeviceInput"];
	["RevalidationSubmissionInput"]: ValueTypes["RevalidationSubmissionInput"];
	["SubmitRevalidationsInput"]: ValueTypes["SubmitRevalidationsInput"];
	["AnalyzeEnergyBillInput"]: ValueTypes["AnalyzeEnergyBillInput"];
	["GetOpportunitiesInput"]: ValueTypes["GetOpportunitiesInput"];
}